/* eslint-disable max-len */
export default {
    test: "Test!",
    brandName: "Aurachain",
    errorRequired: "Acest câmp este obligatoriu!",
    platformVersion: "Versiunea platformei:",
    oldValue: "valoare veche: ",
    generic: {
        bcApplications: "Aplicații",
        bcProcesses: "Procese",
        bcSettings: "Setări",
        bcGeneral: "Generic",
        bcGlobalFeatures: "Depozit de date",
        bcEntities: "Tabele de date",
        bcAdmin: "Setări administrative",
        bcApplicationSpecificGroups: "Grupuri specifice",
        bcWorkSchedule: "Program de lucru",
        bcPermissionsSet: "Permisiuni",
        bcArchiveProcess: "Procese arhivate",
        bcInterfaceBuilder: "Interfețe utilizator",
        bcDocumentBuilder: "Șabloane de documente",
        bcPerspectiveBuilder: "Vizualizări personalizate de date",
        bcSearchPerspectives: "Vizualizari de date",
        bcReports: "Analitice",
        bcProcessData: "Vizualizare date live",
        bcStatistics: "Statistici proces",
        bcBlockchain: "Contracte inteligente",
        bcAPIs: "Integrări",
        bcDataModel: "Modelul de date",
        bcCatalogs: "Cataloage",
        add: "Adăugați",
        modify: "Modificați",
        closePreview: "Close preview",
        update: "Actualizați",
        refresh: "Reîmprospătați",
        warning: "Avertizare!",
        cancel: "Anulați",
        errors: "Eroare!",
        test: "Testează",
        view: "Vizualizați",
        save: "Salvați",
        or: "sau",
        saveData: "Salvați datele",
        create: "Creează",
        createNew: "Creează",
        edit: "Editați",
        clear: "Ștergeți tot",
        clearSingle: "Ștergeți",
        done: "Finalizează",
        open: "Deschideți",
        confirm: "Confirmați",
        discardAndContinue: "Renunțați și continuați",
        yes: "Da",
        no: "Nu",
        leave: "Părăsiți",
        saved: "Salvat",
        apply: "Aplicați",
        information: "Informații",
        savedSuccessfully: "Salvat cu succes",
        saveUnsuccessful: "Salvarea nu a reușit",
        publishingErrorTitle: "Eroare la publicare",
        notFound: "Resursa cu numărul de identificare {id} nu a fost gasită",
        notFoundInterface: "Interfața utilizator nu a fost găsită",
        missingDoc: "Șablonul documentului lipsește",
        copy: "Text copiat",
        search: "Căutare",
        searchTables: "Căutare tabele",
        delete: "Ștergeți",
        filter: "Filtrați",
        noDataAvailable: "Nicio info. disponibilă",
        from: "Din",
        to: "La",
        name: "Nume",
        description: "Descriere",
        expand: "Extinde",
        collapse: "Restrange",
        copyURL: "Apăsați aici pentru a copia URL-ul",
        help: "Ajutor",
        abort: "Întrerupeți",
        continue: "Continuați",
        upload: "Încărcați",
        keep: "Păstrează",
        dataSearchPerspective: "Date",
        minimum: "Minimă",
        maximum: "Maximă",
        language: "Limbă",
        noData: "No classes or attributes to select."
    },
    mainPage: {
        sideBar: {
            smartcontract: "Contracte inteligente",
            apps: "Aplicații",
            settings: "Setări administrative",
            ui: "Interfețe utilizator",
            plm: "Diagrame",
            processes: "Procese",
            appSettings: "Setări",
            appGeneral: "Generic",
            plv: "Analitice",
            search: "Vizualizări de date",
            documents: "Șabloane de documente",
            dataModel: "Model de date",
            api: "Integrări",
            tasks: "Task-uri",
            workspace: "Spațiu de lucru",
            manageGroups: "Administrarea grupurilor",
            processInspector: "Inspector procese",
            selectWorkspace: "Selectați workspace-ul",
            globalFeatures: "Depozit de date",
            globalEntities: "Tabele de date",
            globalIntegration: "Conexiuni de date",
            perspectiveBuilder: "Vizualizări personalizate de date",
            branding: "Marcă"
        },
        lastSave: "Ultima oară salvat la ",
        lastPublishDate: "Data ultimei publicări: ",
        neverPublishTimestamp: "Niciodata",
        publish: "Publicați aplicația",
        publishButtonTooltip: "Publică structura tabelei de date",
        apply: "Aplicați",
        exclusiveGatewayError: "Exclusive gateway nu este configurat",
        save: "Salvați",
        saveAs: "Salvați ca",
        noProcessesTooltip: "Aplicația nu conține niciun proces",
        noPublishPermissionTooltip: "Ne pare rău, nu aveți drepturi de publicare",
        publishedState: "Publicat",
        savedState: "Salvat",
        viewonlyMode: "View Only Mode",
        backToRuleTesting: "Înapoi la testarea regulilor",
        backToDiagram: "Înapoi la diagramă",
        previewSmartContract: "Previzualizare cod contract inteligent",
        deleteSmartContract: "Ștergeți contractul inteligent",
        downloadSmartContract: "Descărcare contract inteligent",
        downloadSwagger: "Descărcare descriptor Swagger",
        publishEntity: "Publicați tabela de date",
        maintenanceMessage: "Asigură-te ca ai totul salvat. Mentenanța este programată în",
        maintenanceLoginBtn: "Autentificare utilizator mentenanță",
        maintenanceRefresh: "Reîncarcă pagina"
    },
    apps: {
        addSomeApps: "Aplicațiile adăugate vor fi listate în această secțiune",
        itIsEmpty: "Nu există nicio aplicație momentan",
        noDescription: "Nicio descriere.",
        downloadError: "Efectuați o salvare în secțiunea Diagrame după care poți descarcă aplicația",
        getStarted: "Începeți",
        noInterfaces: "Nu ați folosit nicio interfață utilizator",
        search: "Căutați o aplicație",
        searchText: "Căutați",
        manageBtn: "Administrați",
        reportsBtn: "Analitice",
        displayed: "recent folosită | recent folosite",
        startBtn: "Start",
        noApps: "Nu au fost găsite aplicații",
        caption: "Aplicații",
        addNew: "Creează",
        viewAllApps: "Vizualizați tot",
        viewApp: "Vizualizați",
        yourApplications: "Aplicații",
        sharedWithYou: "Aplicații la care ați primit acces",
        archivedApplications: "Aplicații arhivate",
        addNewApp: "Setările aplicației",
        appName: "Numele aplicației",
        appType: "Tipul",
        appDescription: "Descriere",
        userInterface: "Interfață utilizator",
        question: "Întrebare",
        response: "Răspuns",
        addToArchive: {
            archiving: "Arhivează aplicația",
            applyTo: "Aplicați pentru",
            optionLabel: "Arhivați",
            appDefinition: "Definiția aplicației",
            appDetails: "Detalii aplicație",
            instances: "Instanțe de proces",
            appDefInfo: "Definiția aplicației va fi arhivată împreună cu procesele aplicației, interfețe utilizator, șabloane de documente, API-uri, modele de date și cataloage.",
            appInstanceInfo:
                "Toate instanțele de proces vor fi arhivate. Cele care încă rulează și cele eșuate vor fi terminate după arhivare. Numărul total și numărul individual de instanțe sunt afișate mai jos.",
            all: "Toate"
        },
        archiveConfirmationMsg: "Arhivând aplicația, aceasta va dispărea din lista aplicațiilor și nu va mai putea fi folosită",
        taskBoard: "Panoul task-ului",
        shareApp: "Share App",
        export: "Exportați",
        duplicate: "Dublați",
        description: "Descriere:",
        duplicatedApp: "Acest nume este deja folosit de o aplicație.",
        createFirst: "Mai întâi trebuie să creați aplicația",
        noName: "Vă rugăm să introduceți un nume pentru aplicația dvs. .",
        noCode: "Codul aplicației este obligatoriu",
        exceededLength: "Ați depășit numărul maxim de caractere",
        noType: "Tipul aplicației este obligatoriu",
        avatarUploaderBody1: "Formate acceptate:",
        avatarUploaderBody2: ".jpg, .png, .svg (max 2 MB)",
        noPermisions: "Permisiunile și utilizatorii/rolurile sunt obligatorii",
        noPermsionsUser: "Utilizatorii sunt obligatorii",
        addPermision: "Permisiunile sunt obligatorii",
        uploadImage: "Încărcați imaginea",
        editApp: "Editați",
        startApp: "Start",
        nameApp: "Nume",
        settingsProcess: "Setări",
        noPermisionsToStartApp: "Procesul a fost pornit. Veți fi notificat atunci cand primiți un Task.",
        noPermissionsToStartProcess: "Nu aveți permisiunea de a iniția acest proces. Vă rugăm să contactați administratorul.",
        noPermisionsToInitiateApp: "Nu aveți drepturile necesare pentru a porni această aplicație",
        untitledApp: "Aplicație fără titlu",
        appTypeNotSet: "Tipul aplicației",
        appStatus: "Statusul aplicației:",
        status: "Stare",
        notPublished: "Nu este publicat",
        createdBy: "Creat de",
        noInfo: "Nu există informații disponibile",
        tasksIterations: "Task-uri și iterații:",
        createApp: "Creează aplicația",
        createAppBtn: "Creează aplicația",
        discardApp: "Renunțați la aplicație",
        update: "Actualizați",
        highlights: "Detalii",
        appDetails: "Detaliile Aplicației",
        users: "Utilizatori și permisiuni",
        groups: "Grupurile aplicației",
        groupsTitle: "Grupurile specifice ale aplicației",
        groupsAddNewBtn: "Adăugați un nou grup",
        noRoles: "Deocamdată această aplicație nu este accesibilă niciunui utilizator sau rol",
        existRoles: "Aplicația este accesibilă către:",
        rolesText: "roluri",
        usersText: "utilizatori",
        giveAcces: "Dați acces",
        importApplication: "Încărcați fișierul cu setări (.bfz) aici.",
        linkImportApplication: "Sau faceți clic mai jos pentru a-l încărca",
        instanceRetention: "Retenția instanțelor de proces",
        periodRetention: "Perioada de retenție a instanțelor de proces",
        retentionMessage: "Perioada de retenție indică durata de timp pentru care sunt păstrate datele unei instanțe de proces, după momentul în care instanța este Finalizată, Terminată, sau Arhivată.",
        indefinite: "Nedeterminată",
        limited: "Limitată",
        period: "Perioada",
        retentionExpirationMessage: "O perioadă de retenție 0 rezultă in ștergerea instanțelor de proces ale acestei aplicații imediat după ce ele sunt Terminate sau Finalizate",
        errorMessage: "Nu poate fi negativ sau fracție",
        days: "Zile",
        months: "Luni",
        weeks: "Săptămâni",
        years: "Ani",
        importExport: "Exportați aplicația",
        exportApp: "Exportați această aplicație cu toate setările sale",
        download: "Descărcați",
        import: "Importați",
        groupsRole: "Grupuri",
        usersCard: "Utilizatori",
        exportSet: "Exportați aplicația",
        importApp: "Importați setările aplicației",
        titleModalSettings: "Importați aplicația",
        importAppBtn: "Importați aplicația",
        importButton: "Încărcați fișierul aplicației",
        importSucess: "Aplicația a fost încărcată cu succes!",
        ini: "INI",
        wri: "WRI",
        rep: "REP",
        PUBLISHED: "Publicat",
        ARCHIVE_IN_PROGRESS: "SE ARHIVEAZA...",
        NOT_PUBLISHED: "Nepublicată",
        UNPUBLISHED_CHANGES: "Modificări Nepublicate",
        IMPORTED: "Importat",
        blockchainType: {
            standard: "Standard",
            hyperledger: "Hyperledger",
            ethereum: "Ethereum"
        },
        deleteUser: "Doriți să ștergeți acest utilizator?",
        deleteRole: "Doriți să ștergeți acest grup?",
        yes: "Da",
        no: "Nu",
        titlePreviewSC: "Cod contract inteligent",
        copyBtn: "Copiați",
        successCopy: "Cod copiat în clipboard",
        errorCopy: "Ne pare rău, nu se poate copia în clipboard.",
        previewTitle: "Previzualizare cod ",
        dialogTitle: "Actualizați aplicația",
        dialogMessage: "Trebuie să încărcați pachetul de aplicații pentru a actualiza aplicația.",
        chooseFile: "Selectați sau încărcați fișierul aici",
        updateFailed: "Actualizare eșuată",
        updated: "{appName} a fost actualizată cu succes.",
        warningMsg: "Actualizarea aplicației va modifica configurațiile tuturor modulelor pentru a se potrivi cu versiunea aplicației exportate.",
        removeBfz: "Sigur doriți să ștergeți acest fișier? Nu veți putea anula acțiunea.",
        deleteFile: "Ștergeți fișierul",
        delete: "Ștergeți",
        cancel: "Anulați",
        bfz: "bfz",
        publishedTooltip: "Această aplicație este publicată și actualizată.",
        unpublishedTooltip: "Această aplicație este nepublicată.",
        unpublishedChangesTooltip: "Această aplicație are modificări nepublicate.",
        beenPublished: "Această aplicație a fost publicată",
        by: "De",
        code: "Cod",
        appCode: "Cod aplicație:",
        defaultNameApp: "Numele aplicației nu este setat",
        initialBlockchainTypeLabel: " nu este setat",
        codeMandatory: "Codul aplicației este obligatoriu.",
        codeDuplicate: "Acest cod este deja utilizat de o aplicație.",
        codeRegex: "Codul aplicației poate avea 2 - 5 caractere (A-Z, 0-9) și nu poate conține caractere speciale.",
        resultsFound: "rezultat(e) găsite",
        imageSizeError: "Imaginea încărcată este prea mare. Dimensiunea maximă admisă este de {maxSize}",
        importUpdateAppDupTitle: "Există deja o aplicație care folosește același cod unic ca și aplicația pe care urmează să o imporți.",
        importUpdateAppDupBody: "Dacă continui, această aplicație importată va primi un alt cod și drept urmare <b>nu va mai putea fi actualizată</b>."
    },
    processes: {
        processes: "Procese",
        addProcess: "Adăugați proces",
        diagram: "Diagramă",
        import: "Importați",
        settings: "Setări",
        retentionTitle: "Retenție",
        invalidName: "Nume invalid",
        nrOfProcesses: "proces | procese",
        nrOfApplications: "aplicație | aplicații",
        numberOfProcesses: "Niciun proces. | Conține 1 proces. | Conține {count} procese.",
        processType: "Tipul:",
        startableOpt: "Individual (Procesul poate fi pornit direct)",
        unstartableOpt: "Asociat (Procesul poate fi pornit doar prin alt proces)",
        inheritedOpt: "Moștenită din setările aplicației",
        indefiniteOpt: "Nedeterminată",
        limitedOpt: "Limitată",
        standaloneLabel: "INDIVIDUAL",
        emptyPeriod: "Valoarea trebuie să fie numerică",
        retentionZeroInfo: "O perioadă de retenție de 0 înseamnă că cazurile vor fi șterse imediat ce sunt finalizate sau încheiate.",
        linkedLabel: "ASOCIAT",
        duplicatedProcessName: "Există deja un proces cu acest nume.",
        warningTitle: "Avertizare!",
        wrnBodyMsg: "Dacă părăsiți pagina înainte de salvare, modificările dvs. se vor pierde. Sunteți sigur că vreți să continuați?",
        leaveBtn: "Salvați și continuați",
        search: "Căutați un proces",
        descriptionError: "Câmpul nu poate conține caractere speciale",
        archive: "Arhivează",
        editDetails: "Editați detaliile",
        duplicate: "Dublați",
        errorFound: "Eroare găsită",
        noProcesses: "Niciun proces, încă",
        createNew: "Creează un proces nou",
        startProcess: "Începeți un proces",
        startProcessBtn: "Pornește",
        deleteUnpublishedFirstMsg: "Sigur doriți să ștergeți '{process}'?",
        deleteUnpublishedSecondMsg: "Poți recupera procesele șterse folosind Istoricul modificărilor.",
        deleteUnpublishedMessageTitle: "Procesul '{process}'",
        deletePublishedFirstMsg: "Toate instanțele acestui proces vor fi Terminate și Arhivate atunci cand aplicația este publicată. In prezent, există ",
        deletePartMsg: " instanțe care rulează. | instanțe care rulează sau au eșuat.",
        deletePublishedSecondMsg: "Poți recupera procesele șterse folosind Istoricul modificărilor. Dacă recuperați acest proces inainte de publicare, atunci instanțele sale nu vor fi terminate. Utilizatorii atribuiți vor avea drepturile de inițiere șterse la publicare.",
        deletePublishedMessageTitle: "Procesul '{process}'",
        markForArchiving: "Marcați pentru arhivare",
        rename: "Redenumiți",
        renameProcess: "Redenumiți proces",
        successfullyRenamed: "Procesul a fost redenumit cu succes.",
        failedRename: "Redenumirea procesului a eșuat",
        emptyProcessNameNotif: "Numele nu poate fi gol",
        alreadyEditProcess: "Acest proces este în prezent editat de {username} și nu poate fi redenumit",
        wrongPatternErr: "Numele poate conține litere, cifre și caractere speciale ca underline, cratimă și spațiu. Primul element trebuie să fie literă.",
        statusReport: "Raport de stare",
        cancelArchiving: "Anulați arhivarea",
        detailsTitle: "Detalii",
        processDetails: "Detaliile procesului",
        publishedWithChanges: "PUBLICAT CU MODIFICĂRI SALVATE",
        currentlyApplying: "În prezent se aplică pentru",
        instances: "Instanțe de proces",
        instancesDescription: "Toate instanțele de proces vor fi arhivate. Cele active vor fi terminate după arhivare. Numărul total curent și numărul individual de instanțe sunt afișate mai jos.",
        completed: "Efectuate",
        terminated: "Terminate",
        running: "Active",
        failed: "Eșuate",
        all: "Toate",
        scheduledForArchiving: "Programat pentru Arhivare la următoarea Publicare",
        abortArchiving: "Întrerupeți arhivarea {name}",
        archivingDescription: "Anularea acțiunii de arhivare va opri arhivarea proceselor la următoarea publicare.",
        infoAlert: "Alertă informativă",
        infoAlertMsg: "Continuând cu publicarea aplicației se va arhiva: {name}.",
        listChanged: "Lista de procese a fost modificată",
        processChanged: "Procesul “{name}” a fost modificat",
        processDeleted: "“{name}” a fost șters cu success",
        errorOnDelete: "Nu poți șterge procesul “{name}” pentru că se află în editare.",
        errorOnRename: "Procesul este editat de “{user}” și nu poate fi redenumit.",
        processUpdatedRefresh: "Procesul “{name}” a fost modificat. Pentru a vedea ultima versiunea, reîmprospătați pagina.",
        editNameTooltip: "Faceti click pe butonul de “Redenumiți” de sub meniul cu trei puncte al Procesului pentru a redenumi."
    },
    giveAcces: {
        add: "Adăugați",
        update: "Actualizați",
        titleModalAcces: "Acordați permisiuni",
        permissionsTitle: "Permisiuni și niveluri",
        initiator: "Initiator",
        editor: "Editor",
        report: "Vizualizator de analitice",
        userRoles: "Selectați utilizatori și roluri",
        userTitle: "Utilizatori",
        groupsTitle: "Grupuri"
    },
    dataModel: {
        caption: "Model de date și cataloage",
        noCatToShow: "Nu există niciun catalog momentan",
        name: "Model de date",
        emptyDataModel: "Nu sunt clase create",
        emptyDataModelMessage: "Odată ce veți crea prima clasă, aceasta va apărea aici",
        catalogs: "Cataloage",
        addNew: "Adăugați",
        classesCounter: "Clasă | Clase",
        classesCounterLowerCase: "clasă | clase",
        attributesCounter: "atribut | atribute",
        attributesFound: "atribut găsit | atribute găsite",
        resultsFound: "rezultat găsit | rezultate găsite",
        thisClassHas: "Această clasă are",
        addAttribute: "Proprietate",
        emptyClassTitle: "Nu puteți salva o clasă goală",
        emptyClass: "Clasa numită {emptyClass} este goală | Clasele {emptyClass} sunt goale",
        ok: "OK",
        createAnother: "Creează încă una",
        dataModelUpdateToast: "Modelul de date a fost actualizat. Apăsați butonul pentru a vedea ultima versiune.",
        deleteClassSuccess: "Clasa a fost ștearsă cu succes",
        refresh: "Actualizați",
        createNew: "Creează",
        modal: {
            title: "Adăugați o nouă clasă",
            editTitle: "Editați clasa",
            subtitle: "Setările clasei",
            attributesSection: "Proprietăți",
            className: "Numele clasei",
            blockchainLabel: "Contract inteligent pregătit",
            titleAddFields: "Adăugați o nouă proprietate",
            titleEditFields: "Editați proprietatea",
            subtitleFields: "Setările proprietății",
            propertyName: "Numele proprietății",
            isEmbedded: "Este încorporat",
            isIndexable: "Identificabil",
            personalInformation: "Informații personale",
            isList: "Listă",
            type: "Tipul",
            deleteTitleDialog: "Woah! Sigur doriți să ștergeți această clasă?",
            deleteTitleDialogClass: "Sigur doriți să ștergeți această clasă?",
            deleteBodyMsg: "Această acțiune nu poate fi anulată.",
            deleteBodyMsgClass: "O puteți recupera mai târziu întorcând Modelul de date la o salvare anterioară.",
            deleteBodyMsgAttr: "Îl puteți recupera mai târziu întorcând Modelul de date la o salvare anterioară.",
            deleteBtnDlt: "Ștergeți",
            closeTitleDialog: "Avertizare",
            closeBodyDialog: "Sunteți sigur că vreți să părăsiți pagina? Veți pierde toate modificările!",
            closeDialog:"Confirmați",
            deleteBtnCancel: "Anulați",
            deletePropDialog: "Sigur doriți să ștergeți acest atribut?",
            noNameErrorClassName: "Numele clasei nu trebuie să fie format doar din spații, caractere speciale sau numere și să nu înceapă cu o cifră.",
            noNameError: "Numele proprietații nu trebuie să fie format doar din spații, caractere speciale sau numere și să nu înceapă cu o cifră.",
            forbiddenAttName: "Nu aveți permisiunea de a utiliza acest nume de atribut",
            duplicateInCatalogs: "Există deja un catalog cu numele {name}",
            duplicateInDataModel: "Există deja o clasă cu numele {name}",
            duplicatePropName: "În această clasă există deja o proprietate cu numele {nume}",
            duplicateInTypes: "{name} este un nume rezervat",
            searchableTooltip:
                "Activați dacă doriți ca această valoare să apară în rezultatele căutării atunci când folosiți Analitice sau Inspectorul de proces.",
            listTooltip: "Activați dacă doriți să permiteți câmpului să dețină mai multe valori sau structură de date complexă",
            smartContractTooltip: "Clasa ar trebui să fie de tipul contract inteligent pentru a avea această opțiune disponibilă.",
            smartContractTooltipActivated: "Activați opțiunea contract inteligent pentru {className} dacă doriți să fie disponibilă pentru această selecție.",
            smartClassTooltip: "Activați dacă doriți să folosiți această clasă in contracte inteligente",
            smartAttributeTooltip: "Activați dacă doriți să folosiți această proprietate in contracte inteligente",
            editSmartContractClassTooltip: "Nu puteți dezactiva această opțiune deoarece conține o proprietate de tip contract inteligent."
        }
    },
    catalogs: {
        name: "Cataloage",
        title: "Toate cataloagele",
        baseTypes: "Tipuri de bază",
        catalogsDetailsSuccess: "Catalogul a fost salvat cu succes",
        addSomeCat: "Adăugați sau selectați un catalog, iar detaliile acestuia vor fi listate în această secțiune",
        emptyRow: "Nu puteți salva un rând fără cod sau nume!",
        addRow: "Adăugați rând",
        emptyCatalogs: "Nu există niciun catalog creat",
        noCatalogSelected: "Selectați sau creați un catalog nou",
        emptyCatalogMessage: "Odată ce o să creați primul vostru catalog, va apărea aici",
        onlyTypeValAllowed: "Sunt permise doar valorile de tip {name}",
        exportDialogTitle: "Alegeți formatul de export",
        exportDialogBody: "Vă rugăm să alegeți formatul de export",
        exportExcel: "Excel (.xlsx)",
        exportJson: "JSON",
        infoMessage: "Numele catalogului depășește limita permisă de Excel. La export, numele va fi trunchiat la 31 de caractere și, drept urmare, fișierul Excel nu va putea fi folosit pentru a importa date înapoi în catalog. Recomandăm utilizarea formatului JSON.",
        infoMessageList: "Unul sau mai multe cataloage au nume ce depășesc limita permisă de Excel. La export, numele acestea vor fi trunchiate la 31 de caractere și, drept urmare, fișierul Excel nu va putea fi folosit pentru a importa date în aceste cataloage. Recomandăm utilizarea formatului JSON.",
        exportBtn: "Export",
        addNew: "Adăugați",
        addData: "Adăugați date",
        editBtn: "Editați",
        addCat: "Adăugați catalog",
        editCat: "Editați catalogul",
        catalogsCount: "catalog | cataloage",
        cardInfoBody: "Faceți clic pe un catalog pentru a vizualiza datele acesuia",
        info: "Info",
        deleteCatRowDialog: "Sigur doriți să ștergeți acest rând?",
        deleteBodyMsgRow: "Îl puteți recupera mai târziu întorcând Catalogul la o salvare anterioară din Istoricul salvărilor.",
        deleteCatDialog: "Sigur doriți să ștergeți acest catalog?",
        deleteBodyMsgCat: "Îl puteți recupera mai târziu din Istoricul Schimbărilor.",
        alreadyDeleted: "Catalogul a fost șters de un alt utilizator.",
        searchCode: "Căutați un cod",
        infoExport: "Cataloagele salvate au fost exportate.",
        maxCodeLength: "Lungimea maximă permisă pentru cod este de 50 de caractere",
        wrnMsgImportDirty: "Există schimbări nesalvate. Importul de date va suprascrie aceste schimbări. ",
        icons: {
            deleteCatalog: "Ștergeți catalogul"
        },
        true: "Adevărat",
        false: "Fals",
        addNewCat: {
            title: "Adăugați un catalog nou",
            subtitle: "Setările catalogului",
            name: "Nume",
            type: "Tip",
            addBtnModal: "Adăugați",
            save: "Salvați",
            description: "Descriere",
            columns: "Coloane",
            addBtn: "Adăugați coloană",
            deleteCol: "Ștergeți coloana",
            requiredTooltip: "Obligatoriu",
            errorDuplicatedName: "Catalogul cu numele {name} există deja",
            noNameError: "Numele clasei nu trebuie să conțină doar spații, caractere speciale sau numere.",
            noCatalogNameError: "Numele nu trebuie să conțină doar spații, caractere speciale sau numere și să nu înceapă cu cifre.",
            duplicatedColumn: "Aveți deja o coloană cu acest nume.",
            nullColumn: "Nu puteți salva o coloană goală.",
            errorExistingCode: "Aveți deja un rând cu acest cod.",
            alreadyEmptyRow: "Aveți deja un rând gol!",
            warning: "Avertizare!",
            duplicatedNameWithInactiveCat: "Aveți deja un catalog inactiv cu acest nume.",
            saveCatBeforeImport: "Trebuie să salvați catalogul înainte de a importa date.",
            activeSpaceData: "Introducerea datelor nu poate conține doar spații sau să înceapă cu spațiu."
        },
        importExport: {
            title: "Importați un catalog nou",
            titleBulk: "Importati date in masă",
            text: "Tipul de date pe care vreți sa le importați/exportați:",
            importData: "Importati date",
            exportData: "Exportați date",
            import: "Importați",
            importAll: "Import date in masă",
            export: "Exportați",
            exportAll: "Export date in masă",
            uploadImportFile: "Încărcați fișierul",
            downloadTemplate: "Descărcați șablonul",
            downloadSectionbdy: "Puteți descărca șablonul de aici",
            importBtn: "Importați",
            incorectFile: "Fișierul pe care doriți să îl importați nu se potrivește cu numele catalogului",
            importDupCodeName: "Asigurați-vă că nu aveți codurile sau numele duplicate.",
            error: "Eroare!",
            invalidJsonFile: "Asigurați-vă că fișierul JSON este formatat corect.",
            importXlsCatListErr: "Nu puteți importa cataloage noi, ci doar valori în cele existente.",
            importMaxLengthErr: "Lungimea maximă permisă pentru cod este de 50 de caractere.",
            duplicateColName: "Valoare duplicat în coloana - nume: ",
            duplicateColCode: "Valoare duplicat în coloana - code: ",
            codeErrEmpty: "Valoarea din coloana code este obligatorie",
            nameErrEmpty: "Valoarea din coloana name este obligatorie",
            type: "Tip",
            successImport: "Datele au fost importate cu success",
            alertTooltip: "Vă rugăm să salvați catalogul înainte de a exporta sau a importa date."
        },
        listUpdated: "Lista de cataloage a fost modificată!",
        contentUpdated: "a fost actualizat!"
    },
    api: {
        caption: "Integrări",
        addNew: "Adăugați",
        apiResults: "API | API-uri",
        credentialApiResults: "set de credențiale API | credențiale API",
        results: "Rezultat | Rezultate",
        mainConsumed: "API-uri externe",
        mainInternal:"API-uri de sistem",
        mainInternalApis:"API-uri interne",
        internalNoData:"Nu aveți acces la nici un API intern.",
        internalNoDescription:"Vă rugăm să contactați administratorul pentru a activa API-urile interne pentru această aplicație.",
        internalMethods:"Metode:",
        internalType:"API de sistem",
        mainExposed: "Credențiale API-uri expuse",
        mainConsume: "Consume",
        mainExpose: "Expose",
        exposedMainTitle: "Detalii credențiale",
        consumeMainTitle: "Detalii API",
        addNewCard: " Adăugați API-uri și acestea vor fi listate în această secțiune",
        noApis: "Niciun API, încă.",
        toggleExposedLabel: "Permiteți accesul numai din domenii personalizate",
        toggleConsumedLabel: "Necesită autentificare",
        name: "Nume",
        url: "URL",
        type: "Tip",
        search: "Căutați un Api",
        description: "Descriere",
        description2: "Descriere:",
        methods: "Metode:",
        type2: "Tip:",
        url2: "URL:",
        edit: "Editați",
        refresh: "Refresh",
        delete: "Ștergeți",
        username: "Numele utilizatorului",
        password: "Parola",
        clientID: "ID client",
        clientID2: "ID client:",
        secretKey2: "Client secret:",
        clientSecret: "Client secret",
        mandatoryField: "Acest câmp este obligatoriu",
        baseURL: "Base URL",
        secretKey: "Cheie secretă",
        addDomain: "Adăugați originea",
        request: "Request",
        response: "Response",
        uploadImage: "Încărcați imaginea",
        allApis: "Toate",
        update: "Actualizați",
        add: "Adăugați",
        warningMessage: "Sigur doriți să ieșiți? Aveți informații nesalvate și care se vor pierde",
        warning: "Avertizare",
        uploadMessage: "Sau puteți încărca fișierul de specificații al serviciului web",
        uploadDescription: "Tipurile fișierelor acceptate sunt .json and .xml",
        buttonMessage: "Încărcați fișierul de servicii web",
        noParams: "Nu există parametrii pentru acest apel.",
        nothingToMap: "Nu există nimic de mapat.",
        viewMethods: "vizualizați metodele",
        changeName: "Aveți deja acest nume API",
        changeLocation: "Aveți deja această locație API",
        ok: "Ok",
        cancel: "Anulați",
        nameRequired: "Numele este necesar",
        urlRequired: "Locația url este necesară",
        download: "Descărcați fișier",
        downloadMessage: "Descărcați fișierul cu specificațiile serviciului web",
        downloadDescription: "Tipurile fișierelor sunt .json și .xml sau .asmx",
        downloadButton: "Descărcați fișierul serviciului web",
        changeFile: "Aveți deja acest fișier de servicii web",
        fileUploadedMsg1: "Fișierul a fost încărcat",
        errorUrlType: "URL-ul este deja folosit de un alt API.",
        errorType: "Este selectat un tip incorect de API.",
        failedApi: "Eroare la parsarea API-ului",
        timeoutApi: "Definiția API a durat prea mult pentru a răspunde.",
        authentificationError: "Acest API necesită autentificare.",
        serviceUnavailableError: "Serviciu indisponibil.",
        location: "Locație",
        location2: "Locație:",
        deleteExpApiError: "API-ul nu poate fi șters deoarece este utilizat (mapat) la elementul 'Pornire din exterior'.",
        externalSource: "API-uri expuse alocate",
        domainTooltip: "https://*.website.com//86.102.41.*",
        authUserPass: "Utilizator și parolă",
        oauth2: "Oauth2",
        oauth2Pass: "Oauth2 cu parolă",
        clientCred: "Credențialele clientului",
        allValDdl: "Toate",
        externalSourceValueDdl: "Sursă externă",
        apiValDdl: "API",
        searchPlaceholder: "Căutare",
        errorName: "Acest nume de api există!",
        emptyName: "Api-ul ar trebui sa aibă un nume",
        wrongPatternErr: "Numele poate conține litere, cifre și caractere speciale ca underscore, punct, cratimă, apostrof și spațiu.",
        fileSizeError: "Imaginea încărcată este prea mare. Dimensiunea maximă admisă este de {maxSize}",
        websocketNotif: "Lista cu api-uri externe a fost actualizată",
        websocketDeletedNotif: "API-ul extern a fost șters",
        websocketDeletedNameNotif: "API-ul extern \"{name}\" a fost șters de către {user}",
        websockeRenameNotif: "API-ul extern a fost redenumit cu succes",
        websocketCredentialsNotif: "Lista cu credențiale a fost actualizată",
        websocketCredentialsDeletedNotif: "Setul de credențiale a fost șters",
        websocketCredentialsDeletedNameNotif: "Setul de credențiale \"{name}\" a fost șters de către {user}",
        websocketCredentialsRenameNotif: "Setul de credențiale a fost redenumit cu succes",
        renameOptionMenu: "Redenumește",
        renameTitleDialog: "Redenumește API-ul extern",
        renameExposedTitleDialog: "Redenumește credențialele API",
        readonlyNameTooltip: "Pentru a redenumi API, deschide meniul “⋮” din lista de API",
        readonlyExposedNameTooltip: "Pentru a redenumi credențialele API, deschide meniul “⋮” din lista de API ",
        emptyNameDialog: "Acest câmp este obligatoriu",
        showCredentials: "Arată credențialele",
        hideCredentials: "Ascunde credențialele",
        copyBtn: "Copiați",
        authTypeReq: "Selectați un tip de autentificare",
        externalApiHighlights: "Repere API",
        externalApiDescriptor: "Descriptor",
        externalApiAuthentication: "Autentificare",
        reloadDescriptorCheckbox: "Reîncărcare descriptor",
        sameDescriptorNotif: "Noul descriptor API este identic cu cel vechi",
        radioFileOpt: "Fișier",
        radioUrlOpt: "URL",
        internalUrlCard: "URL intern",
        methodsModalTitle: "metoda",
        downloadDescriptor: "Descarcă descriptorul",
        savingWillPublish: "Salvând, veți publica schimbările",
        deletedExposed: "Credențialele API șterse nu pot fi recuperate"
    },

    tasks: {
        caption: "Task-uri",
        myTasks: "Task-urile mele",
        myTeamsTasks: "Task-urile echipei",
        task: "Task",
        taskNoLongAvail: " pe care încercați să il vedeți nu mai este disponibil.",
        alrdyClaimed: " a fost deja preluat de",
        noGuiMessage: "Nu există nicio interfață utilizator mapată în acest punct final. Task-ul nu poate fi afișat.",
        newTaskAssigned: "V-a fost atribuit un nou task",
        newTaskReassigned: "Un nou task v-a fost reasignat",
        newTaskAssignedFabricI: 'V-a fost atribuit un nou task. Il puteți revizui în secțiunea "Explorator de task-uri".',
        newTaskReassignedFabricI: 'Un nou task v-a fost reasignat. Il puteți revizui în secțiunea "Explorator de task-uri".',
        openMyTasks: "Deschide-mi task-urile",
        activeTasks: "Task-uri active",
        teamTasks: "Task-urile echipei",
        appsCreators: "Creatorii aplicațiilor",
        completedTasks: "Task-uri finalizate",
        myCompletedTasks: "Task-urile mele - Finalizate",
        myTeamTasks: "Task-urile echipei - De făcut",
        myTeamCompletedTasks: "Task-urile echipei - Finalizate",
        noTasks: "Niciun task",
        myOpenTasks: "Task-urile mele - De făcut",
        filterModalTitle: "Filtre și sortare",
        sortBy: "Sortare după",
        priorityName: "Prioritate",
        taskName: "Numele task-ului",
        creationDateFilter: "Data creării",
        completionDateFilter: "Data finalizării",
        timeRemaining: "Timpul rămas",
        groupTitle: "Grup",
        clearAll: "Resetați tot",
        id: "Id",
        search: "Căutare",
        applications: "Aplicații",
        display: "Afișare",
        allApps: "Toate aplicațiile",
        status: "Status",
        timeToDeadline: "Durata până la termen:  ",
        creationDate: "Data creării: ",
        completionDate: "Data finalizării",
        assignmentUsers: "Desemnat ",
        completedOn: "Finalizat pe:",
        hours: " ore",
        minutes: " min",
        days: " zile",
        weeks: " săptămâni",
        noOpenTasks: "Nu aveți niciun task activ.",
        noCompltedTasks: "Nu aveți niciun task finalizat.",
        viewAllTasks: "Vizualizați tot",
        filterBy: {
            ascending: "Ascendent",
            descending: "Descendent",
            onTime: "La timp",
            inWarning: "În avertizare",
            attention: "În atenţie",
            overdue: "Întârziat",
            allTasks: "Toate task-urile",
            byStatus: "După status",
            byPriority: "După prioritate",
            byDate: "După dată",
            priorities: {
                highest: "Cel mai ridicat",
                high: "Ridicat",
                normal: "Normal",
                low: "Scăzut",
                lowest: "Cel mai scăzut"
            }
        },
        taskAlreadyClaimed: "Se pare că acest task a fost preluat de altcineva. ",
        taskNotFound: "Oops! Acest task nu există sau a fost eliminat",
        noRightsToClaimTask: "Oops! Se pare că nu aveți voie să preluați acest task. Vă rugăm să discutați cu administratorul dvs. ",
        taskFinalized: "Acest task nu mai este activ.",
        taskNotAvailable: "Acest task nu mai este disponibil.",
        view: "Afișați",
        claim: "Preluați",
        cancel: "Anulați",
        unclaimTask: "Resetați",
        reassignTask: "Realocați",
        escalateTask: "Escaladați",
        bulkUnclaim: "Resetați în masă",
        bulkReassign: "Realocați în masă",
        bulkReassignExternal: "Realocați în masă task-uri externe",
        bulkEscalate: "Escaladați in masă",
        bulkSelect: "Selectați tot",
        apply: "Aplicați",
        unclaimTitle: "Resetați",
        unclaimReason: "Motiv",
        infoTurnOff: "Opriți notificările pentru opțiunea de realocare",
        infoTurnOffTooltip: "Notificările de realocare în masă pot declanșa filtre spam",
        reasonPlaceholder: "Vă rugăm să specificați motivul acțiunii dvs.",
        popupTitle: "Resetați acest task?",
        reasonRequired: "Motivul acțiunii dvs. este necesar.",
        unclaimedSucces: "Task-urile au fost preluate cu succes. | Task-ul a fost preluat cu succes.",
        allUsers: "Utilizatori",
        searchPlaceholder: "Căutare după utilizatori și roluri",
        popupAssignTitle: "Realocați task-ul?",
        popupAssignTasks1: "Realocați ",
        popupAssignTasks2: " task-uri ?",
        popupUnclaimTasks1: "Resetați ",
        popupUnclaimTasks2: " task-uri ?",
        reassignSucces: "Task-urile au fost reasignate cu succes. | Task-ul a fost reasignat cu succes.",
        unclaimMessage: "Succes, ați resetat acest task",
        reassignMessage: "Success, ați atribuit un task",
        errorTitle: "Selectați un nou utilizator",
        errorText: "Vă rugăm să selectați un utilizator pentru a reasigna task-ul",
        completedTeam: "Task-urile finalizate ale echipei",
        tabExternal: "Extern",
        tabInternal: "Intern",
        availableUsers: "Utilizatori disponibili",
        availableUsersGroups: "Utilizatori și grupuri disponibile",
        labelEmail: "Adresa de e-mail",
        labelPhone: "Număr de telefon",
        externalBadge: "TXT",
        errorEmail: "Adresa de e-mail este obligatorie",
        errorEmailValid: "Adresa de e-mail trebuie sa fie valabilă",
        errorPhone: "Numărul de telefon este obligatoriu",
        errorPhoneValid: "Numărul de telefon trebuie sa fie valabil",
        errorPhoneNumeric: "Numărul de telefon trebuie să conțină doar caractere numerice",
        separateTask: "Creează un task separat pentru fiecare desemnat",
        separateTaskInfo: "Important: Fii sigur că folosești depozitul de date pentru a configura interfața acestui task.",
        separateTaskInfo2:
            "Important: Fii sigur că folosești depozitul de date pentru a configura interfața acestui task. Un task separat va fi creat pentru fiecare desemnat."
    },

    login: {
        changePassTitle: "Configurați portofelul blockchain",
        changePassDescription: "A fost generat un portofel blockchain pentru contul dumneavoastră. Vă rugăm să alegeți o parolă pentru acest portofel. Această parolă nu poate fi schimbată ulterior.",
        temporaryWalletPass: "Parola temporară pentru portofel",
        temporaryWalletDescription: "A fost trimis un e-mail cu parola temporară pentru portofel",
        errorPassWallet: "Parola trebuie să conțină cel puțin o literă mare, o literă mică, o cifra între 0 și 9 și trebuie să aibă o lungime de cel puțin 8 caractere.",
        errorTempWallet: "Parola este greșită",
        newWalletPass: "Parolă nouă pentru portofel*",
        confirmWalletPass: "Confirmați noua parolă pentru portofel*",
        setUpLater: "Configurați mai târziu",
        changePassword: "Schimbați parola",
        username: "Adresa de e-mail",
        password: "Parola",
        resetTokenExpired: "Tokenul dvs. a expirat",
        login: "Continuă",
        loginWith: "sau continuă cu",
        createAccount: "Creează cont",
        createOneHere: "Creează unul aici.",
        noAccount: "Nu ai cont?",
        enterEmail: "Conectați-vă cu e-mail",
        continueWithEmail: "Continuați cu e-mailul",
        registrationSubmitted: "Cerere de înregistrare trimisă",
        backToConfirmCard: "Înapoi la pagina de autentificare",
        goToLogin: "Accesați pagina de autentificare",
        savePassword: "Salvați parola",
        setPassword: "Setați parola",
        logoutTitle: "V-ați deconectat",
        logoutMessage: "Sperăm să ne vedem din nou foarte curând. Puteți să vă autentificați rapid prin apăsarea butonului de mai jos.",
        title: "Conectează-te",
        invalidSignUpEmail: "Te rugăm să introduci o adresă de email validă",
        forgotPassword: "Am uitat parola",
        reset: "Faceți clic aici pentru a reseta",
        userEmail: "Adresa de e-mail / Nume de utilizator",
        welcomeMessage: "Bine ai venit,",
        userInvalidCredentials: "Nume de utilizator și/sau parolă incorecte",
        strength: "Siguranța parolei:",
        strong: "Puternică",
        weak: "Slabă",
        medium: "Medie",
        titleReset: "Resetați parola",
        savedPassword: "Parolă salvată",
        setPass: "Resetați parola",
        passwordChanged: "Parolă resetată!",
        accountDisabled: "Cont dezactivat",
        accountDisabledBodyMsg: "Acest cont este dezactivat, vă rugăm să contactați administratorul pentru a-l activa.",
        accountNotRegistered: "Contul nu este înregistrat",
        accountNotRegisteredBodyMsg: "Acest cont nu este înregistrat, vă rugăm să contactați administratorul pentru a vă crea un cont.",
        passwordChangedMessage: "Parola dvs. a fost resetata. <br> Pentru a vă autentifica cu noua parolă, vă rugăm să faceți clic mai jos.",
        passwordSetMessage: "Parola dvs. a fost setată. Pentru a vă autentifica cu noua parolă, vă rugăm să faceți clic mai jos.",
        returnToLogin: "Reveniți la pagina de autentificare.",
        returnToReset: "Reveniți la pagina de resetare a parolei",
        tokenExpiry: "Tokenul este setat să expire:",
        expiredToken: "Tokenul a expirat",
        messageForExpiredToken: "Link-ul nu mai este disponibil. Trimiteți un nou link accesând pagina de resetare a parolei",
        invalidUser: "Acest cont a fost dezactivat. Vă rugăm să contactați administratorul de sistem",
        increaseContrast: "Mărește contrast",
        backToReset: "Reveniți la pagina de resetare a parolei",
        backToLogin: "Reveniți la pagina de autentificare",
        hours: "ore",
        changeUser: "Nu sunteți dvs.? Conectați-vă cu alt utilizator",
        sessionExpired: "Sesiunea dvs. a expirat",
        confirmSignUpMessage: "Veți primi un e-mail cu următorii pași necesari pentru a finaliza înregistrarea.",
        resetPassMessage:
            "Vom trimite un link de resetare a parolei la adresa de e-mail pe care ați furnizat-o.",
        linkSentMessage: "Am trimis un link de resetare a parolei la adresa de e-mail pe care ați furnizat-o. Dacă se află în baza noastră de date, veți putea reseta parola în cel mai scurt timp.",
        inviteSetPassMsg:
            "Contul dvs. a fost creat. Setați o nouă parolă aici",
        inviteSetExpiredMsg:
            "Link-ul nu mai este disponibil. Solicitați un nou link pentru a vă configura contul.",
        dashboard: "Duceți-vă la panoul dvs. de bord!",
        continue: "Autentificare",
        resetLink: "Trimiteți linkul de resetare",
        nonexistentEmail: "Nu există niciun cont cu această adresa de email",
        resetP: "Resetați parola!",
        resendLink: "Cereți retrimiterea link-ului",
        resetErr: "Parolele nu sunt identice.",
        emptyUser: "Te rugăm să introduci adresa de e-mail pentru a accesa contul.",
        errMaintenance: "Platforma este în mentenanță",
        emptyPass: "Te rugăm să introduci parola pentru a accesa contul ",
        sendLink: "Vă rugăm să introduceți o adresă de e-mail",
        addPass: "Vă rugăm să introduceți noua parolă",
        confirmPass: "Vă rugăm să confirmați noua parolă",
        mobileInfo: "Această aplicație nu este încă compatibilă cu telefoanele mobile!",
        setPassSAML:
            "Metoda de autentificare a fost schimbată și trebuie să setați o parolă. Am trimis un link de setare a parolei la adresa de e-mail pe care ați furnizat-o.",
        aurachain: "{brandName}",
        allRightsReserved: "Toate drepturile rezervate.",
        setNewPass: "Setează parola nouă*",
        confirmNewPass: "Confirmă parola nouă*",
        firstName: "Prenume*",
        lastName: "Nume*",
        setAccount: "Setează cont",
        createAcc: "Continuă",
        emptyFirstName: "Vă rugăm să introduceți prenumele pentru a vă accesa contul",
        emptyLastName: "Vă rugăm să introduceți numele pentru a vă accesa contul",
        twoFactorAuthBodyMsg:
            "Contul dvs. necesită autentificare in mai mulți pași. <br> Am trimis un cod de acces prin SMS la următorul număr: <strong>{phoneNo}</strong>",
        accessCode: "Cod de acces",
        generateNewCodeMsg: "Dacă nu îl primiți în câteva minute, generați unul nou ",
        clickingHereAccessCode: "făcând click aici.",
        resendAccessCode: "Codul transmis prin SMS a fost trimis. Daca nu l-ați primit, puteți genera unul nou dupa",
        wrongAccessCode: "Cod greșit, încercați din nou sau generați altul",
        expiredAccessCode: "Codul dvs. de autentificare a expirat. Vă rugăm să generați un cod nou.",
        emptyAccessCode: "Introduceți codul de acces",
        secureAccTitle: "Securizați contul",
        securePhoneBodyMsg: "Furnizați numărul de telefon pentru a finaliza autentificarea dvs. în 2 pași.",
        phoneNumberInput: "Numărul dvs. de telefon",
        skipButton: "Treceți peste",
        errorGenerate: "Puteți genera un singur cod o dată la 60 de secunde.",
        errorPhoneNr: "Numărul de telefon este obligatoriu.",
        invalidPhoneNumber: "Vă rugăm să introduceți un număr de telefon valid începând cu '+'.",
        oneSkipRemaining: "(O încercare disponibilă)",
        twoSkipsRemaining: "(Două încercări disponibile)",
        logoutError: "Serviciu Indisponibil. Deconectarea a eșuat. Puteți încerca să reîncărcați pagina. Dacă eroarea persistă, încercați din nou peste câteva minute.",
        invalidTenantTitle: "Pagina nu a fost gasită",
        invalidTenantDescription: "URL invalid, vă rugăm să verificați adresa cu Administratorul dumneavoastră."
    },
    admin: {
        icons: {
            users: "Utilizatori",
            editRole: "Editați numele rolului",
            deleteRole: "Eliminați rolul",
            save: "Salvați",
            cancel: "Anulați",
            addRolesToUsers: "Editați rolurile",
            delete: "Ștergeți",
            remove: "Eliminați"
        },
        schedule: {
            title: "Program de lucru",
            cardTitle: "Ore de lucru",
            workdays: "Zile de lucru",
            from: "De la",
            to: "Până la",
            monday: "Luni",
            tuesday: "Marți",
            wednesday: "Miercuri",
            thursday: "Joi",
            friday: "Vineri",
            saturday: "Sâmbătă",
            sunday: "Duminică",
            holidays: "Zile libere",
            noHolidayText: "Nu există zile libere definite.",
            addBtn: "Adaugă dată nouă",
            close: "Închide",
            toggleTitle:"Activează programul de lucru",
            toggleAppTitle: "Suprascrie programul de lucru al organizației.",
            toggleSubtitle:"Definește zilele lucrătoare, programul de lucru și zilele libere pentru organizație.",
            january: "Ianuarie",
            february: "Februarie",
            march: "Martie",
            april: "Aprilie",
            may: "Mai",
            june: "Iunie",
            july: "Iulie",
            august: "August",
            september: "Septembrie",
            october: "Octombrie",
            november: "Noiembrie",
            december: "Decembrie",
            mandatory: "Obligatoriu",
            toastSaved: "Programul de lucru a fost salvat cu succes",
            toastErrSave: "Programul de lucru trebuie să conțină cel puțin o zi lucrătoare.",
            addNew: "Adăugați nou",
            infoTextApp: "La nivel de organizație nu există niciun program de lucru setat.",
            manageHolidayPerYear: "Gestionează zile libere anuale",
            manageRecurring: "Gestionează zile libere recurente",
            tooltip: "Navigarea este disponibilă pentru cinci ani în jurul celui curent.",
            holidayInfo:"Definiți zile libere anuale (",
            holidayInfo1:") și recurente (",
            holidayInfo2:") pentru organizație."
        },
        processInspector: {
            appSummary: {
                summary: "Rezumat",
                headerInstanceFrom: " instanțe de proces de la ",
                headerAppsSelected: " aplicații selectate",
                headerAppSelected: " aplicație selectată",
                multipleSelectTitle: "Aplicații",
                instances: "Instanțe de proces",
                collapsHeaderInstances: "instanțe de proces",
                appTooltip: "Toate instanțele de proces vor fi arhivate. Numărul total și o defalcare pe status sunt afisate mai jos.",
                deleteInstTitle: "Ștergeți instanța de proces",
                deleteInstMess: "Instanța de proces și toate datele acesteia vor fi șterse permanent. Toate instanțele sincrone vor fi, de asemenea, șterse.",
                deleteInstanceSuccess: "Instanța de proces a fost ștearsă cu succes",
                deleteInstanceError: "Instanța de proces nu a putut fi ștearsă"
            },
            instances: "instanțe de proces",
            filtersApplied: "filtre aplicate",
            clearFilters: "Ștergeți filtrele",
            filter: "Filtrați",
            recordNo: "Informații per pagină",
            at: "la",
            on: "pe",
            notAvailable: "N/A",
            deleteSuccessfully : "{type} din {activity} a fost șters cu succes",
            selectedInstances: "selectate",
            instanceID: "ID-ul instanței de proces:",
            all: "Toate",
            terminateConfirm: "Terminați",
            archive: "Arhivați",
            dmlChip: "DML",
            archiveInstance: "Arhivează instanțele de proces",
            bulkArchiveMsg: "Arhivând aceste instanțe de proces, ele vor fi șterse din lista de instanțe. Orice altă instanță pornită în sincron cu acestea va fi arhivată.",
            title: "Inspector procese",
            subTitle: "Filtrați căutarea folosind opțiunile disponibile",
            systemStatus: "Statusul sistemului",
            process: "Proces",
            selectProcess: "Selectați o singură aplicație pentru a continua.",
            from: "De la",
            lastSaveBy: "Ultima oară salvat de",
            to: "către",
            errorDate: " 'Către Data' este obligatorie!",
            errorFromDate: " 'Din data' este obligatorie!",
            allStatuses: "Toate statusurile",
            runningStatus: "În Execuție",
            completedStatus: "Finalizate",
            failedStatus: "Eșuate",
            deleted: "Șterse",
            deletedComment: "ȘTERS",
            deletedDocument: "ȘTERS",
            terminateStatus: "Terminate",
            successfulStatus: "Cu succes",
            noItemsExecuted: "Nu au fost executate elemente",
            application: "Aplicație",
            searchApp: "Căutare după numele aplicațiilor",
            noAppSelected: "Nicio aplicație selectată",
            appSelected: "aplicații selectate",
            modalTitle: "Detalii",
            modalTitleArchive: "Adăugați instanța de proces la arhivă",
            apiModalTitle: "Vizualizați",
            messagesModalTitle: "Rezumat",
            messageName: "Numele mesajului",
            messageGenerated: "Generat",
            messageSent: "Trimis",
            messageConnectorName: "Numele conectorului",
            messageConnectorDescription: "Descrierea conectorului",
            messageRuleName: "Numele regulii",
            messageTrigger: "Trigger",
            messageRecipient: "Definiția destinatarului",
            messageRecipients: "Destinatari",
            messageSMTPServer: "Server SMTP",
            messageSMTPUsername: "Nume de utilizator SMTP",
            messageSubject: "Subiect: ",
            smsSubject: "Continutul mesajului",
            beforeStage: "Înaintea etapei",
            afterStage: "După etapă",
            apiSummary: "Rezumatul API",
            blockchainSummary: "Rezumatul Blockchain",
            apiName: "Nume",
            deleteTitleNotification:"Ștergeți notificarea primită prin {type}",
            deleteBodyNotification:"Acest mesaj va fi șters permanent. Ești sigur?",
            blockchainName: "Nume contract inteligent",
            apiExecutedOn: "Executat pe",
            apiExecutedIn: "Executat în",
            apiExecutedBy: "Executat de către",
            apiType: "Tip",
            apiMethod: "Metodă",
            apiUrl: "URL",
            blockchainChanel: "Canal",
            blockchaiHost: "Host",
            apiLocation: "Locație",
            apiRequest: "Request",
            apiResponse: "Response",
            appDetails: "Detalii despre aplicație",
            processDetails: "Detalii despre proces",
            blockchainDetails: "Detaliile despre Blockchain",
            retentionPeriod: "Perioada de retenție",
            changeRetention: "Schimbați perioada de retenție",
            deletionDate: "Data ștergerii",
            changeDeletion: "Schimbați data ștergerii",
            type: "Tip",
            duration: "Durată",
            never: "Niciodată",
            custom: "(personalizat)",
            deletionInfo: "Instanța de proces nu va fi ștearsă automat de sistem",
            invalidRetentionDate: "Vă rugăm să alegeți o dată valabilă",
            proccesInstanceId: "ID-ul instanței de proces",
            parentInstanceId: "ID-ul instanței de origine al procesului",
            confirmSavedInterface: "Numele instanței de proces a fost schimbat cu succes.",
            lastActionBy: "Ultima acțiune de către",
            startDate: "Data de început",
            lastUpdate: "Ultima actualizare",
            sentAt: "Trimis la",
            noRespAvailable: "Nu există niciun response disponibil",
            noReqAvailable: "Nu există niciun request disponibil",
            error: "Eroare",
            retry: "Reîncercare",
            retryNotify: "Reîncercați?",
            success: "Succes",
            unclaim: "Resetați",
            reassign: "Realocați",
            escalate: "Escaladați",
            suspend: "Suspendați",
            resume: "Reluați",
            terminate: "Terminați?",
            bulkTerminateMsg: "Terminând aceste instanțe de proces, ele vor fi șterse din lista de instanțe. Orice altă instanță pornită în sincron cu acestea va fi terminată.",
            viewLogs: "Vizualizați log-uri",
            viewLogsConfirm: "Vizualizați log-uri?",
            proceed: "Continuați",
            downloadLog: "Descărcați log",
            deleteBtn:"Ștergeți",
            logsMessage: "Această acțiune va deschide o legătură externă într-un nou tab",
            terminateInst: "Terminați instanța de proces",
            terminateMessage: "Terminând o instanță de proces, aceasta se va sfârși înainte de completare. De asemenea se vor termina toate insțantele active sau eșuate care au legătura cu aceasta. Toate task-urile active vor fi șterse.",
            archiveInst: "Arhivați instanța de proces",
            archiveMessage: "Arhivând o instanță de proces, aceasta va fi ștearsă din lista de instanțe. Orice altă instanță pornită în sincron cu aceasta va fi arhivată.",
            deleteInst: "Ștergeți instanța de proces",
            cancel: "Anulați",
            change: "Modifică",
            delete: "Ștergeți",
            copy: "Copiați",
            download: "Descărcați",
            downloadAll: "Descărcați toate",
            results: "Rezultate",
            startDateInst: "Data de început: ",
            lastUpdateInst: "Ultima actualizare: ",
            date: "Dată",
            traceId: "Trace ID",
            sortBy: "Sortează după",
            refresh: "Reîncarcă",
            ascending: "Ascendent",
            descending: "Descendent",
            dataModel: "Model de date",
            api: "API",
            documents: "Documente",
            richText: "Editor de Text",
            uid: "UID",
            blockchain: "Blockchain",
            messages: "Mesaje",
            assignee: "Desemnat",
            initiator: "Initiator",
            search: "Căutare",
            dataModelDetails: "Detaliile modelului de date",
            instanceName: "Numele instanței de proces",
            searchUsersAndGroups: "Căutare după utilizatori și grupuri",
            searchUsers: "Căutare utilizatori",
            archivedApplication: "Includeți aplicații arhivate",
            includeDeletedProcesses: "Includeți procesele șterse",
            deletedProcesses: "Procese șterse",
            dataModelModal: {
                modalTitle: "Editați",
                savedSuccessfully: "Salvat cu succes",
                savedUnsuccessfully: "Sintaxă JSON invalidă",
                save: "Salvați"
            },
            headerActionDots: {
                retry: "Reîncercare",
                terminate: "Terminați",
                export: "Exportați în Excel",
                archive: "Arhivați",
                delete: "Ștergeți"
            },
            apiDetails: "Detalii API",
            sorry: "Scuze",
            notAcceptedFileType: "nu este un tip de fișier acceptat.",
            documentTitle: "Detalii despre document",
            commentTitle: "Detalii despre comentarii",
            noDocsAvailable: "Nu există documente disponibile",
            noCommentsExecuted: "Nu există comentarii disponibile",
            noRichTextAvailable: "Nu există editor de text disponibil",
            richTextContentUnavailable: "Nu există conținut in editorul de text disponibil",
            isExecuted: "se execută în",
            posted: "Postat pe {event} pentru",
            lastUpdatedBy: "Ultima actualizare pe",
            by: "de către",
            canNotTerminate:
                "Doar instanțele active de proces, care au eșuat sau instanțele de origine care au fost suspendate pot fi încheiate. Vă rugăm să selectați instanțele eligibile pentru această operațiune",
            canNotRetry: "Doar instanțele de proces eșuate pot fi încercate din nou. Vă rugăm să selectați instanțele eligibile pentru această operațiune",
            canNotArchive: "Instanțele de proces active trebuie mai întâi încheiate. Doar instanțele de origine pot fi arhivate. Vă rugăm să selectați instanțele eligibile pentru această operațiune",
            canNotExport: "Vă rugăm să selectați cel puțin o instanță de proces pentru a exporta",
            candNotDelete:"Doar instanțele de proces completate, terminate sau arhivate pot fi șterse",
            dataModelField: "Câmp model de date",
            uploadedIn: "Încărcat în",
            generatedIn: "Generat în",
            generatedBy: "Generat de către",
            relatedTo: "În legătură cu",
            uidDoc: "UID",
            pathOnDisk: "Calea pe disc",
            noMessagesToBeDisplayed: "Nu sunt afișate elemente",
            deletedTooltip: "Șters de {user} la {time}",
            deleteMessage:"Conținutul a fost șters de <b>{user}</b> la {time}",
            deletedDoc: "Documentul a fost șters de <b>{user}</b> la {time}",
            messageDetails: "Detaliile mesajului",
            items: " elemente",
            toLabel: "către",
            errorToStartBigger: "'Către data de început' trebuie sa fie după 'De la data de început' !",
            errorToLastBigger: "'Către ultima actualizare' trebuie sa fie după 'De la ultima actualizare' !",
            deleteValues: "Șterge valorile",
            deleteAuditData: "Șterge toate auditurile de date",
            deleteInformationTitle: "Șterge informatiile personale",
            deletePersonalInfo: "Șterge toate datele personale",
            editIconDisabledTooltip: "Modelul de date poate fi editat doar pentru instanțele de origine ale procesului. Vă rugăm să selectați cazurile eligibile pentru această operațiune.",
            deleteDataModelDisabledTooltip: "Modelul de date poate fi șters doar pentru instanțele de origine ale procesului. Vă rugăm să selectați cazurile eligibile pentru această operațiune.",
            deleteAllDataModelDisabledTooltip: "Auditul de date poate fi șters doar pentru instanțele de origine ale procesului. Vă rugăm să selectați cazurile eligibile pentru această operațiune.",
            deleteDialog: "Ștergerea valorilor din modelul de date este permanentă si ireversibilă. Ești sigur că vrei să ștergi toate valorile stocate?",
            deleteDialogTitle: "Șterge valorile din modelul de date",
            deleteAuditDialog: "Ștergerea întregului audit de date este permanentă si ireversibilă. Ești sigur ca vrei să ștergi întregul audit de date?",
            deletePersonalInfoDialog: "Valorile atributelor etichetate ca date personale vor fi eliminate din Modelul de date, precum și din Auditurile de date ale acestei instanțe și ale oricăror instanțe secundare sincrone.",
            deleteAuditConfirmation: "Toate auditurile de date au fost șterse.",
            deleteInformationConfirmation: "Informațiile personale au fost șterse cu succes",
            deleteValuesConfirmation: "Înregistrările din auditul de date au fost șterse cu succes",
            titleApiModal: "Ștergeți datele API",
            titleBlockchainModal: "Ștergeți blockchain {type}",
            messageApi: "Conținutul acestui API {type} va fi șters permanent. Ești sigur?",
            messageBlockchain: "Conținutul acestui blockchain {type} va fi șters permanent. Ești sigur?",
            apiDelete: "API {type} a fost șters cu succes",
            blockchainDelete: "Blockchain {type} a fost șters cu succes",
            deleteDataRequest : "Ștergeți datele request",
            deleteDataResponse : "Ștergeți datele response",
            dataDeleted: "Datele au fost șterse",
            dataDeletedBy: "Datele au fost șterse de {user} la ",
            archivedStatus: "Arhivate",
            activeDoc: "Actual",
            comments: "Comentarii",
            deleteCommentsDialog: "Conținutul acestui comentariu va fi șters definitiv",
            deleteRichText: "Șterge Conținutul",
            deleteRichTextMessage: "Conținutul va fi șters permanent. Ești sigur?",
            deleteRichTextConfirmation:"Conținutul a fost șters cu succes",
            richTextStatus: "ȘTERS",
            content: "Conținut",
            deleteTitle: "Șterge comentariul",
            deleteConfirmation:"Comentariul a fost șters cu succes",
            deleteInstancesMess: "Instanța(ele) de proces și toate datele aferente vor fi șterse definitiv. Sunteți sigur?",
            cancelDeleteInst: "Anulați",
            confirmDeleteInst: "Ștergeți",
            deleteInstancesTitle: "Ștergeți {number} instanțe de proces",
            succesDelete: "{number} instanțe de proces au fost șterse cu succes",
            processInstanceName: "Nume instanță de proces",
            lastSaved: "Ultima oară salvat la",
            lastSavedBy: "Ultima oară salvat de",
            richTextDetails: "Detalii"
        },
        brandingPage: {
            nameMandatory: "Numele este obligatoriu",
            title: "Marcă",
            brandName: "Numele companiei",
            brandNameSubtitle: "Afișat ca titlu, în informații copyright și mesaje de eroare.",
            inputLabel: "Nume",
            appBuilderSubtitle: "Apare pe toate modulele de construcție ale unei aplicații",
            appBuilderLogoTitle: "Logo constructor aplicații",
            appBuilderLogo: "Formate acceptate: .jpg, .png, .svg (max 2 MB), cu un minim de mărime de 48x48 px.",
            colorCode: "Utilizează o culoare cu un contrast bun și încearcă să eviți culorile deschise.",
            colorCodeTitle: "Culoarea brandului",
            colorCodeLabel: "Codul de culoare",
            colorCodeSubtitle: "Apare pe toate pictogramele de navigare selectate.",
            navigationLogo: "Logo-ul de navigare",
            navigationLogoSubtitle: "Apare în colțul din stânga al fiecărei pagini, alături de meniul de navigare.",
            loginLogo: "Logo autentificare",
            loginLogoSubtitle: "Afișat în zona de autentificare.",
            logoInfoNav: "Formate acceptate: .jpg, .png, .svg (max 2 MB), cu un minim de mărime de 160x40 px.",
            logoInfoLogin: "Formate acceptate: .jpg, .png, .svg (max 2 MB), cu un minim de mărime de 280x60 px.",
            logoInfoFav: "Formate acceptate: .jpg, .png, .svg (max 2 MB), cu un minim de mărime de 16x16 px.",
            logoInfoApp: "Formate acceptate: .jpg, .png, .svg (max 128 KB), cu un minim de mărime de 80x80 px.",
            resetBtn: "Resetați la valorile implicite",
            uploadBtn: "Încărcați un nou logo",
            favicon: "Favicon",
            faviconSubtitle: "Afișat în filele și marcajele browser-ului.",
            uploadBtnFavicon: "Încărcați un nou favicon",
            appPlaceholderLogo: "Logo-ul implicit al aplicațiilor",
            appPlaceholderSubtitle: "Afișat ca logo implicit al aplicațiilor.",
            sizeError: "Imaginea încărcată este prea mare. Mărimea maximă admisă este 2MB.",
            sizeErrorLogo: "Imaginea încărcată este prea mare. Mărimea maximă admisă este {sizeLimit}."
        },
        settings: {
            caption: "Setările aplicației",
            highlights: "Detalii",
            userPermissions: "Utilizatori și permisiuni",
            notifications: "Notificări",
            interrogations: "Interogarile",
            importSettings: "Setări import"
        },
        navigation: {
            caption: "Administrator",
            usersRoles: "Utilizatori și grupuri",
            schedule: "Program de Lucru",
            users: "Utilizatori",
            appM: "Gestionați aplicațiile",
            docM: "Gestionați documentele",
            uiM: "Gestionați interfețe utilizator",
            mktComponents: "Marketplace",
            mktApps: "Aplicații din Marketplace",
            settings: "Setari avansate",
            notSettings: "Mesagerie & Com",
            application: "Aplicație",
            features: "Caracteristici",
            taskNotifications: "Șabloane de E-mail",
            authentication: "Autentificare",
            systemApis: "API-uri de Sistem",
            SSLCertificates: "Certificate SSL",
            logs: "Loguri"
        },
        logs: {
            titleApi: "Înregistrări apeluri API",
            descriptionApi: "Înregistrări detaliate pentru toate apelurile de API efectuate de aplicațiile Aurachain.",
            export: "Export",
            dialogTitle: "Exportați înregistrari apeluri API",
            logsMessage: "Veți fi notificat prin email imediat ce exportul a fost procesat și fișierul este gata pentru descărcare",
            allApplications: "Toate aplicațiile",
            notifyMessage: "Exportul înregistrărilor a început.  Veți fi notificat prin email imediat ce fișierul cu înregistrări este disponibil",
            titleSecurity: "Jurnal de securitate",
            descriptionSecurity: "Lista detaliată a evenimentelor legate de securitate (pornire, închidere, autentificare, schimbare parole, management al userilor etc.)",
            fromDateTimeError: "De la este obligatoriu",
            toDateTimeError: "Pana la este obligatoriu",
            titleAttachments: "Înregistrări descărcări atașamente",
            descriptionAttachments: "Înregistrări detaliate pentru toate descărcările de atașamente efectuate de aplicațiile Aurachain (sursa, user, data-ora etc.)"
        },
        dialogs: {
            delete: {
                msgSingle: "Sigur doriți să ștergeți acest element?",
                msgMultiple: "Sigur doriți să ștergeți aceste elemente?",
                confirm: "Da",
                cancel: "Nu"
            },
            roles: {
                title: "Utilizatori pentru",
                name: "Utilizator"
            },
            users: {
                title: "Roluri pentru",
                name: "Nume rol"
            }
        },
        roles: {
            modal: {}
        },
        users: {
            name: "Numele complet",
            username: "Nume de utilizator",
            email: "E-mail"
        },
        manageApps: {
            name: "Nume",
            owner: "Deţinător"
        },
        manageDocuments: {
            name: "Nume",
            owner: "Deţinător"
        },
        manageUIs: {
            name: "Nume",
            description: "Descriere",
            noDescription: "Nu este nicio descriere",
            owner: "Deţinător",
            usedOn: "Interfaţă folosită pe"
        },
        mktButtons: {
            install: "INSTALEAZA",
            remove: "STERGEȚI",
            update: "ACTUALIZAȚI",
            sync: "SYNC"
        },
        mktComponents: {
            name: "Numele componentei"
        },
        mktApps: {
            name: "Numele aplicaţiei"
        },
        notification: {
            title: "Șabloane de e-mail",
            emailTemplate: "Șablon de e-mail",
            subjectInput: "Subiect",
            editorHTMLTitle: "Email Template HTML Editor",
            htmlEditor: "Editor HTML",
            htmlEditorError: "Editorul HTML are erori. Verificați liniile marcate!",
            save: "Salvați",
            restoreDefault: "Restaurează șablonul implicit",
            newTaskTemplate: "Un nou task",
            newArchiveAppTemplate: "Arhivare aplicație",
            newArchiveInstance: "Arhivare instanță de proces",
            newAccount: "Creează un nou cont",
            shareReportsFilterTemplate: "Filtru distribuit",
            resetPassword: "Resetați parola",
            htmlName: "Șablon HTML",
            expiredDelegator: "Delegare expirată(către delegator)",
            expiredDelegate: "Delegare expirată(către delegat)",
            newDelegation: "Cerere delegare nouă",
            cancelledDelegation: "Delegare anulată",
            updateDelegationToDelegate: "Delegare modificată (către delegat)",
            updateDelegationToDelegator: "Delegare modificată (către delegator)",
            delegationAccepted: "Cerere de delegare acceptată",
            delegationRejected: "Cerere de delegare respinsă",
            delegatorReminder: "Notificare delegare primită(către delegator)",
            delegateReminder: "Notificare delegare primită(către delegat)",
            changedEmail: "Adresă de email modificată",
            changedPassword: "Parolă modificată",
            changedInformation: "Date de cont modificate",
            changedPhone: "Număr de telefon modificat",
            archiveProcess: "Arhivare proces",
            SSLExpired: "Certificat SSL expirat",
            blockchainWallet: "Portofel Blockchain",
            gdmSuccess: "Export - Depozit Date Legacy (reușit)",
            gdmFailed: "Export - Depozit Date Legacy (nereușit)",
            dataStoreSuccess: "Export - Depozit date 2.0 (reușit)",
            dataStoreFailed: "Export - Depozit date 2.0 (nereușit)",
            reportsSucces: "Export analitice (reușit)",
            reportsFailed: "Export analitice (nereușit)",
            logExportSuccess: "Export înregistrare (reușit)",
            logExportFailed: "Export înregistrare (nereușit)",
            defaultTemplate: "Implicit",
            customTemplate: "Modificat"
        },
        messagingCom: {
            title: "Mesagerie & com",
            email: "E-mail",
            sms: "SMS",
            twilio: "Twilio",
            other:"Opțiune alternativă",
            outgoingEmail: "Adresa de e-mail de ieșire",
            server: "Server SMTP",
            outgoingDisplayName: "Numele afișat aferent",
            username: "Nume de utilizator SMTP",
            pass: "Parolă SMTP",
            requiresAuthentication: "Necesită autentificare",
            useEncryption: "Utilizați criptare SMTP TLS",
            changeInfo: "Schimbați informațiile",
            testEmail: "Testare e-mail",
            accID: "ID Cont",
            authToken: "Autentificare Token",
            outgoingPhone: "Număr de telefon aferent",
            testSMS: "Testare SMS",
            save: "Salvați",
            discard: "Renunțați",
            serviceName: "Nume serviciu",
            passKey: "Parolă",
            configService: "Configurare serviciu",
            deleteService:"Ștergeți serviciul",
            deleteServiceBody: "Aceast serviciu pentru scanare fisiere va fi sters. Esti sigur?",
            serviceBodyNotSaved: "Dacă părăsiți pagina fără să salvați, schimbările vor fi pierdute. Doriți să continuați?",
            fileScanningSaved: "Serviciul de scanare fișiere a fost configurat cu succes",
            warning: "Atenție",
            mandatory: "Acest câmp este obligatoriu!",
            testEmailModal: {
                title: "Trimiteți e-mail de testare",
                properties: "Proprietățile E-mailului",
                recipients: "Destinatari",
                subject: "Subiect",
                body: "Corp",
                notification: "E-mailul a fost trimis cu succes",
                send: "Trimiteți",
                recipientsRequired: 'Campul "Destinatari" este obligatoriu',
                subjectRequired: "Subiectul este obligatoriu",
                emailValid: "Adresa de e-mail trebuie să fie valabilă"
            },
            testSmsModal: {
                title: "Trimiteți SMS de testare",
                properties: "Proprietățile SMS-ului",
                recipients: "Destinatari",
                body: "Corp",
                notification: "SMS-ul a fost trimis cu succes",
                recipientsRequired: 'Campul "Destinatari" este obligatoriu',
                mobileValid: "Numărul de mobil ar trebui să înceapă cu +"
            },
            saveNotification: "Configurările a fost salvate cu succes",
            failedPassRo: 'Conectarea la serviciul "{serviceName}" a eșuat: cheie de acces invalidă',
            failedServiceRo: 'Conectarea la serviciul "{serviceName}" a eșuat: nume serviciu invalid'
        },
        usersAndRoles: {
            title: "Utilizatori și grupuri",
            manageGroupsTitle: "Grupuri",
            createRole: "Creează un nou grup",
            addUser: "Adăugați un nou utilizator",
            searchPlaceholderUsers: "Căutare utilizatori",
            users: "Utilizatori",
            user: "utilizator",
            roles: "Grupuri",
            role: "grup",
            usersLower: "utilizatori",
            rolesLower: "grupuri",
            and: " și ",
            usersChipsInfo: "Toti utilizatorii - între 1 și 10 vor fi afișați aici",
            browseRoles: "Căutați grupuri",
            items: "elemente",
            browseUsers: "Căutați utilizatori",
            editRole: "Editați grupul",
            editUser: "Editați utilizatorul",
            roleSettings: "Setări grup",
            userSettings: "Setarile utilizatorului",
            searchPlaceholder: "Căutare utilizatori sau grupuri",
            searchPlaceholderGroups: "Căutare grupuri",
            addPermissions: "Adăugați permisiunile",
            addUsersAndGroups: "Adăugați utilizatori și grupuri",
            groupCoreDescription: "Core",
            groupTypeTD: "Utilizator definit",
            groupTPD: "Aplicația: ",
            groupsSubtitle1: "Această aplicație are ",
            groupsSubtitle2: " grup activ de utilizatori",
            groupsSubtitle3: " grupuri active de utilizatori",
            showOnlyActiveGr: "Afișați doar grupuri active",
            groupsNoGroupsSubtitle: "Această aplicație nu are grupuri de utilizatori activi!",
            usernameField: "Câmpul completat la introducerea adresei de e-mail.",
            disabledOn: "Dezactivat pe ",
            sync: "Sincronizat",
            viewAll: "Vizualizați tot",
            addRoleModal: {
                title: "Creează un nou grup",
                roleTitle: "Numele grupului",
                addPermissions: "Adăugați permisiunile",
                usersCardTitle: "Se pare că acest grup nu are membri",
                usersCardDescription: "Adăugați câteva grupuri și / sau utilizatori",
                addUsers: "Adăugați utilizatori",
                addMembers: "Adăugați utilizatori și grupuri",
                accessPermissions: "Permisiunile aplicației",
                additionalPermissions: "Permisii suplimentare",
                permissionsLabel: "Adăugat manual",
                roleError: "Numele grupului este obligatoriu",
                roleSpaceError: "Numele grupului nu trebuie să înceapă sau să se termine cu spațiu gol, sau să conțină caractere speciale",
                duplicateRoleError: "Un grup cu același nume există deja în platformă. Vă rugăm să alegeți un alt nume de grup.",
                initiator: "Ini",
                editor: "Wri",
                report: "Rep",
                deletePermission: "Ștergeți",
                PUBLISHED: "PUBLICAT",
                NOT_PUBLISHED: "NEPUBLICAT",
                UNPUBLISHED_CHANGES: "MODIFICĂRI NEPUBLICATE",
                alreadyExistName: "Numele grupului există deja!",
                selectManager: "Selectați un manager",
                selectManagerModal: "Selectați un manager",
                changeManager: "Schimbați managerul",
                noUsersManager: "Adăugați utilizatori pentru a selecta un Manager",
                typeManager: "MANAGER",
                typeLDAP: "LDAP",
                selectUsersGroups: "Selectați utilizatorii și grupurile",
                save: "Salvați",
                update: "Actualizați",
                add: "Adăugați",
                platform: "platform",
                application: "app",
                system: "sistem",
                external: "extern",
                successfulCreate: "Grupul a fost creat cu succes",
                titleNotif: "Dezactivați grupul",
                messageNotif: "Dezactivarea unui grup va elimina permanent grupul din toate locațiile în care a fost setat și din lista activă.",
                cancelBtnNotif: "Anulați",
                disableBtnNotif: "Dezactivați",
                createGroup: "Grupul a fost creat cu succes",
                dontChangePass: "Utilizatorul este dezactivat / inactiv. Înainte de a putea schimba parola, trebuie să activați utilizatorul."
            },
            addUserModal: {
                noUsersSelected: "Nu a fost selectat niciun utilizator",
                usersSelected: " utilizatori selectați"
            },
            editRoleModal: {
                title: "Editați grupul",
                parent: "Grupul părinte",
                groupStatus: "Statusul grupului",
                enableOrDisable: "Activați sau dezactivați un grup",
                disabledBy: "Dezactivat de ",
                disabledOn: " pe ",
                updateGroup: "Grupul a fost actualizat cu succes",
                disableGroup: "Grupul a fost dezactivat cu succes"
            },
            manualAddModal: {
                title: "Adăugați manual un utilizator",
                uploadImage: "Incarcați imaginea",
                firstName: "Prenumele",
                lastName: "Numele de familie",
                email: "Adresa de email",
                username: "Nume de utilizator",
                gender: "Gen",
                language: "Selectează limba",
                english: "Engleză",
                status: "Status",
                addUserBtn: "Adăugați utilizator",
                randomPass: "Generați o parolă aleatorie",
                randomPassDescription: "Utilizatorul va primi un e-mail cu o parolă generată aleatoriu. El va trebui să o schimbe după prima autentificare.",
                manualPassword: "Setați manual parola",
                password: "Parola",
                confirmPassword: "Confirmați parola",
                passwordRequirements:
                    "Parola trebuie să conțină cel puțin o literă mare, o literă mică, o cifră intre 0-9, un simbol (ex. @, # etc.) și trebuie să aibă cel puțin 10 și cel mult 128 de caractere și să nu aibă mai mult de două caractere identice consecutive (ex. aa).",
                firstNameErr: "Prenumele este necesar",
                phoneErr: "Introduceţi un număr de telefon valid care sa înceapa cu '+'",
                usernameErr: "Numele de utilizator este necesar",
                lastNameErr: "Numele este obligatoriu",
                phoneNumber: "Număr de telefon",
                occupation: "Profesie",
                organization: "Organizaţie",
                phoneError: "Numărul de telefon este obligatoriu",
                occupationError: "Ocupaţia este obligatorie",
                organizationError: "Organizaţia este necesară",
                emailErr: "E-mailul este necesar",
                emailValidErr: "Adresa de e-mail trebuie să fie valabilă",
                genderErr: "Selectarea genului este necesară.",
                passwordErr: "Parola este necesară.",
                maleGender: "Masculin",
                femaleGender: "Feminin",
                invalidEmail: "Formatul adresei de e-mail este invalid",
                emailDuplicate: "Adresa de e-mail este deja folosită",
                usernameDuplicate: "Numele de utilizator este deja utilizat",
                noRoles: "Acest utilizator nu face încă parte din niciun grup.",
                addRoles: "Adăugați grup",
                inheritedRoles: "Moștenit din grupuri",
                inheritedInfo: "Acest utilizator are următoarele permisiuni de acces moștenite de la grupurile în care este inclus:",
                specificApps: "Aplicații specifice",
                specificInfo: "Acest utilizator are următoarele permisiuni de acces, indiferent de grupurile în care este inclus:"
            },
            permissionsModal: {
                title: "Setați permisiunile",
                selectApp: "Selectați aplicația",
                levels: "Niveluri",
                initiator: "Iniţiator",
                editor: "Editor",
                reportViewer: "Vizualizator de analitice",
                app: "Aplicaţie",
                requireApps: "Vă rugăm să selectați o aplicație!",
                requirePermissions: "Nu sunt selectate permisiuni!",
                search: "Căutare",
                placeholderApplication: "Selectați aplicația",
                manualPermissions: "Permisiuni - adăugate manual",
                oneRole: "grup",
                moreRoles: "grupuri",
                saveBtn: "Salvați",
                updateBtn: "Actualizați"
            },
            addNewUserOnRole: {
                availableUser: "Utilizatori disponibili"
            },
            addNewRoleOnUser: {
                editTitle: "Selectează grup",
                done: "Terminat",
                noRoles: "Nu a fost selectat niciun grup ",
                selection: "grup selectat",
                selections: " grupuri selectate"
            },
            editUserModal: {
                title: "Editați detaliile utilizatorului",
                changePassword: "Schimbați parola utilizatorului",
                english: "Engleză",
                romanian: "Română",
                userStatus: "Statusul utilizatorului",
                active: "Activ",
                inactive: "Inactiv",
                disabled: "Dezactivat",
                savedSuccessfully: "Utilizatorul a fost actualizat cu succes",
                createdSuccessfully: "Utilizatorul a fost creat cu succes",
                errorAdmin: "Parola unui alt administrator nu poate fi modificată!",
                disabledTooltip: "Utilizatorul nu se poate autentifica, nu poate fi adăugat în grupuri sau permisiuni, și nu poate primi notificări sau task-uri.",
                inactiveTooltip: "Utilizatorul nu mai există în Active Directory",
                disabledWarningTitle: "Dezactivează utilizatorul?",
                disabledWarningMessage: "Utilizatorul nu se va mai putea autentifica și nu va mai primi notificări. Toate task-urile preluate de către utilizator vor fi resetate."
            },
            addGroupMembers: {
                addTitleModal: "Adăugați utilizatori și grupuri",
                editTitleModal: "Editați utilizatori și grupuri",
                addButtonTitle: "Adăugați",
                title: "Utilizatori și grupuri",
                searchPlaceHolder: "Căutare după utilizatori și grupuri",
                showSelectedNrs: "utilizatori",
                showSelectedNr: "utilizator",
                showSelectedGroupNr: " grup",
                showSelectedGroupNrs: "grupuri",
                inGroup: "în acest grup",
                showSelected: "selectat/ți",
                showAnd: "și",
                emptyGroup: "Nu există grupuri și utilizatori",
                emptyList: "Nimic de afișat",
                noItemsList: "Nu există elemente în listă",
                nrsUsersGroup: "utilizatori în acest grup",
                nrUsersGroup: "utilizator în acest grup",
                nrGroupGroup: "grup în acest grup",
                nrsGroupGroup: "grupuri în acest grup",
                nrGroupUsersPart1: "grup și ",
                nrGroupUsersPart2: "utilizatori în acest grup",
                ldapType: "LDAP",
                noUsersGroups: " Nu există grupuri și utilizatori în acest grup",
                noMembersAvailable: "Nu sunt membri disponibili!",
                loadMore: "Încărcaţi mai mult",
                systemUser: "Utilizator de system",
                and: "și"
            }
        },
        labs: {
            title: "Caracteristici",
            stable: "Adiţional",
            experimental: "Experimental",
            integration: "Integrări",
            KIBANA_LOG_title: "Permiteți integrarea log-ului Kibana",
            FULL_TIMELINE_title: "Afișați intreaga cronologie",
            APP_UPDT_title: "Actualizare aplicație",
            ALLOW_MULTILANGUAGE_title: "Permiteți selectarea limbii",
            ACCESSIBILITY_title: "Accesibilitate",
            DESIGN_title: "Migrează către serviciul de design",
            INTEGRATION_V2_title: "Migrează integrările",
            INTEGRATION_V2_description: "Migrează integrările la V2",
            MULTI_SC_title: "Migrează către multiple SmartContracte",
            ALLOW_TWO_FACTOR_title: "Securizează conturile cu autentificarea în doi pași",
            REPLACE_BASE64_IMAGE_title: "Înlocuiește toate imaginile base64 din șabloane cu URL-uri",
            FILE_SCANNING_title :"Scanarea fișierelor",
            ENABLE_AI_title: "Permite asistența AI pentru scripturi",
            ENABLE_AI_description: "Permite asistența ChatGPT pentru modulul Interfețe Utilizator",
            ENABLE_ASSISTANT_title: "Permite asistența AI pentru task-uri",
            ENABLE_ASSISTANT_description: "Permite asistența ChatGPT pentru utilizatorii aplicației",
            enableAI: "Permite AI",
            configuration: "Configurare",
            apiKey: "Cheie API",
            chatDeploymName: "Numele implementării chatului",
            embeddingDeploymName: "Încorporarea numelui implementării",
            url: "URL",
            aiDialogTitle: "Atenție",
            configure: "Configurează",
            editConfiguration: "Editează configurarea",
            TASK_DELEGATION_title: "Delegarea task-urilor",
            KIBANA_LOG_description: "Permite administratorilor să deschidă log-urile în Kibana din Inspector procese.",
            APP_UPDT_description: "Actualizează aplicații importate din alte medii.",
            FULL_TIMELINE_description:
                "Afișați intregul audit al utilizatorilor in fereastra task-ului. Utilizatorii vor putea vizualiza auditul pentru toate activitățile de proces inclusiv cele de sistem.",
            ALLOW_MULTILANGUAGE_description: "Permiteți utilizatorilor să selecteze o altă limbă în afară de cea implicită.",
            ACCESSIBILITY_description: "Folosește o temă de culori conformă cu standardele de accesibilitate.",
            REPLACE_BASE64_IMAGE_description:
                "O singură utilizare! Această funcționalitate salvează imaginile base64 pe server și expune un URL pentru a fi consumat.",
            TASK_DELEGATION_description: "Permiteți utilizatorilor înregistrați să-și delege sarcinile atât timp cât aceștia nu sunt disponibili.",
            GDM_title: "Depozit de date",
            legacy: "Legacy",
            DESIGN_description: "Migrează datele vechi către serviciul de design.",
            GDM_description: "Permiteți utilizatorilor să aibă acces la zona depozitului de date și să gestioneze tabelele de date.",
            GDM_false_tooltip:
                "Vă rugăm să vă contactați administratorul. Pentru a utiliza această caracteristică, trebuie verificate unele condiții tehnice preliminare",
            GDM_true_tooltip: "Funcționalitatea 'Depozit de date' este activată",
            MULTI_SC_description: "O singură utilizare! Dacă este activ, toate aplicațiile blockchain vor fi actualizate astfel incât să permită multiple SC.",
            ALLOW_TWO_FACTOR_description: "Adaugă un nivel în plus de securitate. De fiecare dată când utilizatorii își introduc parola, vor primi și un cod de validare prin SMS.",
            SIGNUP_title: "Permite înscrierea publică",
            SIGNUP_description: "Permite utilizatorilor publici să creeze conturi de platformă prin înregistrare publică.",
            FILE_SCANNING_description: "Configurați comportamentul de scanare a fișierelor pentru fișierele încărcate pe platformă",
            additionalDescription: "Unele funcții din {brandName} sunt activate numai la cerere. Sunt caracteristici stabile care pot fi activate sau dezactivate, în funcție de nevoile utilizatorilor.",
            experimentalDescription: "{brandName} oferă mai multe caracteristici beta cunoscute sub numele de Experimental, care sunt modalități noi și interesante de a vă îmbunătăți aplicațiile. Rețineți că, atunci când utilizați o caracteristică experimentală, sunteți de acord să utilizați o caracteristică care nu a fost testată în întregime și poate avea unele erori.",
            additionalEmptyState: "Nu există funcții suplimentare disponibile în acest moment",
            experimentalEmptyState: "Nu există funcții experimentale disponibile în acest moment",
            integrationEmptyState: "Nu există funcții de integrare disponibile în acest moment",
            updateApplication: "Actualizați aplicația",
            updateApp1: "Versiunea curentă(aplicația existentă) va fi înlocuită de cea actualizată (din arhivă).",
            updateApp2: "Actualizările se produc în toate modulele de construcție.",
            updateApp3: "Elementele noi vor fi adăugate versiunii curente.",
            updateApp4: "Elementele șterse din arhivă nu vor fi șterse în momentul actualizării - vor rămâne așa cum sunt.",
            featureCancel: "Anulați",
            featureSave: "Salvează configurarea",
            featureStatusTitle: "Activat",
            dialogTitle: "Modificări nesalvate",
            dialogMessage: "Dacă părăsești această pagină, orice modificare facută se va pierde.\n Ești sigur că vrei să te intorci la pagina de Caracteristici?",
            disclaimerAI: "Atenție: textul introdus de către creatorii de aplicații atunci când editează un script folosind această funcționalitate va fi trimis către un furnizor de servicii terț împreună cu întreg conținutul script-ului. Vă rugăm să vă asigurați că organizația Dvs. permite utilizarea ChatGPT.Activând această funcționalitate, confirmați că întelegeți și sunteți de acord cu riscurile de a transmite informații confidențiale sau sensibile. Aurachain nu poate fi trasă la răspundere pentru eventualele pierderi, pagube, sau consecințe apărute în urma transmiterii de astfel de informații către OpenAI.",
            disclaimerTaskAI: "Atenție: această funcționalitate poate permite utilizatorilor Aurachain să trimită documente către OpenAI sau Azure (în funcție de configurație).Vă rugăm să vă asigurați că organizația Dvs. permite utilizarea ChatGPT.Activând această funcționalitate, confirmați că înțelegeți și sunteți de acord cu riscurile de a transmite informații confidențiale sau sensibile.Aurachain nu poate fi trasă la răspundere pentru eventualele pierderi, pagube, sau consecințe apărute în urma transmiterii de astfel de informații către OpenAI.",
            disclaimerAIDialog: "Textul introdus de către creatorii de aplicații atunci când editează un script folosind această funcționalitate va fi trimis către un furnizor de servicii terț împreună cu întreg conținutul script-ului. Vă rugăm să vă asigurați că organizația Dvs. permite utilizarea ChatGPT.Activând această funcționalitate, confirmați că întelegeți și sunteți de acord cu riscurile de a transmite informații confidențiale sau sensibile. Aurachain nu poate fi trasă la răspundere pentru eventualele pierderi, pagube, sau consecințe apărute în urma transmiterii de astfel de informații către OpenAI.",
            discaimerTaskAIDialog: "Această funcționalitate poate permite utilizatorilor Aurachain să trimită documente către OpenAI sau Azure (în funcție de configurație).Vă rugăm să vă asigurați că organizația Dvs. permite utilizarea ChatGPT.Activând această funcționalitate, confirmați că înțelegeți și sunteți de acord cu riscurile de a transmite informații confidențiale sau sensibile.Aurachain nu poate fi trasă la răspundere pentru eventualele pierderi, pagube, sau consecințe apărute în urma transmiterii de astfel de informații către OpenAI.",
            noAIConfiguration: "Neconfigurat",
            warningMessage: "Dacă părăsiți pagina înainte de salvare, modificările dvs. se vor pierde. Sunteți sigur că vreți să continuați?",
            warningTitle: "Avertizare!",
            configured: "Configurat",
            errorTitleAi: "Configurează opțiunea de asistent AI pentru scripting",
            errorTitleTaskAi: "Configurează opțiunea de asistent AI pentru documente",
            agreementConfirmation: "Sunt de acord",
            mandatoryField: "Acest câmp este obligatoriu",
            limitExceeded: "Limita de tokens pentru ChaGPT a fost depașită. încearcă să scurtezi cerința.",
            cannotReach: "Serviciul de AI nu este disponibil. Vă rugăm să contactați un administrator.",
            genericError: "A avut loc o eroare necunoscută.",
            apiAuthentificationError: "Serviciul de AI nu este disponibil. Vă rugăm să contactați un administrator.",
            publicEnrollment: {
                title: "Procesul de auto-înrolare",
                noSignUpApps: "Nu există aplicații publicate cu acces la API-ul Users.",
                signUpEmptySubtitle: "Pentru a permite accesul unei aplicații la API-ul Users, vizitați pagina Internal APIs",
                labelBtn: "Selectați procesul",
                changeAppBtn: "Schimbați procesul",
                modalTitle: "Permite înscrierea publică",
                modalSubTitle: "Aplicații eligibile",
                processesSubTitle: "Procese eligibile",
                code: "Cod:",
                errorTitle:"Selectați o aplicație pentru înscrierea publică.",
                noProcessToDisplay: "Aplicația selectată nu are niciun proces eligibil disponibil."
            },
            scanningService: {
                title: "Adaugare serviciu",
                editTitle: "Editare serviciu",
                subtitle: "Configurare"
            }
        },
        authentication: {
            enforce: "Single Sign-On",
            infoSSO: "Permite user-ilor să se logheze prin intermediul unui Identity Provider SAML sau OpenID Connect.",
            firstStep: "Selectează protocolul",
            secondStep: "Endpoint-uri",
            identityProvider: "Identity provider",
            configurationDoneToast: "{provider} configurat cu succes!",
            ssoDoneToast: "Conectare unică pornita!",
            ssoDisableToast: "Conectare unică oprita!",
            samlDomain: "Domeniu",
            clientId: "ID client",
            clientSecret: "Secret",
            configurationUrl: "URL configurare",
            viewConfig: "Vezi configurația",
            samlDetails: "Detalii SAML",
            openIdDomain: "Configurație OpenID Connect",
            openIdDomainDescription: "Furnizați informațiile de mai jos pentru efectuarea configurației",
            uploadArea: "ZONA UPLOAD",
            redirectURL: "URL redirectare autorizare",
            logoutURL: "URL logout",
            openIdDetails: "Endpoint-uri OpenID Connect",
            openIdDetailsDescription: "Folosiți informațiile de mai jos pentru a configura providerul de tip OpenID Connect",
            configurationFile: "Fișier configurare",
            dialogTitle: "Dezactivați conectarea unică?",
            turnOffBtn: "Dezactivează",
            dialogMessage: "Dupa dezactivarea conectării unice, userii corespunzători domeniului definit în configurație vor fi convertiți în useri obișnuiți.",
            deleteDialogTitle: "Ștergere configurație",
            deleteDialogMsg: "Sunteți sigur că doriți să ștergeți această configurație?",
            configurationFirstInfo: "Obține un fișier de configurare XML din providerul SAML.",
            autoProvisioningSSO: "Creați automat conturi externe pentru utilizatorii noi (sărind peste procesul de auto-înscriere, dacă există)",
            configurationSecondInfo: "Fișierul de configurare trebuie să conțină certificatul providerului, ID-ul entității sau emițătorul și URL-ul de redirect.",
            samlDetailsDescription: "Folosiți informațiile de mai jos pentru a configura providerul SAML.",
            samlDomainDescription: "Adresele de e-mail ce corespund acestui domeniul vor fi redirectați către providerul de conectare unic definit. După autentificare, dacă există deja un user, acesta va deveni user extern.",
            oidcInfoUrls: "Furnizați ID-ul client-ului, secretul client-ului, și un URL de configurație (OpenID Connect Discovery) care conține o configurație validă OpenID Connect.",
			simpleNext: "Pasul următor",
            previousStep: "Înapoi",
            ldapInfoText: "O configurație LDAP a fost detectata. Conectarea unică nu poate fi utilizată atâta timp cât există o configurație de LDAP activă. Vă rugăm contactați departamentul IT pentru mai multe informații.",
            downloadMetadata: "Descarcă fișierul de configurare",
            domainError: "Domeniul nu poate fi gol",
            duplicateDomainError: "Domeniul este deja folosit",
            clientIdError: "ID-ul client nu poate fi gol",
            clientSecretError: "Secretul client nu poate fi gol",
            configUrlError: "URL-ul nu conține o configurație validă",
            disableConfiguration: "Nu există o configurație validă",
            metadataInfoTitle: "Fișier metadate provider conectare unică",
            thirdStep: "Încheie configurarea",
            selectProvider: "Selectați protocolul de autentificare",
            samlProviderTitle: "Conectare unică prin SAML",
            samlProviderDescription: "Configurează conectarea unică prin intermediul unui provider SAML",
            openIdProviderTitle: "OpenID Connect",
            openIdProviderDescription: "Configurează conectarea unică prin intermediul unui provider Open ID connect",
            providerID: "ID entitate provider servicii ",
            providerURL: "Service Provider Assertion Consumer Service URL/SP Login URL ",
            providerMessage2: "către Identity Provider.",
            labelURL: "Service Provider Assertion Consumer Service URL",
            urlLogoutLabel: "Single log-out (SLO) URL",
            logoutUrlTooltip: "Adresa URL pe care furnizorul de identitate o poate folosi pentru a deconecta utilizatorii din {brandName}",
            and: "și ",
            next: "Următorul pas",
            copyClipboard: "Conținutul a fost copiat cu succes!",
            copyToClipboardCustomMsg: " a fost copiat cu succes!",
            fileNameCopyClipboard: "Numele fișierului a fost copiat!",
            metadataInfo:
                "Utilizatorul trebuie să încarce fișierul XML de metadate al Identity Provider care conține certificatul Identity Provider, ID-ul / emitentul de entitate și adresa URL de redirecționare.",
            finishInfo:
                "Vă rugăm să vă asigurați că pașii dvs. sunt urmați corect pentru configurarea conexiunii dvs. SAML. Puteți arunca întotdeauna o privire pe pasul anterior pentru a confirma că totul este în regulă.",
            readyInfo:
                "Acum sunteți gata să vă conectați cu SAML SSO și toate solicitările de conectare vor fi redirecționate către Identity Provider-ul dvs. . Dacă doriți să editați configurația, vă rugăm să apăsați mai jos.",
            domainName: "Numele Domain-ului*",
            editConfig: "Editați configurarea",
            providerIDTooltip:
                "Identificatorul SAML care numește în mod unic {brandName}. Acest ID de entitate este, de asemenea, cunoscut ca Service Provider Issuer sau audiență.",
            providerURLTooltip: "URL-ul unde {brandName} ascultă cererile de la Identity Provider",
            domainTooltip: "Domeniul este utilizat pentru impunerea utilizatorilor de domeniu să se conecteze cu SAML SSO",
            identityMetadata: "Identity Provider metadata XML",
            logoutSAMLError: "Sesiunea curentă a expirat, vă rugăm să vă autentificați pentru a continua în aplicație.",
            uploadTitle: "Fișier încărcat",
            usedFile: "Fișier utilizat",
            active: "Activ",
            identityProviderName: "Numele furnizorului de identitate",
            domainText: "Redirecționați utilizatorul pe baza domeniului de e-mail",
            domainInfo: "Toate numele de utilizator cu acest domeniu de e-mail vor fi redirecționate către acest furnizor de identitate pentru autentificare.",
            continueWith: "Afișați butonul “continuați cu”",
            continueWithInfo: "Afișați un buton dedicat pe ecranul de conectare pentru acest furnizor de identitate",
            iconInfo: "Formate acceptate:.jpg,.png,.svg (max 2 MB), cu o dimensiune minimă de 24x24 px.",
            label: "Etichetă",
            labelError: "Eticheta nu poate fi goală",
            icon: "Icoană",
            resetToDefault: "Resetați la valorile implicite",
            uploadNewLogo: "Încărcați logo-ul nou"
            
        },
        systemApis: {
            title: "API-uri de sistem",
            users_apiTitle: "Utilizatori și grupuri",
            users_apiDescription:"Permite aplicațiilor să creeze și să gestioneze utilizatori și grupuri",
            series_apiTitle: "Serie",
            series_apiDescription:"Permite aplicațiilor să genereze o secvență distinctă de numere unice pentru fiecare serie definită",
            downloadLog: "Descarcă înregistrare",
            defaultDesc:"Acest api nu este activat pentru nici o aplicație",
            enabledDescription: "Acest api este activat pentru {counter} aplicație | Acest api este activat pentru {counter} aplicații",
            addAppBtn: "Adauga aplicație",
            appPermissions: "Permisiunile aplicației",
            appTitle: "Aplicații",
            selectApp: "Selectați aplicația",
            methods: "Metode",
            CHECK_USERDescription: "Permite verificarea existenței utilizatorului",
            GET_USERDescription: "Permite obținerea utilizatorului",
            ADD_USER_TO_GROUPDescription: "Permite adăugarea utilizatorului în grup",
            ADD_USERDescription: "Permite adăugarea de utilizatori noi",
            appSuccessfully:"Permisiuni adăugate cu succes",
            appSuccessUpdated:"Permisiuni actualizate cu succes",
            appError:"A apărut o eroare la salvarea permisiunii.",
            notifAppDelete:"Permisiuni șterse cu succes",
            messageTitle:"Stergere permisiune",
            messageBody:"Sunteți sigur că doriți să ștergeți această permisiune ?",
            messageTitleNoDelete:"Această aplicație este utilizată ca aplicație de auto-înrolare. Vă rugăm să dezactivați auto-înrolarea sau alegeți altă aplicație pentru auto-înrolare în Admin > Caracteristici."
        },
        SSLCertificates: {
            title: "Certificate SSL",
            tableTitle: "Autorități de certificare de încredere",
            upload: "Încărcați un certificat nou",
            issuedBy: "Emis de",
            issuedTo: "Emis către",
            name: "Nume",
            addedOn: "Adăugat la",
            download: "Descărcați",
            expirationDate: "Data de expirare",
            status: "Status",
            delete: "Ștergeți",
            retrieveForURL: "Preluarea certificatului pe baza URL",
            retrieveCertificate: "Preluare certificat",
            retrieveFromServer: "Preluarea certificatului de autoritate din server",
            serverURL: "Server URL",
            deleteCertificate: "Ștergeți Certificatul",
            confirmDelete: "Certificatul va fi șters permanent din platformă. Sunteți sigur?",
            uploadCertificates: "Încărcați certificate",
            successfullyAdded: "Certificat adăugat cu succes. Înregistrarea poate dura până la 1 minut.",
            successfullyDeleted: "Certificatul a fost șters cu succes."
        }
    },
    diagrams: {
        gridText: "Afișează grila",
        bridgesText: "Afișați punțile conector",
        labelsText: "Afișați etichetele",
        gridTooltip: "Afișează sau ascunde modelul de fundal din spatele activităților și conectorilor",
        bridgesTooltip: "Afișați sau ascundeți un marcator vizual atunci când conectorii se suprapun",
        diagram: "Setări diagramă",
        performanceInfo: "Performanța diagramei a fost îmbunătățită. Punți de conectare ascunse. Reactivați din meniul cu trei puncte din dreapta jos.",
        uiTitle: "Diagrame",
        activities: "Activități",
        events: "Evenimente",
        gateways: "Gateway-uri",
        confirmActivation: "Ultima aplicație salvată va fi publicată. Continuați?",
        appActivated: "Aplicația a fost publicată cu succes",
        duplicatedCode: "Există deja un cod numit {name}",
        untitledConnector: "Conector fără titlu",
        connectorType: "Conector",
        errorMenuTitle: "Aplicația nu poate fi publicată - Au fost găsite erori",
        hintsErrorsEmptyState: "Aici veți vedea sugestiile sau erorile legate de proces",
        task: "Task",
        decisions: "Decizii",
        externalTask: "Task extern",
        generateDoc: "Generează documente",
        callAPI: "Apelează API",
        process: "Proces",
        advLogic: "Logică avansată",
        start: "Start",
        startExt: "Start din exterior",
        end: "Final",
        expAPI: "Expune API",
        exclusiveGate: "Poartă decizională",
        parallelGate: "Poartă paralelă",
        joinGate: "Poartă de joncțiune",
        blockchain: "Blockchain",
        dataExp: "Exportare date",
        blockEv: "Eveniment Blockchain",
        blockStart: "Start Blockchain",
        pluginDescription: {
            name: "Proprietățile obiectului",
            noPluginSelected: "Nu este selectat niciun obiect. Alegeți unul din bara laterală din stânga pentru a afla mai multe despre proprietățile sale",
            noneSelected: "Nici unul"
        },
        turnaroundTime: {
            title: "Timpul de rotație",
            modalTitle: "Statistici",
            liveApps: "Aplicaţii live ",
            app: "Aplicaţie",
            reference: "Referinţă",
            currentPeriod: "Perioada curentă",
            variation: "Variație",
            lastPeriod: "Ultima perioadă",
            stage: "Etapă",
            week: "Săptămână",
            month: "Lună",
            year: "An"
        },
        thresholds: {
            title: "Praguri",
            attention: "Pragul de atenție",
            warning: "Pragul de avertizare",
            showStage: "Aratati stage lights",
            filters: "Filtre",
            dataModel: "Model de date",
            value: "Valoare",
            reset: "Resetează filtrul",
            filter: "Filtru"
        },
        appTracer: {
            title: "Urmărirea aplicațiilor"
        },
        canvasElements: {
            name: "Elementele canvas",
            details: "Detalii",
            targets: "Target-uri",
            users: "Atribuire",
            rules: "Reguli",
            levels: "Niveluri",
            external: "Task-uri externe dinamice"
        },
        components: {
            valueRequired: "Această valoare este obligatorie",
            label: "Etichetă",
            statusName: "Numele statusului",
            statusCode: "Codul statusului",
            code: "Cod",
            description: "Descriere",
            deadline: "Termen limită",
            timeToDeadline: "Timpul până la termenul limită",
            expirationFrame: "Interval de timp",
            expirationTitle: "Comportamentul de expirare",
            processBeh: "Comportamentul procesului",
            selectTarget: "Selectați target",
            expiration: "Timpul până la expirare",
            expirationTarget: "Target-ul de expirare",
            expirationBehaviour: "Comportamentul de expirare",
            errorTime: "Acest câmp este obligatoriu",
            errorTimeUnit: "Selectați unitatea de timp",
            target: "Selectați un target",
            settings: "Setări",
            expirationTime: "Timpul de expirare",
            minutes: "Minute",
            hours: "Ore",
            days: "Zile",
            approvalEvent: "Decizii privind matricea de aprobare",
            approve: "Aprobare",
            autoApprove: "Aprobare automată",
            reject: "Respinge",
            autoReject: "Respingere automată",
            approvalMDecision: "Alocă decizii",
            decisionOverride: "Decizia este deja folosită și va fi atribuită aici",
            onlyNumeric: "Numai caractere numerice",
            maxValue: "Valoarea maximă este ",
            emptyOpt: "Gol/Nul",
            empty: "Gol",
            todayOpt: "Azi",
            alwaysOpt: "Mereu",
            taskPriority: {
                priorityLevel: "Nivel de prioritate",
                lowest: "Cel mai scăzut",
                low: "Scăzut",
                normal: "Normal",
                high: "Ridicat",
                highest: "Cel mai ridicat"
            },
            deadlineExpiration: {
                cardtitle: "Termenul limită și expirare",
                defaultNotification: "Fără notificări",
                notificationNumber: "Nicio notificare | O notificare setată | {count} notificări setate",
                modalTitle: "Setează termenul limită și expirare",
                modalTitleExpiration: "Comportamentul de expirare",
                title: "Termenul limită și comportamentul de expirare",
                defaultCreation: "creationDateTime",
                chipType: "Task",
                modType: "MOD",
                timeTodead: "Timpul limită",
                timeToExpiration: "Timpul până la expirare",
                defaultDeadline: "termenul limită",
                extraTextDeadline: "Dacă termenul limită nu poate fi determinat, atunci sistemul va folosi ",
                extraTextAfter: "pentru a seta termenul limita.",
                activateExpiration: "Adăugati comportament de expirare",
                description: "Termenul limită va fi depășit ",
                descriptionGen: "Termenul limită va fi depășit la {customTime} ",
                descriptionGen1: "Termenul limită va fi depășit după {customTime} ",
                after: "după ",
                from: "de la",
                generalInfoDeadFrom: "de la crearea taskului.",
                generalInfoDead: " după crearea taskului.",
                generalInfoExp: "termenul limită și procesul va urma ruta {plugin}.",
                generalInfoExpExpose: "crearea taskului și procesul va urma ruta {plugin}.",
                d: "zi",
                ds: "zile",
                h: "oră",
                hs: "ore",
                m: "minut",
                ms: "minute",
                descriptionExpiration1: "Taskul expiră după",
                descriptionExpiration1After: "Taskul expiră la {customTime} după ",
                descriptionExpiration2: "Dacă timpul de expirare nu poate fi determinat sau se află în trecut sistemul va folosi ",
                descriptionExpiration3: " pentru a seta timpul de expirare.",
                processFollow: " și procesul va urma ruta {plugin}.",
                behaviourFollow: " și procesul va urma comportamentul {plugin}",
                defaultDescription: "Nu este configurat.",
                selectTarget: "Selectează ruta",
                errorTarget: "Vă rugăm să selectați o rută pentru expirarea taskului",
                deadlineError: "Valorea termenul limită este obligatorie pentru a salva configurația",
                expirationError: "Valorea termenul de expirare este obligatorie pentru a salva comporatamentul expirarii",
                deadlineFormat: "Valorile trebuie sa fie de forma: 3d 20h 30m",
                activateSchedule: "Folosiți programul de lucru"
            },
            setGui: {
                assignUi: "Atribuire interfață utilizator",
                assignedUi: "Interfață utilizator atribuită",
                availableUis: "Interfețe utilizator disponibile ",
                unassigned: "Nedesemnat",
                createdBy: "Creat de",
                createNew: "Creează o nouă interfață utilizator",
                currAssignment: "În prezent este repartizată la: {nrItems} articole",
                addInterface: "Adăugați interfață utilizator",
                wasNotAssigned: "Neutilizată",
                wasAssigned: "Utilizată într-un singur loc | Utilizată în {count} locuri",
                nothing: "Nimic de afișat",
                nothingDetails: "Nu există interfețe utilizator disponibile",
                notResultsFound: "Niciun rezultat găsit",
                notResultsDetails: "Căutarea dumneavoastră nu a returnat nicio interfață utilizator"
            },
            configApi: {
                apiSettings: "Setări API",
                errModalTitle: "Cale",
                errDetailsTitle: "Detalii despre eroare",
                errNumber: "Numărul erorii",
                errDescription: "Descrierea erorii",
                configExposeApi: "Configurați API-ul expus",
                configured: "Configurat",
                clientsDefined: "clienți definiți",
                client: "client",
                rulesDefined: "reguli definite",
                configApi: "Configurați API",
                configParameter: "Configurați parametrul",
                customHeaderErrorValue: "Numele este deja folosit în configurația curentă",
                emptyNameError: "Numele nu poate fi gol",
                selectValueDataModel: "Selectați valoarea",
                customDataTab: "Date personalizate",
                deleteRuleTitle:"Ștergeți regula evenimentului blockchain",
                valueCustomDataInput: "Valoare",
                deleteRuleBody: "Această regulă va fi ștearsă definitiv. Esti sigur?",
                noActionTitle: "Vă rugăm să configurați",
                addBtn: "Adăugați",
                error: "Eroare",
                errEditor: "Editor de eroare",
                addRules: "Adăugați o regulă nouă",
                ruleEditor: "Editor de regulă",
                actionError: "Acțiune(Obligatorie)",
                apiLabel: "Selectați API",
                metLabel: "Selectați metoda",
                reqTitle: "Solicitare",
                respTitle: "Răspuns",
                noDataModel: "Fără câmp din modelul de date",
                respTab: "Răspuns",
                errors: "Erori",
                noPath: "Acest câmp este obligatoriu!",
                placeholder: "Niciun model de date",
                selectApi: "Selectați răspunsul API",
                respEqual: "Egal",
                busiTitle: "Setați reguli",
                apiFrom: "De la Api către",
                actionErr: "Selectați calea",
                defaultPath: "Selectați calea implicită",
                selectAction: "Selectați calea de acțiune",
                selectResp: "Selectați răspunsul",
                addNewApi: "Adăugați o condiție nouă",
                addNewConsumedApiTitle: "Creați un API extern",
                editConsumedApiTitle: "Editați un API extern",
                addNewExposedApiTitle: "Creați credențiale pentru API-uri expuse",
                editExposedApiTitle: "Editați credențiale API",
                newTab: "Nou",
                customHeaderNotAvailable: "Nu este disponibil pentru API-ul selectat",
                customHeadersErrorMapping: "Vă rugăm să mapați parametrii de request și response pentru custom headers",
                errorApiResponse: "Vă rugăm să selectați răspunsul Api!",
                warningRequest: "Vă rugăm să adăugați parametrii de solicitare!",
                warningResponse: "Vă rugăm să adăugați parametrii de răspuns!",
                warningDefultPath: "Vă rugăm să specificați o cale",
                warningError: "Vă rugăm să adăugați acțiuni pentru erori",
                errRule: "Vă rugăm să adăugați condiții",
                errRuleValues: "Vă rugăm să adăugați valori pentru condițiile dumneavoastră",
                defaultPathsub: "Calea implicită",
                custoRules: "Reguli personalizate",
                errorsSub: "Erori",
                warningRequestResponse: "Vă rugăm să adăugați parametrii de solicitare și răspuns!",
                configuration: "Configurație",
                apiNotFound: "API-ul mapat (\"{name}\") nu au fost găsit!"
            },
            exposeApi: {
                titleModalActionRules: "Editor de reguli de acțiune",
                titleModalDefault: "Setați calea implicită",
                actionRulesCardTitle: "Reguli pentru acțiuni",
                paths: "Căile disponibile",
                requestSectionSubtitle: "Cerere",
                requestSectionTitle: "Definiți cererea",
                noRequests: "Nicio cerere definită",
                configuration: "Configurație",
                defineRequestModalTitle: "Definiți cererea",
                continueLabel: "Continuați",
                skipLabel: "Săriți",
                backLabel: "Înapoi",
                finishLabel: "Finalizare",
                defineValidationRules: "Definiți regulile de validare",
                rules: "Reguli",
                addRules: "Adăugați reguli pentru validare",
                addAction: "Adăugați reguli pentru acțiune",
                actionName: "Numele regulii",
                ruleHighlights: "Detaliile regulii",
                actionRulePath: "Calea regulilor de acțiune",
                validationRuleEditor: "Editor de reguli de validare",
                addBtn: "Adăugați",
                updateBtn: "Actualizați",
                setError: "Stabiliți eroarea",
                errorMessage: "Mesaj de eroare",
                error418: "Sunt un ceainic",
                error400: "Cerere greșită",
                error500: "Eroare internă a serverului",
                default: "Mod implicit: ",
                search: "Căutare după numele stadiului",
                searchAPICredentials: "Căutare credențiale API",
                skipBtn: "Săriți",
                configExpose: "Configurați API-ul expus",
                finishStep: "Finalizați pasul ",
                API_PLUGINCODE: "CA",
                EXTERNAL_PLUGINCODE: "ET",
                GENERAL_END_PLUGINCODE: "GE",
                TASK_PLUGINCODE: "HT",
                APPROVAL_PLUGINCODE: "AM",
                DATA_EXPORT_PLUGINCODE: "DE",
                GENERATE_DOCUMENT_PLUGINCODE: "GD",
                EXPOSE_API_PLUGINCODE: "EA",
                BLOCKCHAIN_PLUGINCODE: "BC",
                JOIN_GATEWAY_PLUGINCODE: "JG",
                EXCLUSIVE_GATEWAY_PLUGINCODE: "EG",
                PARALLEL_GATEWAY_PLUGINCODE: "PG",
                PROCESS_PLUGINCODE: "PR",
                API_PLUGINNAME: "Apelaţi Api",
                EXTERNAL_PLUGINNAME: "Task extern",
                GENERAL_END_PLUGINNAME: "Sfârșit",
                TASK_PLUGINNAME: "Task uman",
                APPROVAL_PLUGINNAME: "Decizii",
                DATA_EXPORT_PLUGINNAME: "Export de date",
                GENERATE_DOCUMENT_PLUGINNAME: "Generare documente",
                EXPOSE_API_PLUGINNAME: "Api Expus",
                BLOCKCHAIN_PLUGINNAME: "Blockchain",
                JOIN_GATEWAY_PLUGINNAME: "Join Gateway",
                EXCLUSIVE_GATEWAY_PLUGINNAME: "Exclusive Gateway",
                PARALLEL_GATEWAY_PLUGINNAME: "Parallel Gateway",
                PROCESS_PLUGINNAME: "Process",
                errorType: "EROARE 400",
                errorType2: "EROARE 418",
                errorType3: "EROARE 500",
                addExposedClients: "Gestionați credențialele",
                exposedClientsTitle: "Credențiale API-uri expuse",
                noClients: "Nu sunt definite credențiale pentru API-ul expus. Vă rugăm să adăugați credențiale pentru a permite accesul la acesta."
            },
            instanceName: {
                assignInstanceName: "Numele instanței de proces",
                customInstanceName: "Numele personalizat al instanței de proces",
                errorMsg: "Numele instanței de proces conține caractere invalide."
            },
            taskSubject: {
                assignTaskSubject: "Subiectul task-ului",
                customTaskSubject: "Subiectul task-ului personalizat",
                errorMsg: "Subiectul task-ului conține caractere invalide.",
                limitMsg: "Limita de caractere a fost depășită"
            },
            setProcess: {
                setProcessLabel: "Selectați un proces",
                noProcessLabel: "Procese",
                nothingDisplay: "Nimic de afișat",
                subtitle: "Nu există elemente în această listă",
                addProcessBtn: "Adăugați un proces",
                syncProcess: "Modul de executare:",
                syncProcessOpt: "Sincron",
                asyncProcessOpt: "Asincron",
                syncInfoTooltip: "Procesul principal așteaptă finalizarea procesului selectat.",
                asyncInfoTooltip: "Procesul principal nu așteaptă finalizarea procesului selectat.",
                publishedTooltip: "Acest proces este publicat și actualizat.",
                unpublishedTooltip: "Acest proces este nepublicat.",
                unpublishedChangesTooltip: "Acest proces are modificări nepublicate.",
                archivingTooltip: "Acest proces este în curs de arhivare.",
                configDataLabel: "Configurați datele moștenite",
                inheritedDataLabel: "Datele moștenite"
            },
            advancedLogic: {
                configureTitle: "Configurează",
                configModalTitle: 'Configurează "Logică avansată"',
                editorTitle: "{name} editor",
                configured: "Configurat",
                closeTitle: "Avertizare",
                closeMsg: "Sunteți sigur că vreți să părăsiți pagina? Veți pierde toate modificările!",
                deleteTitle: "Eliminați",
                deleteMsg: "Această acțiune va elimina configurația de logică avansată!",
                saveTitle: "Avertizare",
                saveMsg: "Scriptul are erori. Ești sigur că vrei să salvezi?",
                successMsg: "Logică avansată configurată cu succes.",
                emptyMsg: "Nu poate fi salvat un script gol"
            },
            recurrence: {
                title: "Recurență",
                description: "Configurează",
                remove: "Ștergeți",
                nextPublish: "Folosește urmatoarea dată de publicare ca dată de activare",
                activationDate: "Data de activare",
                processStart: "Timpul de începere al procesului",
                repeat: "Repetă în fiecare",
                endDate: "Data de încheiere",
                Day: "Zi",
                Week: "Săptămână",
                Month: "Lună",
                Year: "An",
                Monday: "Luni",
                Tuesday: "Marți",
                Wednesday: "Miercuri",
                Thursday: "Joi",
                Friday: "Vineri",
                Saturday: "Sâmbătă",
                Sunday: "Duminică",
                onDay: "În ziua",
                onThe: "În",
                First: "Prima",
                Second: "A doua",
                Third: "A treia",
                Fourth: "A patra",
                Last: "Ultima",
                January: "Ianuarie",
                February: "Februarie",
                March: "Martie",
                April: "Aprilie",
                May: "Mai",
                June: "Iunie",
                July: "Iulie",
                August: "August",
                September: "Septembrie",
                October: "Octombrie",
                November: "Noiembrie",
                December: "Decembrie",
                monthOf: "a lunii",
                requiredField: "Acest câmp este obligatoriu!",
                processTimeNotSet: "Timpul de începere al procesului nu este setat.",
                processOn: "Începe ",
                publishDateOn: "cu data de publicare, ",
                at: " la ",
                recurringEvery: ", recurență în fiecare ",
                recurring: ", recurență ",
                daily: "zilnic",
                days: "zile",
                months: "luni",
                weeks: "săptămâni",
                onTheDesc: " în ",
                everyWeek: " din fiecare ",
                endOn: ", se termină "
            },

            taskEmail: {
                assignTaskEmail: "Subiectul e-mailului",
                customTaskEmail: "E-mail personalizat ",
                subject: "Subiectul mesajului",
                attachments: "Adăugați atașament",
                dataAttachments: "Ataşamente",
                body: "Corpul mesajului",
                variablesType: "VAR",
                dataModelType: "DML",
                variablesName: "Variabile",
                dataModelName: "Model de date"
            },

            externalStart: {
                externalUrl: "Url-ul aplicației",
                addExternalClients: "Gestionați credențialele",
                externalClients: "Credențiale API-uri expuse",
                addMapRequest: "Mapați solicitarea",
                externalDataModel: "Câmpurile modelului de date",
                availableClients: "Credențiale API-uri disponibile",
                noClients: "Nu sunt definite credențiale pentru API-ul expus. Vă rugăm să adăugați credențiale pentru a permite accesul la acesta.",
                name: "Nume",
                addNewClient: "Adăugați credențiale API",
                mapRequest: "Mapați solicitarea",
                mapFields: "Mapați câmpurile",
                defineRules: "Definiți regulile",
                configurationRequest: "Configurație",
                fieldsDefine: "Câmpuri",
                dataFields: "Date",
                defineBtn: "Definiți",
                noMappedFields: "Nu sunt definite câmpurile obligatorii",
                continueBtn: "Continuați",
                rulesTitle: "Reguli",
                addRules: "Adăugați reguli",
                rulesEditor: "Editor de reguli",
                setError: "Setați eroarea",
                errorMessage: "Mesaj de eroare",
                error418: "Sunt un ceainic",
                error400: "Cerere greșită",
                error500: "Eroare internă a serverului",
                errorCode418: "EROARE 418",
                errorCode400: "EROARE 400",
                errorCode500: "EROARE 500",
                backBtn: "Înapoi",
                finishBtn: "Finalizează",
                mappedFields: " mapped fields",
                mappedField: " mapped field",
                rules: " rules",
                rule: " rule",
                addBtn: "Adăugați",
                warningRemoveDataModelTitle: "Acest câmp este utilizat în cel puțin o regulă. Vă rugăm să verificați regulile care conțin acest câmp."
            },
            smsSubject: {
                assignSMSSubject: "Subiect SMS",
                customSMSSubject: "Subiect personalizat SMS",
                body: "Corpul mesajului"
            },
            messagingOptions: {
                messagingTitle: "Opțiunile mesageriei",
                regularMessages: "Mesagerie regulată",
                dynamicExternalTasks: "Task-uri externe dinamice",
                addRegularMessage: "Adăugați tipul mesajului",
                addDynamicMessage: "Adăugați tipul mesajului dinamic",
                noMessages: "Încă nu ați adăugat niciun mesaj.",
                itemSubject: "Subiect:",
                itemTo: "Către:",
                actionDelete: "Ștergeți",
                email: "E-MAIL",
                sms: "SMS",
                dataModel: "DML",
                regularMsgType: "Regulat",
                dynamicMsgType: "Dinamic",
                addNewMessage: {
                    regularMsgTitle: "Tip nou de mesaj",
                    dynamicMsgTitle: "Un nou task extern dinamic",
                    editRegularMsgTitle: "Editați tipul mesajului",
                    editDynamicMsgTitle: "Editați un task extern dinamic",
                    messageProp: "Proprietățile mesajului",
                    messageRecipients: "Destinatarii mesajului",
                    tooltipInfo: "Alegând opțiunea numai prin e-mail, vă puteți expune la furtul de identitate.",
                    messageName: "Numele mesajului",
                    emailOnly: "Numai prin e-mail",
                    emailSms: "Email & SMS",
                    separateTask: "Creează un task separat pentru fiecare destinatar",
                    notificationSettings: "Setările notificării",
                    messageRecipient: "Destinatarul mesajului (nu este setat)",
                    dynamicMsgRecipient: "Selectați clasa modelului de date",
                    requiredMsgType: "Vă rugăm să selectați un tip de mesaj!",
                    requiredMsgReceipient: "Vă rugăm să adăugați destinatarul de mesaje",
                    requiredMsgName: "Vă rugăm să adăugați numele mesajului!",
                    toRecipient: "CATRE: ",
                    emailTabName: "Notificare",
                    smsTabName: "Autentificare",
                    setMessageRecipient: {
                        title: "Setați destinatarul mesajului",
                        userInfo: "Informații despre utilizator",
                        selectSource: "Selectați sursa",
                        dataModelLabel: "Model de date",
                        emailAdd: "Adresa de email",
                        phoneNr: "Număr de telefon",
                        txtType: "TXT",
                        dataModelType: "DML",
                        manualInput: "Introducere manuală",
                        dataModel: "Model de date",
                        emailAndPhoneRequired: "Vă rugăm să adăugați e-mail și număr de telefon pentru destinatarul dvs.",
                        phoneRequired: "Vă rugăm să adăugați numărul de telefon pentru destinatarul dvs.",
                        dataModelRequired: "Adăugați un model de date pentru destinatarul dvs.",
                        validEmail: "Adresă email invalidă!",
                        invalidPhone: "Număr de telefon invalid!",
                        contentSmsAndEmail: "Vă rugăm să completați e-mail și sms!",
                        contentEmail: "Vă rugăm să completați corpul de e-mail!"
                    }
                }
            },
            variablesCard: {
                insertSpecialIdentificator: "Introduceți un identificator special",
                dataModel: "Model de date",
                variables: "Variabile",
                users: "Desemnați",
                searchUsers: "Căutare utilizatori",
                freeText: "Text",
                dataText: "Text model de date",
                email: "Email",
                phone: "Telefon",
                list: "Listă",
                errEmail: "Introduceți o adresă de email",
                errPhone: "Introduceți un numărul de telefon",
                listOf: "Lista de",
                addNew: "Adăugați nou"
            },
            setTarget: {
                newTarget: "Adăugați un nou target",
                targetElement: "Selectați un element de target",
                targetLabel: "Obiectiv",
                outcomeProcessLabel: "Rezultatul procesului anterior",
                connectorProperties: "Proprietățile conectorului",
                untitledConnector: "Conector fără titlu",
                addNotifications: "Adăugați notificare",
                notifications: "Notificări",
                to: "Către",
                more: "mai mult",
                subj: "Subiect",
                body: "Corp",
                trigger: "Trigger",
                noLabelConnector: " lipsește eticheta conectorului",
                noProcessSelected: "Niciun proces nu este selectat pe activitatea proces {processName}",
                noEndpointAvailable: "Nu există niciun punct de final disponibil pentru selecție",
                allEndpointsSelected: "Toate punctele de final sunt deja selectate pe alți conectori",
                submissionSettings: "Setări de trimitere a task-urilor",
                preselect: "Preselectează prima opțiune",
                submissionCommentBehavior: "Tipul comentariilor privind trimiterea task-urilor",
                optionalComment: "Opțional",
                requiredComment: "Obligatoriu",
                hideComment: "Ascunde caseta de comentarii",
                noConnectors: "Niciun conector disponibil",
                defaultTooltip: "Lista de opțiuni de trimitere a task-urilor va afișa ordinea target-urilor dacă există mai multe"
            },
            setUsers: {
                users: "Desemnați",
                assignUser: "Adăugați desemnat"
            },
            generateDocuments: {
                configDocuments: "Alocați șablon",
                documentSettings: "Setările șablonului de document",
                generateModalTitle: "Alocați șablon",
                editgenerateModalTitle: "Editați șablon",
                documentLabel: "Șablon document",
                docExtension: "Extensia documentului generat",
                dataModelLabel: "Câmp model de date",
                addRow: "Adăugați",
                headerAction: "Ștergeți",
                dupDocError: "Ați mapat deja acest câmp din modelul de date într-un șablon de document.",
                fileName: "Nume fișier personalizat"
            },
            notifications: {
                notifications: "Notificări",
                notificationProperties: "Proprietățile notificării",
                notificationType: "Tipul notificării",
                notificationName: "Numele Notificării",
                setup: "Setările notificării",
                send: "Emite notificare",
                email: "E-mail",
                sms: "SMS",
                addRecipients: "Destinatari",
                cc: "cc",
                bcc: "bcc",
                subject: "Subiect",
                notificationBody: "Corpul notificării",
                templates: "Șabloane",
                attachments: "Fișiere atașate",
                collapse: "Colapsați",
                notificationTargetRequired: "Vă rugăm să adăugați un target pentru notificarea dvs.",
                messageRequired: "Vă rugăm să adăugați un mesaj pentru notificarea dvs.",
                subjectRequired: "Vă rugăm să adăugați un subiect pentru notificarea dvs.",
                characters: "caractere",
                mandatory: "Obligatoriu",
                nameError: "Numele notificării este obligatoriu",
                trigger: "Trigger",
                when: "Când",
                after: "După",
                before: "Înainte",
                on: "La",
                taskEvent: "Eveniment",
                timeframe: "Interval de timp",
                expiration: "Expirare",
                deadline: "Termen limită",
                creation: "Creare",
                completion: "Finalizare",
                repeat: "Repetă notificarea",
                repeatEvery: "Repetă notificarea la fiecare",
                until: "până când task-ul este finalizat.",
                noNullValues: "Nu introduceți valori nule",
                validFormat: "Valorile valide sunt: 3d 7h 30m",
                daysLabel: " zile",
                hoursLabel: " ore",
                minsLabel: " minute",
                andLabel: " și ",
                notConfigured: "Notificarea nu este configurată.",
                starts: "Programată să pornească cu",
                repeating: ", repetându-se la fiecare",
                markedCompleted: "până când task-ul este finalizat",
                placeholderTimeframe: "Ex: 4d 2h",
                createNew: "Creează o notificare nouă"
            },
            exclusiveGate: {
                name: "Nume",
                code: "Cod",
                description: "Descriere",
                rules: "Configurarea regulilor",
                activityMessage: "Vă rugăm să adăugați mai întâi acțiuni la activitate",
                order: "Comandă",
                activity: "Activitate",
                condition: "Condiție",
                exception: "Excepție",
                up: "Sus",
                down: "Jos"
            },
            conditionalBlock: {
                modalTitle: "Setări pentru blocul condițional",
                deleteBlock: "Șterge bloc",
                deleteBlockTitle: "Șterge blocul {name}",
                errorBlockName: "Vă rugăm să introduceți un nume pentru blocul condițional",
                deleteBlockMessage:
                    "Ștergând blocul condițional, veți elimina doar blocul în sine, nu și conținutul acestuia. Orice regulă salvată aici va fi, de asemenea, ștearsă."
            },
            richTextBlock: {
                modalTitle: "Setări pentru conținutul interfeței"
            },
            repeatableBlock: {
                modalTitle: "Setări pentru blocul repetitiv",
                addListAttribute: "Adăugați atributul de tip listă",
                errorBlockName: "Vă rugăm să introduceți un nume pentru blocul repetitiv",
                customSorting: "Sortare personalizată",
                sortListLabel: "Sortați valorile listei",
                sortBy: "după",
                sortPlaceholder: "Selectați valoarea",
                selectAttributeTitle: "Selectați atributul",
                filtersTitle: "Filtre",
                sortAttrMandatory: "Atributul este obligatoriu pentru a se executa sortarea",
                changeDeleteListWarnTitle: "Schimbați atributul listei existente",
                changeDeleteListWarnBody:
                    "Dacă îl schimbați, atributele listei conținute anterior sunt deconectate și vor trebui eliminate manual din blocul repetitiv.",
                continueBtn: "Continuați",
                configureInfo: "Blocul curent nu poate fi configurat înaintea blocului părinte"
            },
            ruleTesting: {
                importedData: "Date importate din:",
                existingInstances: "Instanțe existente de proces",
                rule: "regulă",
                rules: "reguli",
                statement: "Declarație:",
                condition: "Condiție",
                level: "nivel",
                levels: "niveluri",
                title: "Rezultatul testului",
                sideBarTitle: "Testarea regulilor",
                sideBarCardTitle: "Componenta selectată a diagramei",
                sideBarTestBtn: "Test",
                sideBarTestAgainBtn: "Retestați",
                sideBarGetInstanceBtn: "Datele instanței de proces",
                sideBarLevels: "niveluri",
                testAllLevels: "Testați toate nivelurile",
                testAllRules: "Testați toate regulile",
                copy: "Copiați",
                paste: "Lipiți",
                copyMessage: "Valorile au fost copiate cu succes",
                successPaste: " valorile au fost potrivite cu succes",
                noMatchPaste: "Nu au fost potrivite valori"
            },
            importConditions: {
                importConditionsSubTitle: "Reguli privind importul de condiții",
                importConditionsTitle: "Importați condițiile",
                activities: "Activități",
                condition: "condiție",
                conditions: "condiții",
                level: "Nivel",
                search: "Căutare activitate"
            },
            exclusiveGateway: "Gateway exclusivist",
            setRules: {
                ruleEditor: "Editor de reguli",
                addRule: "Adăugați regulă",
                ruleHighlights: "Detaliile regulilor",
                name: "Numele regulii",
                description: "Descrierea regulilor",
                ruleName: "Numele regulii",
                ruleNameRequired: "Vă rugăm să adăugați un nume pentru regula dvs.",
                conditionsRequired: "Vă rugăm să adăugați cel puțin o condiție pentru regula dvs.",
                syntaxError: "Condițiile dvs. generează o eroare de sintaxă. Mai întâi trebuie să-l reparați",
                outcomesRequired: "Vă rugăm să adăugați cel puțin un rezultat pentru regula dvs.",
                targetsRequired: "Trebuie să setați unul sau mai mulți destinatari pentru a continua",
                targetsAndRightRequired: "Trebuie să setați unul sau mai mulți membri și cel puțin un rol de \"Aprobator\"",
                delete: "Ștergeți",
                update: "Actualizați",
                warning: "Avertizare",
                warningMessage: "Sunteți sigur că vreți să părasiți pagina? Veți pierde toate modificările!",
                validCondition: "Vă rugăm să vă asigurați că această condiție este valabilă"
            },
            setConditions: {
                importConditions: "Condiții de import",
                conditions: "Condiții",
                statement: "Declaraţie",
                addCondition: "Adăugați o nouă condiţie",
                equals: "Egal",
                notEquals: "Nu este egal",
                greater: "Mai mare ca",
                greaterOrEqual: "Mai mare sau egal ca",
                less: "Mai puțin decât",
                lessOrEqual: "Mai mic sau egal decât",
                is: "Este",
                not: "Nu",
                isNot: "Nu este",
                group: "Grup",
                addValue: "Adăugați valoare",
                selectValue: "Selectați valoare..."
            },
            // targets last tab assign for users
            ruleOutcomes: {
                outcomes: "Rezultate",
                roles: "Desemnați",
                notifications: "Notificări",
                taskDetails: "Detaliile task-ului",
                usersInfo: "Setați unul sau mai mulți destinatari care vor primi aceast task după îndeplinirea condițiilor de mai sus",
                initialAssignees: "Destinatarii inițiali",
                newAssignees: "Adăugați destinatarul",
                newUserGroup: "Nou grup desemnat",
                addMembers: "Adăugați membri",
                decisionGroup: "Grup Decizional",
                addDecisionGroup: "Adăugați grup decizional",
                levelTaskDetails: "Puteți actualiza comportamentul nivelului",
                initialValues: "Desemnați inițiali",
                newValues: "Nou desemnați",
                notificationsInfo: "Actualizați notificările pentru a informa unul sau mai mulți utilizatori odată îndeplinite condițiile de mai sus",
                tasks: "Task-uri",
                role: "Rol",
                decisionType: "Tipul deciziei",
                prolonger: "Prolonger",
                approveBtn: "Aprobator",
                evaluateBtn: "Evaluator",
                overrideBtn: "Aprobator suprem",
                singular: "Singular",
                group: "Grup",
                approversNumber: "Numărul de aprobatori",
                setApproversNumber: "Setați o valoare",
                singularTooltip: "Oricare dintre membrii grupului poate decide în numele grupului.",
                groupTooltip: "Mai mulți membri ai grupului trebuie să aprobe taskul. Odată ce numărul necesar de aprobări este atins sistemul continuă procesul de aprobare.",
                approverTooltip: "Are putere decizională, cu toate acestea, este mai jos decât Aprobator suprem; este necesar cel puțin un Aprobator să fie configurat pe nivel.",
                evaluatorTooltip : "Are putere consultativă; scopul său este de a ajuta aprobatorii și aprobatorii supremi să ia o decizie; aprobarea nu poate fi configurată doar cu evaluatori pe nivel.",
                overriderTooltip: "Are cea mai mare putere; decizia lui prevalează asupra oricărei decizii luate de alți aprobatori; aprobarea nu poate fi configurată numai cu aprobatori supremi pe nivel.",
                requires: "Necesită",
                approvals: "aprobări",
                noApprovalsError: "Trebuie să existe cel puțin o aprobare",
                noApprovalsDMError: "Trebuie să selectați un atribut",
                integerError: "Valoarea trebuie să fie un număr întreg mai mare decât 0"
            },
            setLevels: {
                level: "Nivel",
                name: "Nume",
                addLevel: "Adăugați incă un nivel",
                levelEditor: "Editorul nivelului",
                levelSettings: "Setările nivelului",
                rules: "Reguli",
                conditionalRules: "Reguli de notificare condiționată",
                levelHighlights: "Detaliile nivelului",
                delete: "Ștergeți",
                selectBehaviour: "Selectează comportament"
            },
            approvalTime: "Timpul până la expirare",
            timeUnit: "Unitate",
            continueIfRejected: "Dacă este respins, continuați la nivelul următor",
            ifExpires: {
                ifExpires: "Comportament de expirare",
                autoReject: "Respingere automată",
                autoApprove: "Aprobare automată",
                propagatePreviousDecision: "Propagarea deciziei anterioare"
            },
            setBlockchain: {
                assignFunction: "Atribuiți funcția",
                assignedFunction: "Funcție atribuită",
                selectFunction: "Funcție",
                eventTitleModal: "Configurare Eveniment Blockchain",
                inParameters: "Parametrii de intrare",
                outParameters: "Parametrii de ieşire",
                configEvent: "Configurare Blockchain Eveniment",
                mesWarning: "Evenimentul de Blockchain trebuie conectat fie la activitatea de Decisions fie la cea de Exclusive Gateway",
                configureBlockchain: "Configureaza Blockchain",
                startFromBkActivity: "Evenimentul de Start Blockchain"
            }
        }
    },
    smartContract: {
        duplicateScName: "Există deja un contract cu numele {name}",
        scNameValidation: "Caracterele speciale nu sunt permise în numele contractului inteligent",
        newScTitle: "Folosește un șablon pentru contract inteligent ",
        newScDescription: "Poți crea un contract inteligent folosind un șablon existent pe care il poți configura ușor.",
        startFromScratch: "Începe de la zero",
        useTemplate: "Folosește un șablon",
        removeTitle: "Șterge Parametru",
        removeEvent: "Șterge Eveniment",
        removeTitleFunction: "Șterge Functie",
        dialogBodyDefaultFunction: "Ești sigur că vrei sa ștergi funcția ? Nu o să mai poți folosi această funcție in viitor",
        dialogBodyDefaultEvent: "Ești sigur că vrei sa ștergi evenimentul ? Nu o să mai poți folosi aceast eveniment in viitor",
        deleteSmartContract: "Ești sigur că vrei sa ștergi?",
        deleteSmartContract2: " Nu o să mai poți folosi aceast contract inteligent in viitor.",
        dialogBodyDefault: "Ești sigur că vrei să ștergi variabilă? Nu o să mai poți folosi această variabilă in viitor.",
        deleteParamEventConstraint: "Este obligatoriu un parametru!",
        cancel: "Anulare",
        remove: "Șterge",
        createBtn: "Creează",
        importBtn: "Importă",
        ethType: "Etherum",
        scNetwork: "Rețea",
        scTitle: "contracte inteligente",
        scCredentials: "Credențiale",
        titleDetails: "Detaliile Funcției",
        subscriptionType: "Tipul Abonării",
        onDemand: "Abonare la cerere",
        continous: "Abonare continuă",
        addBtn: "Adaugă",
        editBtn: "Salvare",
        scAddress: "Adresă",
        scAddressInfo: "Adresa se va completa după publicarea contractului inteligent",
        eventsTitleDetails: "Detaliile Evenimentului",
        scDetails: "Detaliile contractului inteligent",
        scListSubtitle: "Află mai multe despre Blockchain",
        newContract: "Creează unul nou",
        importContract: "Importă un contract inteligent",
        scPlaceholderText: "Nu există nici un contract inteligent.",
        scPlaceholderTextSmall: "Creează un contract inteligent folosind butonul de <b>Creează un contract inteligent</b>",
        functions: "Funcții",
        previewFunction: "Previzualizare cod funcție",
        deleteFunction: "Șterge funcția",
        deleteEvent: "Șterge evenimentul",
        editFunction: "Editează",
        editFunctionTitle: "Editează Funcția",
        scName: "Numele contractului inteligent*",
        editEvent: "Editează Evenimentul",
        scDescription: "Descriere",
        scType: "Tipul",
        events: "Evenimente",
        editContract: "Editeaza un contract inteligent",
        newEvent: "Creează Eveniment",
        newFunction: "Creează Funcție",
        uiTitle: "Contract inteligent",
        uiSubtitle: "Află mai multe despre Blockchain",
        noFuncDescription: "Nu exista descriere",
        confirmationDialog: {
            agree: "Sunteți de acord",
            disagree: "Nu sunteți de acord",
            msg: "Ești sigur că vrei să parasești această secțiune? Vei pierde toate modificările!",
            msg2: "Ești sigur că vrei să parasești această secțiune? Orice dată nesalvată va fi pierdută",
            title: "Confirmați"
        },
        appendVariable: "Adăugați variabila",
        appendVarComponent: {
            noVar: "Nu există variabile disponibile"
        },
        ifHandler: {
            expression: "Expresie"
        },
        forHandler: {
            noNumericVars: "Nu au fost declarate variabile întregi!",
            increasing: "Crestere",
            decreasing: "Scădere",
            variable: "Variabilă",
            startValue: "Valoarea de pornire",
            endValue: "Valoarea de final",
            stepBy: "Pas cu pas",
            direction: "Direcție"
        },
        assignHandler: {
            noFunctionsAvailable: "Nu există funcții disponibile!",
            noEventsAvailable: "<b>Nu există evenimente disponibile!</b>",
            createAnEvent: "Creează un eveniment folosind butonul <b>Creează Eveniment</b>",
            createAFunction: "Creează o funcție folosind butonul <b>Creează funcție</b>",
            parameter: "Parametru",
            parameters: "Parametrii",
            function: "Funcție",
            noParams: "Această funcție nu așteaptă niciun parametru!",
            isFunctionCall: "Apelul funcției",
            description: "Descriere",
            assignment: "Atribuire",
            variable: "Variabilă",
            value: "Valoare",
            add: "Adăugați atribuirea",
            delete: "Ștergeți atribuirea",
            custom: "Cod personalizat",
            condition: "Condiție"
        },
        declareHandler: {
            size: "Dimensiune array",
            blockchainRead: "Blockchain Read"
        },
        parameters: {
            variable: "Numele Variabilei*",
            addParam: "Adaugă Parametru",
            editParams: "Editează Parametru",
            title: "Parametri",
            description: "Descriere",
            isArray: "Este Array",
            isIndexable: "Este Indexabil",
            nothingToDisplay: "Nimic de afisat"
        },
        callHandler: {
            detailsTab: "Detalii",
            description: "Descriere",
            selectContract: "Selectează un contract inteligent",
            selectFunction: "Selectează Funcția",
            configureCallFunction: "Configurați Funcția",
            title: "Apelarea Funcției",
            save: "Salvați",
            functionParams: "Parametrii Funcției",
            noVar: "Nicio variabilă",
            saveWarning: "Vă rugăm să mapați toți parametrii de pe request"
        },
        emitEventHandler: {
            selectEvent: "Selectează Evenimentul",
            configureEmitEvent: "Configurează Evenimentul",
            title: "Eveniment",
            eventParams: "Parametri Eveniment"
        },
        callFunction: {
            search: "Caută în parametrii funcției",
            functionParams: "Parametri Funcției",
            declareVar: "Variabile Declarate",
            systemVar: "Variabile de sistem",
            noParams: "NICI UN PARAMETRU DEFINIT",
            request: "Request",
            response: "Response",
            config: "Configurare"
        },
        preview: {
            previewFunction: "Previzualizare funcție"
        },
        declare: {
            declaration: "Declaraţie",
            addNewDeclaration: "Adăugați declaraţie",
            isArray: "Este array?",
            variableName: "Numele variabilei",
            variableType: "Tipul variabilei"
        },
        returnVars: {
            addReturns: "Adăugați variabila de returnare",
            editParams: "Editeaza variabila de returnare",
            title: "Variabile de returnare"
        },
        main: {
            element: "Element",
            noFunctionElementsYet: "Nu au fost adăugate încă elemente funcționale!",
            functionElements: "Elemente ale funcției",
            functionActions: "Acțiuni ale funcției",
            selectFunction: "Selectați funcția",
            editFunction: "Editați funcția",
            inEditFunctionIs: "Funcția actuală in editare: ",
            noFunctionSelectedForEdit: "Nicio funcție selectată pentru editare!",
            clickManageFunctions: "Faceți clic pe „Gestionare funcții” pentru a selecta o funcție pentru editare!",
            noFunctionSelected: "Vă rugăm să selectați mai întâi o funcție pentru editare!",
            noFunctionsMain: "Vă rugăm să creați o funcție și să intrați în modul de editare pentru acea funcție.",
            deleteFunction: "Ștergeți functia",
            editFunctionBody: "Editați corpul funcției",
            variableName: "Numele variabilei",
            functionsTitle: "Funcţii",
            addFunction: "Creaţi funcţie",
            variableType: "Tipul variabilei",
            isArray: "Este Array",
            function: "Funcţie",
            funcName: "Numele funcţiei",
            funcNameErr: "Numele funcţiei este obligatoriu!",
            description: "Descriere",
            isExposed: "Public",
            isSubscribed: "Abonat",
            previewFunctionCode: "Previzualizare Cod funcție",
            manageFunc: "Gestionați funcțiile",
            noFunctions: "Nu există funcții declarate pentru această aplicație!",
            addAFunc: "Adăugați o functie",
            diagramError: "Vă rugăm să adăugați un start, un sfârșit și cel puțin un bloc de proces",
            diagramErrorTitle: "Erori",
            sameNameParametersError: "Această funcție are aceeași parametri ca altă funcție existentă. Parametrii configurați trebuie să fie unici."
        },
        manageFunctions: {
            functionDetails: "Detalii",
            functionParameters: "Parametrii",
            functionReturn: "Variabile de returnare",
            noNameError: "Numele nu poate fi gol și nu trebuie să înceapă cu un număr, să conțină spații sau caractere speciale.",
            functionDuplicateName: "Acest nume de funcție există deja!",
            duplicateParams: "Există 2 parametri cu același nume",
            varTypeNull: "Vă rugăm să selectați un tip pentru parametrii funcției"
        },
        useTemplateSC: {
            select: "Selectarea șablonului",
            config: "Configurarea șablonului",
            details: "Detaliile contractului",
            titleSelect: "Selectează șablonul",
            descriptionSelect: "Poți adăuga mai multe proprietăți pentru contractul inteligent. Să aveți în vedere că trebuie configurate.",
            selectBtn: "Selectează șablonul",
            back: "Înapoi",
            titleDetails: "Detaliile contractului inteligent",
            descriptionDetails: "Configureaza detaliile de baza a unui contract inteligent",
            finalStep: "Termina Configurarea",
            wallet: "Poți adăuga codul portofelului pentru șablonul tău.",
            walletIdentifier: "Codul Portofel",
            saveChanges: "Salvează modificarile",
            proceedToDetails: "Treceți la detalii",
            notConfig: "Neconfigurat",
            optionalValues: "Valorile din acest card sunt opționale",
            titleDialog: "Confirmare",
            messageDialog: "Ești sigur că vrei să parasești această secțiune? Vei pierde toate modificările!"
        },
        createFromScratch: {
            btnCreate: "Creează"
        },
        pluginDescription: {
            name: "Proprietățile obiectului",
            noPluginSelected: "Nu este selectat niciun obiect. Alegeți unul din bara laterală din stânga pentru a afla mai multe despre proprietățile acestuia",
            noneSelected: "Nici unul"
        }
    },
    documents: {
        addSelect: "Adăugați/Selectați",
        addSelectWarn: "Sigur doriți să selectați sau să adăugați un document nou? Toate modificările dvs. care nu au fost salvate vor fi pierdute.",
        save: "SALVATI",
        select: "SELECTATI",
        titleModal: "Documente",
        deleteDocumentTitle: "Ștergere șablon de document",
        deleteWarn: "Sunteți sigur că doriți să ștergeți ",
        documentBuilder: "Șabloane de documente",
        noDocuments: "Woah! Niciun document",
        deleteTitle: "Woah! Sigur doriți să ștergeți acest element?",
        deleteBody:
            "Această acțiune nu poate fi anulată. Informațiile curente sunt în prezent utilizate, iar eliminarea acestora va determina oprirea următoarelor sisteme:",
        uploadedBy: "Incărcat de",
        on: "pe",
        preview: "Previzualizare",
        download: "Descărcați",
        delete: "Ștergeți",
        rename: "Redenumiți",
        selectAll: "Selectați tot",
        selectNewModalHeader: "Selectați un document existent sau creați unul nou",
        selectDocLabel: "Selectați un document existent",
        createNewDocLabel: "Creează un document nou",
        saveDocModalHeader: "Salvați documentul",
        uniqueName: "Numele șablonului de document trebuie să fie unic",
        wrnMessage: "Părăsind această pagină, veți pierde modificările!",
        leaveBtn: "Părăsiți",
        cancelBtn: "Anulați",
        wrnTitle: "Avertizare",
        draftMessage: "Dacă adaugi un șablon nou de document fară să il salvezi pe cel curent, toate modificările se vor pierde. Ești sigur că vrei să continui?",
        imageTooLargeError: "Dimensiunea imaginii prea mare, maxim 10 MB",
        addDocument: "Creați unul nou",
        emptyDocuments: "Nu există niciun șablon de document in listă",
        successDelete: "Șablonul documentului a fost șters.",
        alreadyDeleted: "Șablonul documentului a fost șters de un alt utilizator.",
        listUpdate: "Lista de șabloane de documente a fost modificată.",
        updated:"a fost actualizat",
        renamed: "a fost redenumit",
        deleteBy:"a fost șters de",
        documentUpdateToast: "a fost actualizată. Pentru a vizualiza ultima versiune te rog reîncarcă pagina.",
        refresh:"Actualizați",
        maxLengthNameErr: "Vă rog introduceți un nume de cel mult 400 caractere!",
        untitledDoc: "Șablon de document fără nume",
        noDocsAvailable: "Niciun șablon de document disponibil",
        deleteMessageDialog: "Acest șablon de document va fi șters permanent. Ești sigur?",
        deleteConfirmation: "{type} a fost șters cu succes",
        deletedDocument: "Șablonul documentului a fost șters",
        renamedSuccessfully: "Documentul a fost redenumit cu succes.",
        cantBeRenamed: "Documentul este editat de {user} și nu poate fi redenumit.",
        sameNameDocument: "Numele Documentului trebuie sa fie unic.",
        docs: "șablon de document | șabloane de documente",
        results: "rezultat | rezultate"
    },
    userProfile: {
        title: "Detaliile utilizatorului",
        settings: "Setări",
        notif: "Notificări",
        username: "Nume de utilizator",
        firstName: "Prenumele",
        lastName: "Numele de familie",
        email: "E-mail",
        phone: "Telefon",
        phoneNumber: "Nr. Telefon",
        roles: "Roluri atribuite mie:",
        position: "Funcţie",
        manager: "Manager",
        allowAccessibility: "(Opțiune dezactivată de către Administrator)",
        allowAdminAccessibility: "(Contrastul se va modifica la următoarea autentificare)",
        language: "Selectați limba",
        en: "Engleză",
        ro: "Română",
        taskToMe: "Anunță-mă de fiecare dată când mi se atribuie un task",
        taskToTeam: "Anunță-mă de fiecare dată când un task este atribuită unui rol care imi este atribuit",
        diagramNotif1: "Anunță-mă de fiecare dată când este executată o aplicație pe care o dețin",
        diagramNotif2: "Anunță-mă de fiecare dată când o diagramă la care am lucrat este modificată",
        interfNotif1: "Anunță-mă de fiecare dată când se adaugă o interfață utilizator",
        interfNotif2: "Notifică-mă de fiecare dată când o interfață utilizator pe care am lucrat este modificată",
        notifTypeEmail: "Prin e-mail la",
        notifTypeSms: "Prin SMS la ",
        notifTypeApp: "Notificări regulate în aplicație",
        password: "Parolă",
        department: "Departament",
        changePassword: "Schimbați parola",
        oldPass: "Parola veche",
        newPass: "Parola nouă",
        enterOldPass: "Parola veche este obligatorie",
        oldPassNoMatch: "Parolele nu corespund.",
        confirmPass: "Confirmați noua parolă",
        minLengthErr: "Vă rugăm să introduceți o parolă cu cel puțin 6 caractere",
        alphaNumErr: "Parola trebuie să aibă minim 6 caractere și să conțină cel puțin o literă mare și un caracter special",
        sameAsErr: "Parolele nu se potrivesc!",
        samePassword: "Parola este deja utilizată pentru acest cont. Vă rugăm să alegeți o altă parolă.",
        reportsTo: "Raportează către",
        taskNotif: "Notificări task",
        diagramNotif: "Notificări legate de diagramă",
        interfaceNotif: "Notificări legate de interfață utilizator",
        notifType: "Tipul de notificare",
        changeInfo: "Schimbați informațiile",
        passwordNeverUpdated: "Nu s-a schimbat niciodată",
        lastPasswordUpdateOn: "Ultima actualizare la {date}",
        emptyPhone: "Numărul de telefon este obligatoriu",
        changePassCode: {
            title: "Validați numărul de telefon",
            label: "Cod de acces",
            button: "Continuare",
            validSuccess: "Număr de telefon validat cu succes",
            validPass: "Parola a fost modificată cu succes"
        },
        myAccountSideNav: {
            myAccount: "Contul meu",
            usrDet: "Detalii despre utilizator",
            notif: "Notificări",
            roles: "Grupuri",
            othSettings: "Alte setări",
            taskDelegation: "Delegare task-uri",
            blockchainWallet: "Portofele Blockchain"
        },
        tasksDelegation: {
            pageTitle: "Delegare task-uri",
            subtitle: "Delegarea mea",
            helperText: "Configurați și vedeți delegarea dumneavoastră",
            delegateButton: "Creează o delegare",
            editButton: "Editați",
            cancelButton: "Anulați",
            cancelDelegationTitle: "Anulați delegarea",
            cancelDelegationBody: "Sunteți sigur că doriți să anulați delegarea sarcinilor către {delegatedUser} între {startDate} și {endDate} ?",
            cancelDelegationStartedBody: "Delegarea dvs. către {delegatedUser} a început pe {startDate}. Sunteți sigur că doriți să anulați această delegare?",
            sureButtonCancel: "Da, sigur",
            noDelegation: "Nu aveți nicio delegare activă momentan.",
            receivedText: "Delegări primite din partea altor utilizatori",
            receivedHelperText: "Delegările primite vor fi afișate în această zonă",
            from: "De la ",
            to: "Către",
            between: "Între ",
            and: "și",
            rejectButton: "Respingeți",
            acceptButton: "Acceptați",
            accepted: "Acceptată",
            pending: "În așteptare",
            rejected: "Respinsă",
            successfullyAccepted: "Delegarea a fost acceptată cu succes",
            rejectDelegationTitle: "Respinge delegarea de la {user}",
            rejectDelegationMessage: "Sunteți sigur că vreți să respingeți delegarea?"
        },
        delegationModal: {
            newDelegationTitle: "Delegare nouă",
            editDelegationTitle: "Editați delegarea",
            createBtn: "Creează",
            saveBtn: "Savați",
            period: "Perioada",
            recipient: "Destinatar",
            availableTasks: "Task-uri active",
            startDate: "Data de început",
            endDate: "Data de încheiere",
            startDateError: "Data de început este necesară",
            endDateError: "Data de încheiere este necesară",
            unsavedChangesTitle: "Modificări nesalvate",
            unsavedChangesBody: "Dacă părăsiți această pagină, toate modificările pe care le-ați făcut vor fi pierdute. Sigur doriți să reveniți la pagina de delegări?",
            leaveButton: "Părăsiți",
            availableTasksInfo: "Alegeți ce se întamplă cu task-urile din lista task-urilor active.",
            delegateThem: "Le deleg",
            keepThem: "Le păstrez",
            recipientInfo: "Utilizatorul desemnat va primi toate task-urile ce apar pe parcursul delegării active.",
            requiredEmail: "Introduceți un delegat",
            currentUserError: "Nu vă puteți delega propriile task-uri",
            emailInputLabel: "Adresă email",
            delegationCreated: "Delegarea a fost creată cu succes",
            delegationEdited: "Delegarea a  fost editată cu succes",
            delegationCanceled: "Delegarea a fost anulată cu succes",
            readonlyTooltip: "Nu poate fi modificat după ce delegarea a fost acceptată"
        },
        currentlyPartOfNRoles: "În prezent fac parte din {n} roluri:",
        roleUsers: "0 utilizatori | 1 utilizator | {count} utilizatori",
        roleApplications: "0 aplicații | 1 aplicație | {count} aplicații",
        uploadedProfileImageSizeError: "Imaginea încărcată este prea mare. Dimensiunea maximă admisă este de {maxSize}",
        uploadedProfileImageTypeError: "Imaginea încărcată trebuie să fie de tip JPG, SVG sau PNG"
    },
    historyPLV: {
        id: "ID instanță de proces",
        name: "Numele instanței de proces",
        status: "Status",
        actions: "Acțiuni",
        deadline: "Termen limită",
        users: "Utilizatori",
        finished: "Procese finalizate",
        active: "Procese active"
    },
    dashboard: {
        sidebarTitle: "Panourile mele de bord",
        myDashboard: "Panoul meu de bord",
        myTeamDashboard: "Panoul de bord al echipei",
        week: "Săptămână",
        month: "Lună",
        year: "An",
        compareWith: "Compară cu",
        productivity: "Productivitatea task-urilor",
        infomationComparedToLastWeek: "comparativ cu săptămâna trecută",
        informationAboutYestarday: "task-uri finalizate ieri",
        chartGroupTitle: "Utilizatorii și grupul dvs.",
        chartGroupInstruction:
            "Comparați un grup cu un utilizator sau cu 2 utilizatori între ei. Utilizați clic stânga pentru a selecta primul utilizator sau grup și clic dreapta pentru a selecta al doilea.",
        tasks: "Task-uri",
        containerTasksTitle: "Task-urile mele",
        title: "Panourile de bord",
        myDashTitle: "Panoul meu de bord",
        start: "Start",
        applications: "aplicații",
        editApp: "Editați aplicația",
        application: "Aplicație",
        period: "Interval",
        tasksOverview: "Prezentarea generală a task-urilor",
        allApps: "Toate aplicațiile",
        charts: {
            januaryShort: "Ian",
            februaryShort: "Feb",
            marchShort: "Mar",
            aprilShort: "Apr",
            mayShort: "Mai",
            juneShort: "Iun",
            julyShort: "Iul",
            augustShort: "Aug",
            septemberShort: "Sep",
            octoberShort: "Oct",
            novemberShort: "Nov",
            decemberShort: "Dec",
            mondayShort: "L",
            tuesdayShort: "M",
            wednesdayShort: "Mi",
            thursdayShort: "J",
            fridayShort: "V",
            saturdayShort: "S",
            sundayShort: "D",
            day: "Zi",
            week: "Săptămână",
            week1: "Săptămâna 1",
            week2: "Săptămâna 2",
            week3: "Săptămâna 3",
            week4: "Săptămâna 4",
            week5: "Săptămâna 5",
            week6: "Săptămâna 6",
            twoWeeks: "2 săptămâni",
            lastWeek: "Săptămâna trecută",
            lastTwoWeeks: "Ultimele doua săptămâni",
            twoWeeksAgo: "Acum două săptămâni",
            threeWeeksAgo: "Acum trei săptămâni",
            lastMonth: "Luna trecută",
            twoMonthsAgo: "Acum două luni",
            threeMonthsAgo: "Acum trei luni",
            lastQuarter: "Trimestrul trecut",
            lastSemester: "Semesterul trecut",
            lastYear: "Anul trecut",
            month: "Lună",
            quarter: "Trimestru",
            semester: "Semestru",
            year: "An",
            onTrack: "La timp",
            attentionState: "În atenţie",
            warningState: "În avertizare",
            exceededDeadline: "Depăşit",
            yesterday: "Ieri"
        },
        tasksPriority: "Prioritatea task-urilor",
        opened: "Deschis",
        onTrack: "La timp",
        totalTasks: "Totalul task-urilor",
        attentionState: "În status de atenție",
        warningState: "În status de avertizare",
        exceededDeadline: "Întârziat",
        display: "Afişează",
        allTasks: "Toate task-urile",
        timeToDeadline: "Durata până la termen:",
        status: "Status:",
        total: "Total",
        reports: "Analitice",
        selectAttributes: "Selectează atribute",
        select: "Selectați",
        stringErrorMessage: "Doar caracterele a-z, 0-9 și spatiu sunt acceptate",
        integerErrorMessage: "Doar valori de tip întreg acceptate",
        decimalErrorMessage: "Doar valori de tip decimal acceptate",
        usedFilterTitle: "Filtru folosit: ",
        instanceStatus: "Statusul instanței de proces",
        savedFilters: "Filtre salvate",
        yourFilters: "Filtrele dumneavoastră",
        bulkDelete: "Ștergeți în masă",
        selectAll: "Selectați toate cele {count} filtre",
        filterDeleteText:
            "Acteastă acțiune o să șteargă filtrul permanent. Nu poate fi anulată | Această acțiune o să șteargă filtrele permanent. Nu poate fi anulată ",
        filterDeleteTitle: "Ștergeți filtrul salvat | Ștergeți filtrele salvate",
        filterSavedMessage: "Filtru salvat cu succes",
        filterFavoriteMessage: "Filtru a fost marcat ca favorit cu success",
        filterUnfavoriteMessage: 'Filtru a fost nemarcat cu success"',
        emptyNameFilter: "Vă rugăm să introduceți un nume pentru filtru",
        duplicateName: "Acest nume de filtru este deja utilizat.",
        filterName: "Numele filtrului",
        nrOfGroups: "1 grup | {count} grupuri",
        nrOfUsers: "1 utilizator | {count} utilizatori",
        showSelected: "{count} selectate",
        lowPriority: "Prioritate scăzută",
        mediumPriority: "Prioritate medie",
        highPriority: "Prioritate ridicată",
        latestApps: "Aplicații",
        customize: "Modifică panoul de bord",
        applications_name: "Aplicații",
        tasks_name: "Task-uri",
        overview_name: "Sumar task-uri",
        tasklist_name: "Listă task-uri",
        productivity_name: "Productivitate",
        applyToThis: "Aplică doar pentru panoul de bord curent ",
        applyToAll: "Aplică pentru toate panourile de bord existente",
        sections: "Secțiuni",
        settings: "Setări",
        editDashboard: "Editează panoul de bord",
        atLeastOneSection: "O secțiune trebuie să fie mereu activă",
        atLeastOneSubsection: "O subsecțiune trebuie să fie mereu activă"
    },
    reports: {
        favoritesFilters: "Filtre favorite",
        favorites: "Favorite",
        viewAllFilters: "Vedeți toate filtrele",
        noFavFilters: "Nu aveți niciun filtru favorit",
        allActivities: "Toate activitățile",
        unclaimTitle: "Resetați | Resetați în masă",
        reassignTitle: "Realocați | Realocați în masă",
        unclaimMessage: "Doriți să resetați task-ul selectat? | Doriți să resetați în masă task-urile selectate?",
        reassingMessage: "Doriți să realocați task-ul selectat? | Doriți să realocați în masă task-urile selectate?",
        bulkCountReassign: "Realocați ({count})",
        bulkCountUnclaim: "Resetați ({count})",
        copyFilterInfo: "Copiați link-ul filtrului",
        copyInfo: "Copiați link",
        succesCopyFilter: "Filtru copiat",
        filterSaved: "Filtru salvat cu succes",
        shareFilter: "Distribuire filtru",
        share: "Distribuie",
        directLink: "Link direct",
        noUsersSelected: "Niciun utilizator selectat",
        usersSelected: "{count} utilizator selectat | {count} utilizatori selectați",
        saveFilterMessage: "Filtrul {count} a fost distribuit cu succes",
        savedFiltersInfo: "Filtre salvate",
        resetColumnInfo: "Resetează coloanele la aranjamentul inițial",
        saveLaterUser: "Salvează filtrul pentru a-l utiliza mai târziu",
        addFiltersDM: "Adaugă filtre din modelul de date",
        addColumnsDM: "Adaugă coloane din modelul de date",
        filterFavInfo: "Marchează filtru ca favorit",
        applyFilterInfo: "Aplică filtrul",
        shareFilterInfo: "Trimite filtrul pe email",
        deleteFilterInfo: "Ștergeți",
        noFiltersList: "Filtrele salvate pot fi accesate în această zonă",
        emptyListFilters: "Nu aveți filtre salvate",
        noProcessesTitle: "Nu aveți niciun proces",
        noProcessesDescription: "Aici puteți găsi orice proces creat si publicat in viitor",
        selectProcessTitle: "Selectați un proces pentru a continua",
        selectProcessDescription: "Aici puteți vedea datele procesului",
        noProcessesYet: "Niciun proces momentan",
        reportsTxt: "proces | procese",
        caseSearchTxt: "vizualizare de date | vizualizari de date"
    },
    pluginFileManager: {
        uploadFile: "Încărcați un fisier",
        selectDataModel: "Selectați din modelul de date",
        imageSourse: "Selectați sursa de imagine"
    },
    pluginFabricImage: {
        labelClass: "Clasă",
        labelSource: "Sursă",
        imageDescription: "Descrierea imaginii",
        imageTitle: "Titlul imaginii",
        imageDimensions: "Dimensiuni",
        imageWidth: "Lăţime",
        imageDimensionsOperator: "x",
        imageHeight: "Înălţime",
        imageConstrainProp: "Constrânge proporțiile",
        imageCaption: "Titlu",
        advancedTabs: "Inserați / editați imaginea",
        bodyGeneral: "General",
        bodyAdvanced: "Avansat",
        bodyStyle: "Stil",
        styleVerticalspace: "Spațiu vertical",
        styleHorizontalspace: "Spațiu orizontal",
        styleBorder: "Margine",
        titleDefaultDialog: "Inserați / editați imaginea",
        tooltipImageButton: "Inserați / editați imaginea",
        textImageMenu: "Imagine"
    },
    pluginPageSetup: {
        documentProperties: "Proprietățile documentului",
        labelPageSize: "Mărimea paginii",
        labelPageSizeA4: "A4",
        labelPageSizeA3: "A3"
    },
    setLabel: {
        untitledPlugin: "Plugin fără titlu"
    },
    liveView: {
        leftSideBar: {
            titlePLV: "Vizualizare live",
            infoPLV: "Aflați mai multe despre task-uri și aplicații",
            itemTasks: "Vizualizare date live",
            itemStatistics: "Statistici proces"
        },
        filters: {
            dml: "DML",
            completion: "Completare:",
            title: "Filtre",
            viewBtn: "Vizualizare",
            noFiltersMsg: "Niciun filtru aplicat",
            nrOfFiltersApplied: " filtre aplicate",
            itemsFound: " elemente găsite",
            taskStatus: "Statusul task-ului",
            allStst: "Toate stările",
            dataModel: "Model de date",
            addStatment: "Adăugați o nouă declarație",
            verifyApp: "Selectați o aplicație pentru a continua",
            onTime: "La timp",
            attn: "Atenţie",
            wrng: "Avertizare",
            overdue: "Întârziat",
            creationDate: "Data creării",
            taskPriorityTitle: "Prioritatea task-ului",
            allPriorities: "Toate prioritățile",
            lowest: "Cel mai scăzut",
            low: "Scăzut",
            normal: "Normal",
            high: "Ridicat",
            highest: "Cel mai ridicat",
            completionSts: "Statusul finalizării",
            date: "Data",
            fromDate: "Din",
            toDate: "La",
            allTsks: "Toate task-urile",
            openTask: "Active",
            completedTasks: "Finalizate",
            usersAndRoles: "Utilizatori și roluri",
            noUsersSel: "Nu ați selectat utilizatori",
            usersSel: " utilizatori selectați",
            noGroupsSel: "Nu a fost selectat niciun grup",
            groupsSel: " grupuri selectate",
            noResultsFound: "Niciun rezultat găsit",
            addBtn: "Adăugați",
            conditionTitle: "Condiție",
            statement: "Declaraţie",
            dataModelSearch: "Căutare (minim 3 caractere)",
            dataModelCollapsTitle: "Clasele modelului de date",
            catalogsCollapsTitle: "Cataloage",
            apiTitle: "APIs",
            variablesTitle: "Variabile de sistem",
            dataModelOperators: {
                equals: "Egal",
                contains: "Conține",
                notEquals: "Nu este egal",
                greater: "Mai mare ca",
                greaterOrEqual: "Mai mare sau egal ca",
                less: "Mai puțin decât",
                lessOrEqual: "Mai mic sau egal decât",
                true: "Adevărat",
                false: "Fals"
            },
            validations: {
                noProperty: "Vă rugăm să selectați o proprietate din Modelul de date",
                noStatement: "Declarația trebuie să conțină doar litere și numere"
            },
            export: {
                exportResults: "Exportă rezultatele",
                exportBtn: "Exportă",
                toastMsg: "Cererea de export a fost trimisă. Odată ce acțiunea este completă, vei primi o notificare pe email.",
                err409: "Ai deja un export în desfășurare pentru aplicația aceasta!",
                err400: "Cel puțin un câmp din modelul de date trebuie să fie selectat!",
                err5001: "Eroare internă de server",
                err500: "No task data is available",
                err404: "Nu a fost găsit",
                errorGen: "Ceva nu a funcționat, te rugăm să încerci din nou mai târziu."
            }
        },
        taskDetails: {
            search: "Cautați...",
            searchForTask: "Cautați un task...",
            searchForInstance: "Cautați o instantă...",
            activitiesCollapsibleLabel: "Activități",
            endpointsCollapsibleLabel: "Puncte de final",
            tasksFilterSearchBtn: " filtre aplicate",
            searchForTaskAndInstance: "Căutare după task-uri și instanțe de proces...",

            title: "Activități - instanțe de proces deschise",
            titleOpened: "Activități - instanțe de proces deschise",
            titleCompleted: "Activități - instanțe de proces completate",
            taskDescription: "Activitate",
            taskDescrAssignee: "Desemnat: ",
            taskDescrDeadline: "Durata iniţială până la termen: ",
            instanceId: "ID:",
            timeToDeadline: "Durata până la termen:",
            timeToCompletionDate: "Data finalizării:",
            timeToExpiration: "Timpul până la expirare:",
            expired: "expirat",
            titleInstances: "Task-uri",
            creationDate: "Data creării:",
            openTasks: "Task-uri",
            completedTasks: "Task-uri finalizate",
            completeBy: "Completat de: ",
            completionDate: "Data finalizării: ",
            timeframe: "Interval de timp: ",
            asc: "Asc",
            desc: "Desc",
            deadlineExceeded: "Termenul depășit cu: ",
            exceededType: "depășit",
            warningType: "Avertizare",
            onTimeType: "La timp",
            typeHours: " ore, ",
            typeMinutes: " min",
            loadMore: "Încărcaţi mai mult",
            notificationMsg: "Fără detalii!",
            noTasks: "Fără task-uri!",
            ON_TRACK: "La Timp",
            ATTENTION: "În Atenţie",
            AT_RISK: "În Avertizare",
            OVERDUE: "Întârziat",
            TERMINATED: "Terminat",
            SUSPENDED: "Suspendat",
            FAILED: "Eșuat",
            COMPLETED: "Finalizat",
            RUNNING: "În execuție",
            ARCHIVED: "Arhivat",
            instances: "Instanțe de proces",
            actionsCancel: "Anulați",
            UNCLAIM: "Resetați",
            REASSIGN: "Realocați"
        },
        taskDescription: {
            activityTitle: "Detalii despre activitate",
            taskTitle: "Detaliile task-ului",
            appTitle: "Sursă",
            appName: "Aplicație",
            processName: "Proces",
            taskName: "Numele task-ului",
            instanceName: "Instanța de proces",
            timeToDeadline: "Durata până la termen",
            timeRemaining: "Durata rămasă",
            expirationTimeRemaining: "Timpul de expirare rămas",
            expirationBehaviour: "Comportamentul expirării",
            priority: "Prioritate",
            taskDescriptionProp: "Descrierea task-ului",
            assignedUserinterface: "Interfață utilizator atribuită",
            escalationBehaviour: "Comportament de escaladare",
            users: "Utilizatori",
            autoApprove: "Aprobare automată",
            autoReject: "Respingere automată",
            pPDecision: "Propagarea deciziei anterioare",
            label: "Etichetă"
        },
        statistics: {
            appStatsTitle: "Statisticile procesului",
            taskTitle: "Task",
            nrCurrInstances: "numărul curent de instanțe deschise",
            nrUncompletedTasks: "Task-uri necompletate",
            nrCompletedTasks: "Task-uri finalizate",
            turnaroundTime: "Timpul de rotație",
            nrCompletedInstances: "numărul curent de instanțe completate",
            levelDetails: "Detaliile nivelului",
            appStatsOptimal: "OPTIMAL:",
            currTimeFrame: "INTERVALUL DE TIMP CURENT:",
            prevTimeFrame: "INTERVALUL DE TIMP PRECEDENT:",
            timeFrameVariation: "VARIAȚIA INTERVALULUI DE TIMP:",
            extendedReport: "Raport extins",
            taskDeadline: "TERMENUL LIMITĂ AL TASK-URILOR:",
            applicationThresholds: "Pragurile aplicației",
            viewLevels: "Vizualizați nivelurile",
            oneWeek: "1 săptămână",
            twoWeeks: "2 săptămâni",
            month: "Lună",
            thresholds: {
                title: "Setați pragurile aplicației",
                currentThresholds: "Praguri curente",
                infodefault: "Pragurile implicite pot fi actualizate",
                infoDefaultDescription: "Lorem ipsum dolor sit amet, consectetur . . . ",
                thOnTime: "La timp",
                thAttention: "Atenţie",
                thWarning: "Avertizare",
                taskInception: "Începerea task-ului",
                taskOverdue: "Task intâzriat",
                thSimulation: "Simularea pragului",
                infoSimulation: "Verificați diagrama de mai sus cu o simulare de timp",
                labelTimeToDeadline: "Durata până la termen",
                labelUnits: "Unități",
                runSimulation: "Rulați simularea ",
                infoSimDetails: "Task-ul simulat va avea următoarea durată de viață:",
                attentionInfo0: "Dacă aplicația este pornită pe ",
                attentionInfo1: "Termenul limită va ajunge la ",
                attentionInfo2: " prag în ",
                attentionInfo: "ATENŢIE",
                warningInfo: "AVERTIZARE",
                overdueInfo: "ÎNTÂRZIAT",
                titleButtActions: "Actualizați"
            }
        },
        tasksInstances: {
            tasksTitle: "Taskuri",
            instancesTitle: "Instanțe de proces",
            tooltipFullScreen: "Vizualizare listă completă",
            tooltipDiagramView: "Vizualizare diagramă",
            expand: "Extinde",
            collapse: "Restrânge",
            showSearchFilter: "Arată filtrele",
            hideSearchFilter: "Ascunde filtrele",
            export: "Exportă",
            moreActions: "Mai multe acțiuni",
            priority: "Prioritate",
            taskName: "Numele task-ului",
            instanceName: "Numele instanței de proces",
            instanceId: "ID-ul instanței de proces",
            finalStage: "Activitate finală",
            creationSource: "Originea instanței de proces",
            activity: "Activitate",
            assignment: "Desemnat",
            creationDate: "Data creării",
            startDate: "Data start",
            completionDate: "Data finalizării",
            tasks: "Taskuri",
            deadline: "Termen limită",
            expiration: "Expirare",
            status: "Status",
            action: "Acțiune",
            more: "Mai mult",
            ON_TRACK: "La timp",
            AT_RISK: "În avertizare",
            ATTENTION: "În atenție",
            OVERDUE: "Întârziat",
            viewBtn: "Afișați",
            unclaim: "Resetați",
            reassign: "Realocați",
            bulkUnclaim: "Resetați în masă",
            bulkReassign: "Realocați în masă",
            bulkReassignExternal: "Realocați în masă taskurile externe",
            noInterfaceError: "Nu există nici o interfață utilizator mapată în acest punct final. Interfața nu poate fi afișată.",
            cancel: "Anulați",
            selectAll: "Selectați toate cele {counter} taskuri",
            clearAll: "Deselectati toate taskurile selectate",
            itemTask: "task",
            itemTasks: "taskuri",
            itemInstance: "intanță",
            itemInstances: "instanțe de proces",
            selected: "selectat",
            displayed: "afișate",
            viewAssignee: "Arată destinatarii",
            instancesActivity: "Activitate",
            tooltipInstance: "Vezi taskurile instanței de proces",
            tooltipInstanceFailed: "Nu există taskuri disponibile",
            switchTabWarning: "Dacă dorești să te întorci la căutarea anterioară te rugăm să elimini 'instance ID' adăugat în campul de căutare",
            filterNotFound: "Filtrul accesat nu exista.",
            noPermissions: "Nu ai permisiune de a vedea pagina accesata.",
            noStatus: "Statusul nu este aplicabil",
            assigneeSystem: "Sistem",
            clearFilters: "Ștergeți filtrele",
            cancelRequest: "Solicitarea a fost anulată cu succes."
        }
    },
    dataTable: {
        settingsTitle: "Coloane",
        exportTasksTitle: "Exportați task-uri",
        exportInstancesTitle: "Exportați instanțe de proces",
        exportMessage: "Cererea de export se proceseaza. Cand se va finaliza, il vei primi via email",
        btnData: "Model de date",
        btnCancel: "Anulați",
        btnReset: "Resetați",
        btnConfirm: "Confirmă",
        btnExport: "Exportați",
        noData: "Nimic de afișat",
        noDataInfo: "Nu există elemente în această listă",
        dataModelTitle: "Selectați atributele",
        removeCol: "Elimină",
        tooltipSettings: "Setări",
        firstPage: "Prima pagină",
        prevPage: "Pagina anterioară",
        nextPage: "Urmatoarea pagină",
        lastPage: "Ultima pagină",
        settingsInfo: "Selectat: ",
        paginationLabel: " din ",
        exportNotification: "Se procesează cererea de export. Când ați terminat, îl veți primi prin e-mail.",
        exportError: "Prea multe solicitări în curs. Vă rugăm să încercați din nou mai târziu.",
        exportPanelTooltip: "Selectați cel puțin o coloană pentru a continua"
    },
    comments: {
        weekdays: ["D", "L", "M", "Mi", "J", "V", "S"],
        noComments: "Nici un comentariu, încă",
        userText: "a spus"
    },
    oneAtATime: {
        uiReadonly: "Acest articol este în prezent în editare.",
        uiReadonlyMessage: "Acest articol este în prezent editat de {user}",
        uiReadonlyDetail: "Veți fi anunțat când puteți începe editarea",
        uiEditableMessage: "Acum puteți edita",
        beginEditingAction: "Începeți editarea"
    },
    manageGroupsApps: {
        title: "Gestionați grupurile"
    },
    exportReports: {
        retryDownload: "Dacă descărcarea nu începe în",
        retryDownload2: "de secunde, vă rugam să apăsați butonuil de mai jos.",
        retryDlBtn: "Reîncearcă descărcarea",
        downloadBtnLabelCounter: "Reîncearcă în {counter}s ...",
        beginDownload: "Descărcarea fișierului va începe în scurt timp",
        exportTaskInfo: "Exportați datele task-urilor",
        retryDlBtn30s: "Reîncearcă în 30s ...",
        exportInstanceInfo: "Exportați datele instanțelor de proces",
        noPermission: "Nu aveți permisiunea de a accesa acestă pagină!",
        goToDashboard: "Către dashboard",
        usedBrowsers: "Puteți folosi unul din următoarele browsere suportate:",
        usedPlatforms: "Puteți folosi unul din următoarele sisteme suportate:",
        browserNotSupported: "Browser-ul folosit nu este compatibil",
        platformNotSupported: "Sistemul de operare nu este compatibil"
    },
    externalTaskLogin: {
        title: "Introduceți codul de acces pentru a continua",
        welcomeTitle: "Bine ai venit,",
        accessCode: "Cod de acces",
        continue: "Continuați",
        invalidOrExpiredToken: "Token invalid sau expirat",
        invalidOrExpiredTokenInfo: "Token invalid sau expirat, vă rugăm să contactați asistența",
        checkingAccessToken: "Verificarea tokenului de acces",
        serverDown: "Serverul nu este disponibil.",
        serverIssueMsg: "Vă rugăm să încercați mai târziu.",
        accessCodeMandatory: "Adăugați codul de acces sau faceți clic pe link-ul de mai jos pentru a obține unul nou",
        twoFactorAuthTxt: 'Contul dvs. necesită autentificare de tipul "multi-factor".',
        accessCodeSentTo: "Am trimis un cod de acces prin SMS la următorul număr:",
        accessCodeSentToEmail: "Am trimis un cod de acces prin e-mail",
        sentCode: "Dacă nu ați primit codul în 10 minute, generați unul nou",
        resendCode: "Un nou cod a fost trimis. Dacă nu îl primiți în 10 minute, generați unul nou",
        clickHere: "Retrimite codul",
        emailAddress: "Adresă de email",
        invalidAuthCode: "Codul de acces este incorect",
        expiredAuthCode: 'Codul de acces furnizat este expirat. Faceți clic pe "Retrimite codul" pentru unul nou',
        taskNoLongerActive: "Acest task nu mai este activ",
        newAccessCodeSent: "A fost trimis un nou cod de acces.",
        resendInTime: "Retrimiteți in {time}",
        tokenExpired: "Tokenul dvs. a expirat",
        taskExpired: "Task-ul dvs. nu mai este activ.",
        taskCompleted: "Mulțumim!",
        taskCompletedInfo: "Task-ul dvs. a fost trimis cu succes.",
        roLang: "RO",
        enLang: "EN"
    },
    timeline: {
        title: "Cronologia procesului",
        search: "Căutare",
        loadMore: "Încărcați mai mult",
        timelineOf: "Cronologia procesului ",
        collapseAll: "Reduceți totul",
        ON_TRACK: "LA TIMP",
        ATTENTION: "ÎN ATENŢIE",
        AT_RISK: "ÎN AVERTIZARE",
        OVERDUE: "ÎNTÂRZIAT",
        actionBy: "de către",
        onBehalfOf: "în numele lui",
        openComment: "Comentariu deschis",
        errorTask: "Eroare la primirea detaliilor task-ului!",
        CLAIM: "Preluat",
        CREATE: "Creat",
        SUBMIT: "Trimis",
        DELEGATION: "Delegat",
        SAVE_DATA: "Salvat",
        JAVA_SCRIPT_EXECUTED: '"JavaScript"',
        TASK_TIMER_TRIGGERED: "Expirat",
        SAVE_FOR_LATER: "Salvat",
        ASSIGN: "Atribuit",
        TASK_CLOSE: "Închis",
        UN_CLAIM: "Nepreluat",
        AUTO_REJECT: "Respingere automată",
        REASSIGN: "Realocat",
        START_SUBPROCESS: "început",
        submittedAction: "Trimis cu ",
        autosubmitAction: "Trimis automat cu ",
        startAction: "A început",
        instanceLabel: "instanța de proces",
        processLabel: "proces",
        exitedAction: "Ieșit cu ",
        submitBy: "de către",
        assignedTo: "la",
        task: "Task",
        eventAction: "Raspuns pentru",
        listeningValidRsp: "Se asteapta un raspuns valid...",
        eventReceved: "primit de",
        Response: "Răspuns primit",
        Request: "Request trimis",
        apiService: "APIService",
        executedBy: "Sistem",
        executedAction: "executat",
        levelMatrixDetails: "PE",
        approve: "Aprobați",
        reject: "Respingeți",
        autoApprove: "Aprobare automată",
        autoReject: "Respingere automată",
        approveLevel: "Aprobat",
        rejectLevel: "Respins",
        autoApproveLevel: "Aprobat automat",
        autoRejectLevel: "Respins automat",
        started: "Pornit de la",
        system: "Sistem",
        inProgress: "ÎN PROGRES",
        noTrueRule: "Nici o regulă nu a fost evaluată ca fiind adevărată",
        noResultsAvailable: "Nu există rezultate disponibile",
        singularDecision: "Aprobator (decizie \"singulară\")",
        groupDecision: "Aprobator (pragul setat la \"{count}\" aprobări)",
        overriderDecision: "Aprobator suprem",
        evaluatorDecision: "Evaluator",
        SMS: "trimis",
        EMAIL: "trimis",
        uploadedBy: "încărcat de",
        generatedBy: "generat de",
        retried: "Reîncercat",
        terminated: "Terminat",
        downloadedLog: "Log descărcat",
        viewedLog: "Log vizualizat",
        savedDataModel: "Model de date salvat",
        deleteDataModel: "Valorile modelului de date a fost sters",
        deleteDataModelAudit: "Auditul valorilor modelului de date a fost sters",
        anonymizeInfo: "Anonimizarea datelor personale",
        archived: "Arhivat",
        on: "pe",
        using: "folosind",
        changeMadeBy: " modificare făcută de ",
        changesMadeBy: " modificări făcute de ",
        valueChanges: "Modificări",
        viewDataAudit: "Vizualizați auditul de date",
        deleteCommentAudit:"Comentariul a fost sters",
        added: "adăugat(e)",
        removed: "îndepărtat(e)",
        edited: "editat(e)",
        subtitleDeteletedProcess: "Instanța procesului a fost ștearsă"
    },

    fabricInterface: {
        taskWindow: "Fereastra task-ului",
        appTracer: "Urmărirea aplicațiilor",
        minSidebar: "Minimizați bara laterală",
        taskInfoTitle: "Informații despre task",
        timelineTitle: "Cronologie",
        docsTitle: "Documente",
        commTitle: "Comentarii",
        taskErrorsTitle: "Erori de activitate",
        noErrorsFound: "Nicio eroare găsită",
        errors: "eroare | erori",
        errorsFound: "O eroare a fost găsită | {count} Erori au fost găsite",
        submitErrorMessage: "Fixați eroarea pentru a continua. | Fixați erorile pentru a continua.",
        errorsTitle: "Erori interfață utilizator",
        myAccount: "Contul Meu",
        logout: "Deconectare",
        unclaim: "Resetați",
        reassign: "Realocați",
        escalate: "Escaladați",
        goBack: "Înapoi",
        saveForLater: "Salvați pentru mai târziu",
        submitData: "Trimiteți datele",
        sgMandatoryField: "Există un câmp obligatoriu care nu a fost completat.",
        multiMandatoryField: "Există câteva câmpuri obligatorii care nu au fost completate.",
        invalidFields: "Există un câmp completat greșit. | Există câteva câmpuri completate greșit.",
        configIssues: "Validarea a eșuat. Există o problemă în configurare. Vă rugăm să contactați un administator.",
        loseDataMsg: "Veți pierde datele nesalvate. Sunteți sigur?",
        landscapeTitle: "Vă rugăm să întoarceți dispozitivul în modul portret",
        landscapeDescription: "Pentru a vizualiza platforma de pe dispozitivul dvs., vă rugăm să păstrați dispozitivul în modul portret.",
        removeImage: "Ștergeți imaginea",
        editContent: "Editare conținut",
        submitTask: "Trimiteți task-ul",
        confirmInfo: "Prin confirmarea trimiterii, task-ul va fi trimis la etapa următoare și va fi considerat ca finalizat pentru dvs.",
        cancelBtn: "Anulare",
        confirmBtn: "Confirmare",
        confirmBtnMobile: "Trimitere",
        commentplaceHolder: "Lasă un comentariu",
        mandatoryComment: "Câmp obligatoriu",
        optionalComment: "Câmp opțional",
        mandatoryCommError: "Acest câmp este obligatoriu",
        selectError: "Trebuie să selectați o destinație înainte de a putea continua",
        noPreviewMsg: "Nicio previzualizare disponibilă pentru acest tip de fișier"
    },
    userInterface: {
        addNewBtn: "Creați",
        interface: "interfață utilizator | interfețe utilizator",
        fragment: "fragment | fragmente",
        labelInterfaces: "Interfețe utilizator",
        labelFragments: "Fragmente",
        results: "rezultat | rezultate",
        info1: "Începeți să adăugați câteva elemente de layout.",
        info2: "Trageți elementele de layout din bara laterală din stânga și puneți-le aici.",
        deleteInfoTitle: "Interfața/Fragmentul nu mai exista",
        deleteInfoContent: "Interfața/Fragmentul pe care încercați să-l deschideți, nu mai există sau a fost șters.",
        hasFragments: " conține fragmente. Vrei să continui?",
        mandatoryField: "Acest câmp este obligatoriu",
        codeMandatory: "Codul este obligatoriu",
        duplicateCode: "Codul este duplicat",
        duplicateCodeToast: "Există deja o interfață utilizator cu același cod!",
        nameMandatory: "Numele este obligatoriu",
        listUpdate: "Lista de interfețe utilizator a fost modificată",
        interfaceUpdate:"a fost actualizată",
        pageProp: "Proprietățile paginii",
        codeLabel: "Cod",
        nameLabel: "Nume",
        descriptionlabel: "Descriere",
        testingLabel: "Testare",
        auraAssistant: "Asistent",
        appAndBehLabel: "Aspect și comportament",
        selectTheme: "Selectați o temă",
        layoutElements: "Elementele layout-ului",
        dataModelMapp: "Mapările modelului de date",
        allPages: "Toate paginile",
        userInterfaces: "Interfețe utilizator",
        basicComponents: "Componente de bază",
        layoutStruct: "Structura layout-ului",
        standardElements: "Elementele standard",
        formElements: "Elementele formularului",
        customComponents: "Componente personalizate",
        interfaces: "Interfeţe",
        fragments: "Fragmente",
        importInterf: "Importați interfața utilizator",
        exportInterf: "Exportați interfața utilizator",
        pagesTitle: "Pagini",
        layoutTitle: "Layout",
        values: "Valorile opțiunilor",
        container: "Container",
        containerFilter: "Filtre",
        containerFilterDefault: "Fără filtru",
        positionIndex: "Poziție index",
        addItem: "Adaugă element",
        viewMode: "Interfața utilizator este deschisă în modul de vizualizare",
        importInterfaceReadonlyMode: "Nu se pot importa interfețe utilizator în modul read-only",
        addComponentReadonlyMode: "Nu se pot adăuga componente în modul read-only",
        addInterfaceFirst: "Este necesară adăugarea unei interfețe utilizator sau a unui fragment",
        leavePageMsg: "Există modificări nesalvate care vor fi pierdute",
        deleteInterfaceTitle: "Ștergere interfața utilizator",
        deleteFragmentTitle: "Ștergere Fragment",
        deleteMessage: "Sunteți sigur că doriți să ștergeți ",
        deleteElementTitle: "Ștergere Element",
        deleteElementMsg: "Sunteți sigur că doriți să ștergeți acest element?",
        confirm: "Confirmă",
        continue: "Continuă",
        errorRemoveInterface: "A existat o problemă în timpul ștergerii interfeței utilizator.",
        interfaceRemoved: "Interfața utilizator a fost ștearsă",
        importInterface: "Interfața utilizator a fost importată cu succes",
        saveInterface: "Interfața utilizator a fost salvată cu succes",
        errorInterface: "A apărut o eroare in timpul salvării interfeței utilizator",
        fragmentError: "Nu poți salva un fragment cu alt fragment in interior.",
        sameFragment: "Nu poți adăuga un fragment in interiorul aceluiași fragment.",
        addedFragment: "Fragmentul a fost adăugat deja.",
        addedSegment: "Nu poți adăuga un fragment in interiorul unui segment.",
        updateInterface: "a fost actualizată. Pentru a vizualiza ultima versiune te rog reîncarcă pagina.",
        deleteInterfaceMsg: "Interfața utilizator {interface} a fost ștearsă de către {username}.",
        noDisplayInterfaces: "Selectați sau creați o nouă interfață utilizator sau fragment",
        noInterfaces: "Nu sunt interfețe utilizator sau fragmente",
        noInterfacesDesc: "Aici se vor afișa toate interfețele utilizator sau fragmentele create ulterior",
        openModeInterface: "Interfața utilizator este deschisă in modul citire",
        loseDataMsgTitle:"Avertizare",
        loseDataMsg: "Părăsind această pagină, veți pierde modificările!",
        leaveBtn: "Confirmați",
        cancelBtn: "Anulați",
        refresh:"Actualizați",
        integerVal: "Integer",
        decimalVal: "Decimal",
        nrOfDecimals: "Numărul de zecimale",
        expressionLabel: "Expresie",
        expressionTooltip: "Validarea se aplică la iesirea din câmp",
        eventLabel: "Eveniment",
        eventTooltip: "Validarea se aplică la evenimentul selectat",
        onChangeOpt: "La schimbarea valorii",
        onDefocusOpt: "La ieșirea din câmp",
        tooltipAIDisabled: "Salvați interfața pentru a utiliza asistentul AI.",
        validation: {
            emailOpt: "Adresa de e-mail",
            regexOpt: "RegEx",
            ibanOpt: "IBAN",
            urlOpt: "URL"
        },
        data: {
            linkModel: "Corelare model get/set",
            getLabel: "Obținere date",
            setLabel: "Setare date"
        },
        properties: {
            align: "Aliniere",
            leftAlign: "Stânga",
            rightAlign: "Dreapta",
            centerAlign: "Centru",
            icon: "Icon",
            process: "Proces",
            configureProcessTitleModal: "Configurați sincronizarea datelor",
            configureProcessModalSubtitle: "Modelul de date",
            pickerPlaceholder: "Căutați modelul de date",
            dataSyncLabel: "Data sync",
            elementLabel: "element | elemente",
            addDataModel:"Model de date",
            modalTitle: "Adăugați variabile data model",
            modalCardTitle: "Data model",
            filename: "Numele fișierului",
            type: "Tipul",
            validationTxtOpt: "Text",
            validationNumberOpt: "Numeric",
            validationOthOpt: "Altele"
        },
        scriptErr: " | Scriptul conține o eroare. | Scriptul conține {n} erori.",
        renameInterface: "Redenumiți interfața utilizator",
        renamedSuccessfully: "Interfața utilizator a fost redenumită.",
        cantBeRenamed: "Interfața utilizator este editată de {user} și nu poate fi redenumită",
        emptyName: "Interfața utilizator trebuie să aibă nume",
        notFoundFr: "Fragmentul cu id {id} nu a fost găsit",
        promptAiPlaceholder: "Descrieți ce doriți ca AI să {action}",
        promptTooltip: "Solicitarea dvs. și, eventual, conținutul scriptului vor fi trimise către OpenAI pentru procesare. Nu introduceți informații sensibile.",
        auraAssist: {
            addBtn: "Adăugați",
            title: "Creează un asistent",
            editTitle: "Editează un asistent",
            actionType: "Tipul acțiunii",
            summarizeAct: "Rezumat",
            targetedSum: "Rezumat specializat",
            conversationAct: "Conversaţie",
            translateAct: "Traduceți",
            custom: "Personalizat",
            allowDocSelection: "Permite utilizatorului să aleagă documente",
            instructions: "Instrucțiuni",
            userPrompt: "Permite cerințe din partea utilizatorului",
            userRepliesPrompt: "Permite replici din partea utilizatorului",
            deleteAiAcTitle: "Ștergeți acțiunea asistentului",
            deleteAiAcBody: "Sunteți sigur că doriți să ștergeți această acțiune a asistentului?",
            promptText: "Selectați una dintre acțiunile disponibile pentru a continua",
            docsForSelection: "Selectați documentele",
            summaryDefaultBody: "Summarize the documents.",
            convDefaultBody: "Answer any questions asked by the user based on the information from the documents.",
            translateDefaultBody: "Traduceți documentele furnizate în limba indicată.",
            targetedSumBody: "Extract and summarize all information related to the topic indicated by the user from the documents.",
            targetedDocs: "Documente vizate",
            translateInfoBox: "Utilizatorul va putea selecta limba dorită",
            conversationInfoBox: "Utilizatorul va putea pune intrebari și purta conversații despre documente.",
            targetedSumInfoBox: "Utillizatorul va putea introduce un subiect.",
            docsError: "Trebuie să selectați cel puțin 1 element de interfață înainte de a salva configurația.",
            docsErrorExecution: "Trebuie să selectați cel puțin 1 element de interfață înainte de a continua",
            noUploadedDocs: "Câmpurile selectate nu conțin niciun document",
            targetTopic: "Subiect țintă",
            englishLg: "Engleză",
            frenchLg: "Franceză",
            germanLg: "Germană",
            spanishLg: "Spaniolă",
            generatingResponse: "Se generează răspuns",
            promptLabel: "Prompt",
            docsAlreadySelectedPlaceholder: "Documentele selectate",
            duplicatedName: "Numele trebuie să fie unic",
            errInstructions: "Instrucțiunile nu pot fi goale dacă prompt-ul utilizatorului este dezactivat.",
            additionalReq: "Adăugați solicitări suplimentare",
            progressTooltip: "Încărcarea documentelor și generarea răspunsului",
            progressTooltipShort: "Generare răspuns",
            noElemensAvailable: "Nu există încă elemente de 'Upload' disponibile în interfață",
            interfaceSubtitle: "Documente din interfață",
            additionalDocsSubtitle: "Documente suplimentare",
            topicLabel: "Subiect",
            exportPDFAnswers: "Exportați toate răspunsurile",
            exportPDFAll: {
                targeted: "Exportați toate răspunsurile și subiectele",
                custom: "Exportați toate răspunsurile și prompt-urile",
                conversation: "Exportați toate răspunsurile și întrebările"
            }
        }
    },
    appTasksContainer: {
        available: "Disponibile",
        claimed: "Preluate",
        delegated: "Delegate",
        delegatedFrom: "Delegat de la",
        delegatedTo: "Delegat către",
        myTasks: "Task-uri",
        myTeamsTasks: "Task-urile echipei",
        completionDate: "Data finalizării",
        timeRemaining: "Timpul rămas",
        myOpenTasks: "Task-urile mele",
        completedTasks: "Task-urile mele",
        teamsTasks: "Task-urile echipei",
        totalNumbertasks: "task-uri",
        tasksDisplayed: "afișate",
        selectAllTasks: "Toate task-urile",
        selectTasks: "Task-uri",
        selectAllStatus: "Toate statusurile",
        selectStatuses: "Statusuri",
        selectAllApps: "Toate aplicațiile",
        selectAllProcesses: "Toate procesele",
        selectApps: "Aplicații",
        selectAllUsers: "Toți utilizatorii",
        selectAllGroups: "Toate grupurile",
        selectStatus: "Status",
        selectUsers: "Utilizatori",
        selectGroup: "Echipă",
        priority: "Prioritate",
        taskName: "Task",
        instanceName: "Numele instanței de proces",
        application: "Aplicație",
        applications: "Aplicații",
        processes: "Procese",
        users: "Utilizatori",
        creationDate: "Data creării",
        assignment: "Desemnat",
        status: "Status",
        action: "Acțiune",
        viewDetails: "Vizualizați",
        loadMoreFirst: "Încărcați mai multe",
        onTrack: "La timp",
        atRisk: "În avertizare",
        attention: "În atenţie",
        overdue: "Întârziat",
        goTop: "Înapoi sus",
        unclaimAction: "Resetați",
        reassignAction: "Realocați",
        noTasks: "Nu există task-uri disponibile",
        hours: " ore",
        minutes: " minute",
        days: " zile",
        weeks: " săptămâni",
        critical: "Mai puțin de 1 minut",
        priorityTooltip: "prioritate",
        UNCLAIM: "Resetați in masă",
        REASSIGN: "Realocați in masă",
        cancelBulk: "Anulați",
        tasks: "task-uri",
        task: "task",
        tasksSelectedUNCLAIM: "selectate pentru resetare",
        tasksSelectedREASSIGN: "selectate pentru a fi realocate",
        settingsTitle: "Setările coloanei",
        settingsConfirm: "Confirmă",
        settingsDefault: "Implicit",
        settingsCancel: "Anulați",
        completedTeamsTasks: "Task-urile echipei",
        completedBy: "Completat de"
    },
    submitModal: {
        modalTitle: "Trimiteți",
        submitAction: "Trimiteți acțiunea",
        commentInput: "Comentariu"
    },
    adminUsersGroups: {
        usersGroupsTitle: "Utilizatori & Grupuri",
        searchField: "Căutare",
        tabUsersTitle: "Utilizatori",
        tabGroupsTitle: "Grupuri",
        itemsDisplayed: "afișate",
        results: "rezultat | rezultate",
        numberItemUSERS: "utilizator | utilizatori",
        numberItemGROUPS: "grup | grupuri",
        andWord: "și",
        typeLabel: "Tip",
        statusLabel: "Status",
        allTypesLabel: "Toate tipurile",
        allStatusLabel: "Toate statusurile",
        createNewUSERS: "Creează un nou utilizator",
        createNewGROUPS: "Creează un nou grup",
        typeEXTERNAL: "Extern",
        typePLATFORM: "Platformă",
        typeSYSTEM: "Sistem",
        typeAPPLICATION: "Aplicație",
        optionTypeApp: "Aplicație",
        typeACTIVE: "Activ",
        typeINACTIVE: "Inactiv",
        typeDISABLED: "Dezactivat",
        disabledTypeOn: "Dezactivat pe ",
        lastLogin: "Ultima logare: ",
        noLastLogin: "Ultima logare: Niciodată",
        disabledTypeAt: " la ",
        loadMoreButton: "Încărcaţi mai mult",
        noGROUPS: "Nu există grupuri disponibile",
        noUSERS: "Nu există utilizatori disponibili",
        inviteBulkUsers: "Invitație multiplă",
        createNew: "Creează",
        bulkuserStatusTitle: "Status utilizatori noi",
        disabledUser: "Dezactivat (utilizatorii trebuie să-și confirme contul)",
        activeUser: "Activ",
        bulkInviteModalListing: "listare | listări",
        bulkInviteModalInvalidEntries: "intrări invalide",
        formatInstructions: "Instrucțiuni de formatare:",
        formatInstruction: "Numărul de telefon trebuie să înceapă întotdeauna cu „+” și codul țării",
        emailInvalidMsg: "Formatul adresei de e-mail invalid. Va fi omisă în timpul invitării.",
        phoneInvalidMsg: "Formatul numărului de telefon invalid. Va fi omis în timpul invitării.",
        doneBtn: "Terminat",
        downloadTemplate: "Descarcă șablon",
        downloadSubtitle: "Selectează formatul de fișier dorit dintre opțiunile permise de mai jos",
        uploadTitle: "Încărcați fișierul",
        uploadInfo: "Încărcați fișierul .csv, .xls, .xlsx aici sau <br> apasă aici pentru a îl căuta prin calculatorul tău.",
        dialogTitle: "Unele adrese de email sau numere de telefon nu sunt valide",
        dialogMessage:
            "{invalidEntries} din cele {totalEntries} de intrări importate au date incorecte și nu vor primi invitație. Trimitem invitații către celelalte {availableEntries}{space}",
        emailAddress: "adrese ramase?",
        invalidEntriesMessage: "Format de adresă de e-mail sau număr de telefon greșit sau deja existent. Nu vor primi invitație.",
        multipleInvitesToastMsg: " utilizatori au fost invitați cu succes.",
        oneInviteToastMsg: "Utilizatorul a fost invitat cu succes.",
        noAvailableEmails: "Toate intrările importate au date incorecte și nu vor primi invitație. Te rugăm să încarci alt fișier, cu date corecte.",
        noAvailableEmailsTitle: "Emailuri invalide",
        invalidFile: "Fișier invalid",
        invalidFileText: "Fișierul pe care l-ai selectat este incorect. Încarcă un fișier corect și încearcă din nou."
    },
    applicationSettingsSidebar: {
        settings: "Generic",
        workSchedule: "Program de lucru",
        applicationGroups: "Grupuri specifice",
        permissions: "Permisiuni"
    },
    applicationPermissions: {
        title: "Seturi de permisiuni",
        search: "Căutare",
        itemsResults: " rezultate",
        OWNERRole: "Posesor",
        OWNERRoleDesc: "Acces complet oriunde în aplicație",
        INITIATORTitle: "Inițiază",
        INITIATORRole: "Inițiați toate procesele",
        INITIATORRoleDesc: "Permisiunea de a iniția orice proces din aplicație",
        ADMINISTRATORRole: "Gestionați permisiunile și grupurile",
        ADMINISTRATORRoleDesc: "Creați și editați grupuri specifice, acordați și eliminați permisiuni.",
        EDITORRole: "Proiectarea și configurarea elementelor de business",
        EDITORRoleDesc:
            "Creați și configurați procese, interfețe utilizator, șabloanele de documente, modelul de date și cataloage. Vizualizați integrări și contracte inteligente.",
        DIAGRAM_EDITORRole: "Fluxul modelului de aplicație",
        DIAGRAM_EDITORRoleDesc:
            "Creați și configurați procese, interfețe utilizator, șabloanele de documente. Vizualizați integrări, contracte inteligente, modelul de date și cataloage.",
        REPORTS_VIEWERRole: "Vizualizați analitice",
        REPORTS_VIEWERRoleDesc: "Vizualizați sarcinile și instanțele de proces ale aplicației, statisticile proceselor, fluxul de procese și interfețele task-urilor.",
        TASKS_MANAGERRole: "Realocați task-urile",
        TASKS_MANAGERRoleDesc: "Renunțați și realocați toate atribuțiile de sarcini din aplicație prin analitice sau vizualizări de date.",
        SMART_CONTRACT_DESIGNERRole: "Funcții contracte inteligente",
        SMART_CONTRACT_DESIGNERRoleDesc: "Creați și configurați contracte inteligente. Vizualizați procese, modelul de date și cataloage.",
        INTERFACES_MANAGERRole: "Designul interfețelor utilizator",
        INTERFACES_MANAGERRoleDesc: "Creați, editați și ștergeți interfețe utilizator. Vizualizați procese, șabloanele de documente, integrări, modelul de date și cataloage.",
        DOCUMENTS_MANAGERRole: "Designul șabloanelor de documente",
        DOCUMENTS_MANAGERRoleDesc:
            "Creați, editați și ștergeți șabloanele de documente. Vizualizați procese, interfețe utilizator, integrări, modelul de date și cataloage.",
        PERSPECTIVE_MANAGERRole: "Designul vizualizărilor de date",
        PERSPECTIVE_MANAGERRoleDesc: "Creați, editați și ștergeți vizualizările de date. Vizualizați interfețe utilizator.",
        PerspectiveRoleDesc: "Acest utilizator poate accesa vizualizările de date.",
        API_MANAGERRole: "Configurați integrări",
        API_MANAGERRoleDesc:
            "Editați, adăugați și ștergeți integrările aplicațiilor. Vizualizați procese, interfețe utilizator, șabloanele de documente, modelul de date și cataloage.",
        VIEWERRole: "Accesați aplicația în modul vizualizare",
        VIEWERRoleDesc: "Vizualizați toate modulele aplicației în modul citire.",
        SIDEBARContainerRole: "Vizualizați panourile de informații și resurse ale interfeței task-ului",
        SIDEBARContainerRoleDesc: "Accesați documentele instanței de proces, cronologia, comentariile și panourile informative cu detaliile task-ului din interfața task-ului",
        INITIATORContainerRole: "Inițiați procese",
        INITIATORContainerRoleDesc: "Permisiunea de a iniția procese în aplicație",
        SIDEBAR_DOCUMENTSRole: "Vizualizați documentele instanței de proces",
        SIDEBAR_COMMENTSRole: "Vizualizați comentariile instanței de proces",
        SIDEBAR_TIMELINERole: "Vizualizați cronologia instanței de proces",
        SIDEBAR_TASK_INFORMATIONRole: "Vizualizați informațiile task-ului",
        SIDEBARRole: "Vizualizați toate activitățile",
        PUBLISH_APPRole: "Publicați aplicația",
        PUBLISH_APPRoleDesc: "Permisiune de a publica aplicația.",
        DATA_MODEL_MANAGERRole: "Definiți și configurați modelul de date și cataloage",
        DATA_MODEL_MANAGERRoleDesc: "Adăugați, editați și ștergeți clasele și atributele modelului de date, definițiile și valorile catalogului.",
        CATALOGS_MANAGERRole: "Editați cataloagele",
        CATALOGS_MANAGERRoleDesc: "Definește structura și valorile cataloagelor.",
        DATA_MODEL_VIEWERRole: "Vizualizați modelul de date și cataloage",
        DATA_MODEL_VIEWERRoleDesc: "Vizualizați clasele și atributele modelului de date. Vizualizați cataloagele.",
        permissionOnlyOneUser: "Această permisiune poate avea doar 1 utilizator",
        buildingTab: "Construire",
        initiateTab: "Inițiere",
        tasksTab: "Task-uri",
        dataViewsTab: "Vizualizări de date",
        analyticsTab: "Analitice",
        settingsTab: "Setări",
        viewDetailsBtn: "Vizualizați detaliile permisiunii",
        changeBtn: "Schimbați",
        addNewBtn: "Adăugați",
        permissionsFirst: "Această permisiune are ",
        permissionsSecond: "și ",
        group: "grup",
        groups: "grupuri",
        user: "utilizator",
        users: "utilizatori",
        usersAndGroups: "utilizatori și grupuri",
        displayed: "afișate",
        noUsersAndGroups: "Această permisiune nu are nici utilizatori nici grupuri",
        givePermissions: "Acordați permisiuni",
        saveAddPermission: "Permisiunile au fost adăugate cu succes",
        noResultsFound: "Niciun rezultat gasit",
        noResultsFoundDetails: "Nu am putut găsi niciun rezultat pentru căutarea dumneavoastră.",
        noData: "Lipsă date",
        noDataDisplayed: "Nu există date de afișat",
        tooltipPermissions: "Vizualizarea permisiunilor",
        tooltipUsers: "Vizualizarea utilizatorilor",
        alreadyExisting: "Elemente deja existente",
        newlyAdded: "Elemente nou adăugate",
        addConfirmationMsg: "Permisiunile au fost salvate cu succes",
        removeConfirmationMsg: "Permisiunile au fost eliminate cu succes"
    },
    applicationPermsViewDet: {
        title: "Vizualizați detaliile permisiunii",
        titleEditor: "Editor",
        titleSection: "Secțiune",
        titleManage: "Admin.",
        titleView: "Viz.",
        appSettings: "Setările aplicației",
        highlights: "Detalii",
        workSchedule: "Program de lucru",
        updateApp: "Actualizați aplicația",
        exportApp: "Exportați aplicația",
        managePerms: "Administrați permisiunile",
        manageAppGr: "Administrați grupurile aplicației",
        diagrams: "Procese",
        smartConDes: "Contracte inteligente",
        interfaceBuilder: "Interfețe utilizator",
        docBuilder: "Șabloane de documente",
        perspectiveBuilder: "Vizualizări personalizate de date",
        apis: "Integrări",
        dataModel: "Model de date",
        catalogs: "Cataloage",
        catalogDef: "Definiția catalogului",
        catalogValues: "Valorile catalogului",
        reports: "Analitice",
        instancesTasks: "Vizualizare date live",
        statistics: "Statistici proces",
        reassign: "Realocați task-uri",
        unclaim: "Resetați task-uri",
        publish: "Publicați"
    },
    applicationChangeOwner: {
        title: "Schimbați posesorul aplicației",
        subtitle: "Posesor curent",
        ownerChanged: "Posesorul a fost schimbat cu succes"
    },
    appEditPermissions: {
        title: "Editați permisiunile",
        memberTitle: "Membru",
        other: "Alte permisiuni",
        inharited: "Moștenit din grupurile părinți:",
        inheritedDesc: "Acest utilizator are următoarele permisiuni de acces moștenite de la grupurile în care este inclus:",
        permissions: "Permisiuni",
        tooltipSave: "Utilizatorul trebuie să aibă cel puțin o permisiune selectată",
        remove: "Elimină",
        cancel: "Anulează",
        removeUser: "Elimină element",
        dialogBody: "Această acțiune va elimina {type} din '{permissionName}'",
        dialogBodyDefault: "Această acțiune va elimina toate permisiunile",
        dialogBodyGroup: "Această acțiune va elimina toate permisiunile directe pentru acest grup",
        dialogBodyUser: "Această acțiune va elimina toate permisiunile directe pentru acest utilizator",
        saveEditPermission: "Permisiunile au fost actualizate cu succes",
        removeEditPermission: "Permisiunile au fost eliminate cu succes",
        owner: "POSESOR"
    },
    appSetPermissions: {
        title: "Setați permisiunile",
        editTitle: "Editați permisiunile",
        appTitle: "Aplicație",
        placeholderApp: "Selectați aplicația",
        addPermissions: "Adăugați permisiunile",
        directPermissions: "Permisiuni directe",
        directPermDesc: "Acest grup are următoarele permisiuni de acces acordate direct",
        directPermDescUser: "Acest utilizator are următoarele permisiuni de acces acordate direct",
        inheritedPermissions: "Moștenit din grupurile părinți",
        inheritedPermDesc: "În urma permisiunilor de acces moștenite de la grupurile în care este inclus",
        inheritedPermDescUser: "Acest utilizator are următoarele permisiuni de acces obținute în urma apartenenței la anumite grupuri",
        code: "Cod:",
        permissions: "permisiuni",
        remove: "Eliminați",
        requiredMsgApp: "Vă rugăm să selectați o aplicație",
        requiredMsgPerm: "Selectați una sau mai multe permisiuni",
        group: "grup",
        groups: "grupuri"
    },
    uploader: {
        defaultTitle: "Încărcați un fișier aici",
        uploadText: "Încărcați",
        uploadFiles: "fișierul",
        uploadText2: "max",
        uploadText3: "sau",
        uploadText4: "apăsați aici",
        uploadText5: "pentru a îl căuta prin calculatorul tău.",
        duplicatedNameErr: "Fișierul este deja încărcat",
        addedFiles: "fișier adăugat | fișiere adăugate",
        ignoredFiles: "fișier ignorat | fișiere ignorate",
        fileSizeError: "Mărimea fișierului este prea mare",
        extensionError: "Formatul fișierului nu este admis",
        allowExtensions: "Extensii acceptate",
        uploadTitle: "Fișier încărcat",
        updateUploadTitle: "Actualizare aplicație",
        samlUploadTitle: "Încarcă fișierul de metadate pentru Identity Provider",
        uploadSubTitle: "Încărcați un fișier <b>{allowedExtensions}</b> in această zonă, sau {clickHere} pentru a îl căuta prin calculatorul tău."
    },
    froala: {
        insertPageBreakTooltip: "Inserează limită pagină",
        pastePlainTextTooltip: "Comutați lipește sub forma text simplu",
        directionRTLTooltip: "Orientare text de la dreapta la stânga",
        directionLTRTooltip: "Direcția textului de la stânga la dreapta",
        renameDocumentTitle: "Redenumiți șablonul documentului",
        pageA4Tooltip: "Pagina A4",
        pageA3Tooltip: "Pagina A3",
        toggleBlocksTooltip: "Arată blocuri",
        dynamicTableTooltip: "Inserare tabel din modelul de date",
        richTextBlockTooltip: "Inserați bloc de text îmbogățit",
        dynamicImageTooltip: "Inserați imagine dinamică",
        dynamicTable: "Tabel dinamic",
        header: "Antet",
        footer: "Subsol",
        dataModel: "Model de date",
        backgroundImage: "Imagine de fundal",
        firstPage: "Prima pagină diferită",
        firstPageTab: "PRIMA PAGINA",
        otherPagesTab: "ALTE PAGINI",
        pageNumbers: "Numerele paginilor",
        pageNr: "Număr pagină",
        pagesCount: "Număr de pagini",
        conditionalBlock: "Bloc condițional",
        richTextBlock: "Bloc text îmbogățit",
        dynamicImage: "Imagine dinamică",
        conditionalBlockTooltip: "Inserare bloc condițional",
        repeatableBlock: "Bloc repetitiv",
        repeatableBlockTooltip: "Inserare bloc repetitiv",
        separatorError: "Nu puteți folosi \"{char}\" ca separator",
        decimalError: "Separatorul zecimal nu poate fi gol",
        insertLineBefore:"Adauga linie noua inainte",
        insertLineAfter: "Adauga linie noua dupa",
        customDateTitle: "Formatare dată",
        customNrTitle: "Formatare numere",
        settings: "Setări",
        delete: "Ștergeți",
        addBefore: "Adăugați linie nouă înainte",
        addAfter: "Adăugați linie nouă după",
        downloadPreviewPDF: "Previzualizare ca PDF",
        downloadPreviewDOCX: "Previzualizare ca DOCX",
        failedPreview: "Nu poți avea atribute de tip listă în afara unui bloc repetitiv sau a unui tabel dinamic",
        moveRight: "Mută coloana la dreapta",
        moveLeft: "Mută coloana la stânga",
        moveUp: "Mută linia în sus",
        moveDown: "Mută linia în jos",
        transpose: "Transpune",
        transposeDisabled: "Transpunerea nu este posibilă pentru tabelele dinamice sau tabelele cu celule îmbinate sau împărțite.",
        reorder: "Reordonează",
        reorderDisabled: "Reordonarea nu este posibilă pentru tabelele cu celule îmbinate sau împărțite."
    },
    globalDataModel: {
        entitiesTitle: "Tabele de date",
        entitiesLegacy: "Tabele de date Legacy",
        invalidEntries: "intrări invalide pe",
        invalidCell: "celulă | celule",
        invalidRows: "rând | rânduri",
        latestDisplayed: "Sunt afișate ultimele {number} inregistrări",
        refreshData: "Reîncărcați",
        addNewData: "Adăugați date",
        createNewEntity: "Creează",
        importEntity: "Importați",
        entities: "tabelă de date | tabele de date",
        numberItems: "rezultat | rezultate",
        searchEntities: "Căutați tabele de date",
        viewAs: "Văzut ca",
        createEntityTitle: "Creează o nouă tabelă de date",
        settings: "Setări",
        name: "Nume",
        code: "Cod",
        type: "Tipul de dată",
        addColumn: "Adaugă coloană",
        editColumn: "Editează coloană",
        source: "Sursă",
        aurachain: "{brandName}",
        microsoftSQL: "Microsoft SQL Server",
        MySQL: "MySQL",
        oracle: "Oracle",
        catalogType: "Catalog",
        wrongPatternErr: "Numele poate conține litere, cifre și caractere speciale ca underline, cratimă și spațiu. Primul element trebuie să fie literă.",
        wrongPattern: "Numele poate conține maxim 60 de caractere alfanumerice precum: litere, cifre și caractere speciale  underline, cratimă și spațiu.",
        wrongPatternCode: "Codul poate conține maxim 60 de caractere alfanumerice precum: litere, cifre și caracterul special underline",
        wrongPatternEntityName: "Numele tabelei poate conține maxim 60 de caractere alfanumerice precum: litere, cifre și caractere speciale  underline, cratimă și spațiu.",
        duplicateName: "Numele introdus există deja",
        duplicateCode: "Codul introdus există deja",
        alreadyEdited: "Această tabelă este în editare la userul {userName} și nu poate fi ștearsă",
        alreadyInRoom: "Această tabelă este în editare la userul {userName} și nu poate fi redenumită",
        tooltipInfo: "Coloana cheie primară generată automat cu valori întregi incrementale unice pentru fiecare rând",
        permCard: "Permisiunile aplicației",
        renameEntityToast: "Tabela {entityName} a fost redenumită cu succes",
        duplicatedEntityToast: "Numele tabelei există deja.",
        emptyNameEntity: "Numele tabelei nu poate fi gol.",
        duplicatedEntity: "Numele tabelei există deja",
        wrongPatternEntity: "Numele tabelei poate conține maxim 60 de caractere alfanumerice precum: litere, cifre și caracterele speciale underline, cratimă și spațiu.",
        addNewAtt: "Adăugați atribut",
        addNewColumn: "Adăugați coloană",
        attType: "Tipul atributului",
        columnType: "Tip",
        addAnother: "Adăugați încă unul ",
        addAnotherColumn: "Adăugați încă una",
        emptyName: "Acest câmp este obligatoriu!",
        globalEntities: "Tabele de date",
        editTitle: "tabela de date",
        deleteEntity: "Ștergeți",
        deleteTitle: "Ștergeți tabela de date",
        deleteMsg: "Sigur doriți să ștergeți această tabelă de date? Această acțiune o va șterge împreună cu toate datele sale și este ireversibilă.",
        publishedDeleteMsg: "Tabela de date și datele ei vor fi șterse. Această acțiune este ireversibilă. Este recomandat să exportați datele înainte de a continua această acțiune.",
        deleteForever: "Ștergeți pentru totdeauna",
        deletedMsg: "Tabela a fost ștearsă cu succes",
        deletedMsgStore: "Tabela {entityName} a fost ștearsă cu succes",
        editEntity: "Editați",
        permissions: "Permisiuni",
        permissionsLabel: "{entityName} permisiuni",
        editPermissions: "Editați permisiuni",
        accessPermissions: "Permisiuni de acces",
        addNewAccessPermissions: "Adăugați o permisiune nouă",
        emptyElement: "Acest element este obligatoriu",
        addPermission: "Adăugați permisiune",
        renameDataTable: "Redenumește tabela de date",
        rename: "Redenumește",
        emptyEntityName: "Numele nu poate fi gol",
        applications: "Aplicații",
        dataAccess: "Access la date",
        audit: "Audit",
        viewDataAudit: "Vizualizare audit de date",
        notifyToast: "Lista de permisiuni pentru {entityName} a fost actualizată cu succes",
        view: "Vizualizare",
        edit: "Editare",
        duplicatedName: "Numele introdus există deja",
        save: "Salvați",
        onlyDecimal: "Doar valori de tip decimal pot fi adaugate",
        onlyInteger: "Doar valori de tip integer pot fi adaugate",
        publishInfo: "Data ultimei publicări: ",
        unpublishedInfo: "Nepublicat",
        toastMsg: "Tabela de date a fost publicată cu succes!",
        deleteRow: "Ștergeți rândul",
        deleteData: "Ștergere date",
        deleteRowMsg: "Sigur doriți să ștergeți acest rând? Odată șters, nu-l veți putea recupera.",
        deleteDataMsg: "Acțiunea va elimina rândurile și este ireversibilă.",
        confirmBtn: "Continuați",
        copySwaggerLink: "Copiere URL pentru descriptor Swagger",
        downloadSwagger: "Descărcare descriptor Swagger",
        deleteBtn: "Ștergeți",
        editAtt: "Editați Atributul",
        deleteAttTitle: "Ștergeți atributul",
        deleteColumnTitle: "Ștergeți coloana",
        deleteAttMsg: "Această acțiune este ireversibilă și afectează orice aplicație care utilizează acest atribut.",
        deleteColumnMsg: "Această acțiune este ireversibilă și afectează orice aplicație care utilizează această coloană.",
        deletedAttMsg: "Atributul a fost șters cu succes.",
        deletedColMsg: "Coloana a fost ștearsă cu succes.",
        editedAttToast: "Atributul a fost actualizat cu succes.",
        editedColToast: "Coloana a fost editată cu succes.",
        addedAttribute: "Atributul a fost adăugat cu succes.",
        addedColumn: "Coloana a fost creată cu succes.",
        invalidInput: "Numele conține caractere invalide.",
        updateEntity: "Tabela de date a fost actualizată cu succes",
        deleteTooltip: "Atributul Row ID nu se poate șterge",
        deleteTooltipColumn: "Coloana ID nu se poate șterge",
        export: "Exportă",
        exportEntityDetails: "Detalii extensie fisier (.xlsx)",
        exportEntityMethod: "Metodă",
        download: "Descarcă",
        sendByEmail: "Trimite pe email (recomandat pentru volum mare de date)",
        exportEntitMethod: "Methodă",
        structure: "Structură",
        data: "Dată",
        successExportStructure: "Structura a fost exportată cu succes",
        successExportData: "Datele au fost exportate cu succes",
        exportConfig: "Configurare export",
        exportByEmail: "Se procesează exportul de structură si dată. După terminare îl veți primi pe email.",
        importData: "Importă date",
        import: "Importă",
        entries: "intrări",
        importAFile: "Importă un fișier",
        fileHasErrors: "Fișierele care contin erori nu pot fi importate",
        noUnpublishedEntity: "Nu se pot importa date pe tabele de date nepublicate",
        invalidExcelEntries: "Fișierul conține intrări invalide",
        invalidFile: "Structura fișierului nu se potrivește cu structura tabelei de date",
        allowedDataFormats: "Formatul de date acceptat",
        rowIdInfo: "6 caractere alphanumerice, numere între 0-9 și litere mici ",
        row: "Rand",
        error: "Eroare",
        separated: "separat de punct",
        invalidFileStructure: "Structură de date invalidă",
        noAttError: 'Atributul cu numele de "{attributeName}" nu există sau nu este publicat.',
        rowIdValidation: "Formatul Row ID trebuie să contină 6 caractere.",
        rowIdUnique: "Row ID trebuie sa fie unic.",
        invalidDataFormat: 'Format de date invalid pe "{name}".',
        uploadFileTitle: "Încarcă fișierul structurii",
        uploadInstruction: "Instrucțiuni pentru încărcare:",
        instructionLine: "Atributele suportate sunt: ",
        instructionLine1: "string, integer, decimal, datetime, date, time",
        instructionLine2: "și",
        instructionLine3: "boolean.",
        instructionLine4: "The",
        instructionLine5: "Codul tabelei de date, atributul Row ID",
        instructionLine6: "și",
        instructionLine7: " codul fiecărui atribut",
        instructionLine8: "vor fi generate automat de sistem.",
        importModalTitle: "Importă tabelul din fișerul CSV",
        csvFile: "Fișer CSV",
        allowedDataFormatsText: "Formatul de date acceptat:",
        instrLine1: "datetime:",
        instrLine2: "yyyy-mm-ddThh:mm:ss+hh:mm",
        instrLine3: "date:",
        instrLine4: "yyyy-mm-dd",
        instrLine5: "time:",
        instrLine6: "hh:mm:ss+hh:mm",
        instrLine7: "boolean:",
        instrLine8: "true, false",
        instrLine9: "decimal - ",
        instrLine10: "separat de “.”",
        importBehaviourText: "Importă comportamentul:",
        instrLine11: "Fiecare rând din tabela de date va primi automat un număr unic, incremental.",
        instrLine12: "ID:",
        instrLine13: "integer",
        ruleUseIdFromFile: "Coloana ID selectată necesită ID-uri unice. Liniile fără ID sau cu ID existent în tabelă vor fi ignorate.",
        ruleUpdateExistingRows: "Liniile sunt actualizate in funcție de coloana ID. Liniile fără ID sau cu ID negăsit în tabelă vor fi ignorate.",
        errorNoColumn: "Minim o coloană trebuie să fie selectată",
        errorNoId: "Coloana 'ID' trebuie să fie mapată",
        uploadYourFileTitle: "Încarcă fișierul tău",
        importDataLabel: "Importați date în tabela {entityName}",
        table: "Tabel",
        addNewRows: "Adaugă linii noi",
        updateExistingRows: "Actualizează liniile existente",
        autoGenerateId: "Auto-generează ID-uri",
        idFromFile: "Utilizează ID-urile din fișier",
        errorDuplicateColumns: "Fișierul are coloane duplicate.",
        errorFileEmpty: "Fișierul este gol.",
        alreadyMapped: "Deja folosită",
        invalidStructure: "Structură de fișier invalidă",
        dataNotSupported: 'Tipul de date "{invalidDataInFile}" nu este suportat.',
        missingData: 'Lipsește un nume sau tip de atribut la linia "{invalidDataInFile}" ',
        duplicatedData: 'Numele "{invalidDataInFile}" nu este unic',
        successImportedFile: "Datele au fost importate cu succes",
        importInfoBehaviour: "Comportament la import:",
        importInfoBehaviour1: "Intrările din fișier fără valoare în câmpul “Row ID” vor fi adăugate ca linii noi în tabela de date și li se va genera un Row ID random",
        importInfoBehaviour2: "Intrările din fișier cu  valoare în câmpul “Row ID”:",
        importInfoBehaviour3: "Pentru care nu se regăsește Row ID-ul în baza de date, se vor adaugă că linii noi și li se va alocă Row ID-ul din fișier",
        importInfoBehaviour4: "Pentru care se regăsește Row ID-ul în baza de date , se vor actualiza cu datele din fișier",
        entityCreated: "Tabela de date a fost creeată cu succes",
        importSuccessMsg: "Cererea de import se procesează. Când se va finaliza, vei fi notificat via email.",
        createSuccessMsg: "Cererea de creare se procesează. Când se va finaliza, vei fi notificat via email.",
        columnMappedError: "Coloana trebuie să fie mapată",
        autoGeneratedId: "ID auto-generat",
        importInProgress: "Există deja un import în desfășurare pentru această tabelă de date",
        errorUploadEmptyFile: "Fișierul este gol.",
        errorUploadDuplicatedColumns: "Fișierul are coloane duplicate.",
        errorUploadCSVHeader: "Eroare la citirea antetului fișierului CSV.",
        disabledAddDataBtnTooltip: "Nu se pot adăuga date într-o tabelă de date nepublicată",
        noDataToExport: "O tabelă de date nepublicată nu se poate exporta",
        noSwaggerDownload: "Nu se poate descărca descriptorul pentru o tabelă de date nepublicată",
        importedRows: "Importul va adăuga {newRows} noi rânduri și va updata {updatedRows} rânduri existente",
        personalInfo:"Informație personală",
        noResults: "Nu a fost găsit nici un rezultat",
        selectEntity: "Selectați sau creați o nouă tabelă de date",
        choseAction: "Alegeți următoarea acțiune în funcție de nevoile dvs.",
        noEntity: "Nu există încă tabele de date create",
        firstCreate: "Odată ce îți vei crea prima tabelă de date, aceasta va apărea aici",
        headerPublishedTooltip: "Structura tabelei de date este publicată și la zi.",
        headerUnpublishedChangesTooltip: "Structura tabelei de date are modificări nepublicate.",
        codeForSubtitle: "Cod:",
        wrnMsg: "Selectând ștergerea datelor, veți pierde modificările nesalvate.",
        wrnMsgDel: "Selectând această acțiune, veți pierde modificările nesalvate.",
        rowsDeleted: "Rândurile au fost șterse cu succes",
        dataDeleted: "Datele au fost șterse cu succes",
        columns: "Coloane",
        columnMapping: "Maparea coloanelor",
        deleteAllData: "Ștergeți toate datele",
        deleteAllDataMsg: "Datele din tabel vor fi șterse. Această acțiune este ireversibilă. Este foarte recomandat să faceți o copie de rezervă a datelor înainte de a continua cu acțiunea.",
        deleteEntityMsg: "Acțiunea este ireversibilă și orice aplicație care utilizează tabelul de date nu va mai funcționa corect.",
        deleteTable: "Ștergeți tabela",
        dataAudit: "Auditul datelor",
        tooltipOldValue: "Valoare veche: \"{oldValue}\"",
        dataAuditTitle: "{entityName} audit de date",
        warningRightIconTooltip: "Această coloană este mapată de mai multe ori",
        modifiedBy: "Modificat de",
        modifiedVia: "Modificat prin",
        event: "Eveniment",
        eventDate: "Data evenimentului",
        processInstanceId: "ID-ul instanței de proces",
        applicationId: "ID aplicație",
        modifiedByUserId: "Modificat de (ID utilizator)",
        exportCsv: "Export în CSV",
        warningMessage: "Modificarea tipului unui atribut poate duce la probleme atunci când valorile vechi ale acestui atribut sunt afișate în interfețe (de exemplu, pentru instanțe de proces existente). Dacă doriți să vă asigurați că valorile vechi sunt accesibile, creați un nou atribut de tipul dorit și mapați noul atribut într-un câmp nou. "
    },
    gdmIntegration: {
        addNewIntegration: "Creează",
        integrations: "conexiune de date | conexiuni de date",
        title: "Conexiuni de date Legacy",
        createNewIntegration: "Creează o nouă conexiune la baze de date",
        DBIntegration: "Detaliile conexiunii",
        connection: "Detaliile bazei de date",
        type: "Tip de conector",
        DB: "Bază de date",
        host: "Host/IP",
        port: "Port",
        username: "Numele utilizatorului",
        role: "Rol",
        password: "Parolă",
        connectionSucces: "Conexiune reușită",
        connectionError: "Nu s-a putut conecta",
        testConnectionBtn: "Testează conexiunea",
        testAgainConnectionBtn: "Testează din nou",
        host2: "Gazdă",
        database: "Bază de date",
        pending: "In asteptare",
        connected: "Conectat",
        error: "Eroare",
        status: "Stare",
        editIntegration: "Editați conexiunea",
        changeCredentials: "Schimbați Credențialele",
        dbUnreachable: "Tabela de date nu poate accesa baza de date sursă",
        externalNotPublished: "Tabela de date nu este incă publicată.",
        theEntity: "Tabela de date",
        listUpdated: "Lista de tabele de date a fost actualizată.",
        noConnection: "Fără conexiune",
        checkIntegration: "Verificați conexiunea",
        deleteTitle: "Ștergeți conexiunea",
        deleteMsg: "Ștergerea conexiunii o va elimina din pagina de 'Conexiuni la baze de date'.",
        columnAdded: "Atribut nou adăugat in sursă",
        columnRemoved: "Acest atribut a fost șters din sursă"
    },
    helpCenter: {
        title: "Help center",
        tooltipTitle: "Help center",
        ourResources: "Resursele noastre",
        recommendedArticles: "Articole recomandate",
        allArticles: "Toate articolele",
        academy: "Academie"
    },
    capturePhotoVideo: {
        startBtnVideo: "Începe înregistrarea",
        cancelBtnVideo: "Anulează înregistrarea",
        stopBtnVideo: "Opreste înregistrarea",
        capture: "Faceți fotografia",
        cancel: "Anulare",
        doneBtn: "Terminat",
        timer: "secunde rămase...",
        seconds: "secunde",
        captured: " Captură fotografie",
        capturedVideo: "Captură videoclip",
        resetBtn: "Refaceți",
        photoModal: "Captură Fotografie",
        videoModal: "Captură Video",
        messageDialog: "Inregistrarea nu va fi salvată. Sunteți sigur că doriți să continuați?",
        titleDialog: "Confirmare",
        submitCurrent: "Finalizează"
    },
    perspectiveBuilder: {
        savePerspective: "Vizualizarea de date a fost creată cu succes. | Vizualizarea de date a fost salvată cu succes",
        errorPerspective: "A apărut o eroare la salvarea vizualizarii de date.",
        noPerspective: "Selectați sau creați o vizualizarea de date nouă",
        noPerspectiveDesc: "Alegeți următoarea acțiune în funcție de nevoile dumneavoastră.",
        noDisplay: "Nimic de afișat",
        noPersDescription: "Nu există încă o vizualizarea de date creată",
        dialogTitle: "Avertizare",
        dialogMessage: "Există modificări nesalvate care vor fi pierdute",
        deleteTitleDialog: "Ștergeți vizualizarea de date",
        deleteMessageDialog: "Ștergând această vizualizare de date, ea va fi eliminată definitiv atât din lista de vizualizari cât și din lista de permisiuni",
        infoDeleteTooltip: "Pentru a putea șterge vizualizarea de date trebuie mai întâi să eliminați drepturile utilizatorilor și grupurilor din permisiunea aferentă",
        infoDeleteToast: "a fost ștearsă cu succes",
        duplicate: "Duplicare",
        copy: "copie",
        duplicateTitle: "Duplicare vizualizare de date",
        duplicateMessage: "Duplicând vizualizarea de date “{count}“ vei continua cu versiunea duplicată",
        delete: "Ștergere",
        tableInfo: "Acest tabel este populat cu date fictive. Datele reale vor fi disponibile în utilizare.",
        leftSideBar: {
            title: "Constructor de vizualizări de date",
            titleBtn: "Creează",
            defaultPerspective: "Vizualizare de date implicită",
            noPerspectiveFound: "Nu a fost găsit niciun rezultat",
            noPerspectiveYet: "Nu există încă vizualizari de date disponibile",
            perspective: "Vizualizare de date"
        },
        rightSideBar: {
            setupTitle: "Configurarea vizualizării",
            name: "Nume",
            showDiagram: "Arată diagrama procesului",
            customInterface: "Adăugați o interfață utilizator",
            invalidName: "Numele poate conține doar litere, cifre, spații și subliniere",
            tabSetup: "Pagină",
            tabFilters: "Filtre",
            tabTable: "Setările tabelului",
            showOnTasks: "Afișează și pe task-uri",
            searchArea: "Afișarea zonei de căutare",
            searchCollapse: "Restrâns",
            searchExpanded: "Expandat",
            tableState: "Afișarea zonei tabelare",
            tableFullscreen: "Expandat total",
            tablePreview: "Previzualizare",
            tableCollapsed: "Restrâns",
            configFilters: "Configurați filtre",
            modelOption: "Model de date",
            saveFiltersOption: "Salvarea filtrelor",
            lockOperator: "Blochează operator",
            advancedBtn: "Setări avansate",
            noActivities: "Nu există activități disponibile",
            addDataModel: "Adăugati filtre din modelul de date",
            addAdvancedFilters: "Configurare avansată a filtrelor",
            availableFilters: "Filtre disponibile",
            invisibleToUser: "Ascuns utilizatorului final",
            modelTitleContainer: "Clasele modelului de date",
            advancedInfoTooltip: "Prepopulează filtre cu valori și configurează comportamente specifice pentru filtrele disponibile",
            noFiltersSelected: "Cel puțin un filtru trebuie să fie vizibil pentru a putea utiliza această opțiune",
            emptyName: "Numele vizualizarii de date este obligatoriu",
            duplicateName: "Numele trebuie să fie unic",
            infoFiltersTab: "Selectați filtrele disponibile pentru a fi utilizate",
            infoInterfaceBox: "Afișați o interfață utilizator specifică pentru instanțele de proces.",
            process: "Proces",
            noProcess: "Nu exista procese disponibile",
            settings: "Setări",
            searchFilters: "Căutare & Filtre",
            tableConfig: "Configurare Tabel"
        },
        tabTable: {
            tableLayout: "Dispunerea tabelului",
            tasks: "Task-uri",
            cases: "Instanțe de proces",
            columnSorting: "Sortarea coloanelor",
            columnSettings: "Setările coloanelor",
            settingsAddModel: "Adăugați atribute suplimentare din modelul de date",
            dataExport: "Exportul de date",
            tabTasks: "Tab task-uri",
            dataModel: "Modelul de date",
            // tabCases: "Cases tab",
            tabCases: "Tab instanțe de proces",
            tabsTooltip: "Trebuie selectat cel putin un tab",
            oneColSelected: "Cel putin o coloana trebuie sa fie selectata"
        }
     },
    searchPerspectives: {
        title: "Vizulizări de date",
        defaultStateTile: "Selectați o vizualizare de date pentru a continua",
        defaultStateDescription: "Aici puteți accesa vizualizarile de date",
        noProcessTitle: "Vizualizarea de date nu a putut fi încărcată. | Daca problema persista, contactați administratorul de aplicatie.",
        noProcessDesc: "Dacă problema persistă, contactați un administrator.",
        loadFilterError: "Filtrul nu poate fi aplicat. Unele atribute/valori nu mai sunt disponibile. Actualizați pagina pentru a vedea ultima versiune.",
        sortSettingsError: "Acțiunea nu poate fi realizată. Actualizați pagina pentru a continua",
        goToSearchRedirect: "Accesați lista de vizualizari de date",
        tryAgain: "Incearcă din nou"
    },
    blockchainBuilder: {
        title: "Mapare contract inteligent",
        selectSC: "Selecteaza contractul inteligent",
        settings:"Setări",
        address: "Adresa contractului*",
        bcAddress: "Adresa de retea a BC*",
        chainId: "Chain ID",
        method:"Metoda",
        mapping: "Mapare",
        request: "Request",
        noResult: "Nici un rezultat",
        response: "Response",
        noMethod: "Vă rugăm să selectați mai întâi Metoda...",
        save:"Salvare",
        delete:"Stergere",
        script:"script",
        req: "1 parametru de cerere",
        resp: "1 parametru de raspuns",
        reqParams: "parametri de solicitare",
        resParams: "atribute de răspuns",
        noMap: "fără mapări",
        allMap: "toți parametrii mapați",
        param: "parametru",
        params: "parametrii",
        mapped: "mapat",
        selectInterface: "Selectați componenta din interfața utilizator",
        error: "Nu poate fi gol",
        succes: "Contractul inteligent a fost mapat cu succes!",
        deleteSucces: "Maparea contractului inteligent a fost ștearsă cu succes!",
        uploadTitle: "Încărcați ABI-ul contractului inteligent"
    },
    dialogComponent: {
        exportBtn: "Exportați date"
    },
    defaultState: {
        title: "Nimic de afișat",
        description: "Nu există încă elemente create",
        createButton: "Creează",
        createApp: "Nu a fost creată nicio aplicație",
        createAppView: "Nu a fost creată nicio aplicație",
        createPlugin: "Nu a fost importat nici un plugin ",
        import: "Import",
        descriptionPlugin: "Importă primul tău plugin si bucurate de Aurachain. Integrează instrumentele tale pentru aplicatii mai complexe",
        descriptionApp: "Aici puteți crea aplicații, împreună cu elementele de suport: interfețe utilizator, șabloane de documente, API-uri, modele de date și așa mai departe.",
        descriptionAppView: "Aplicațiile disponibile pentru dvs. vor fi afișate aici.",
        createEntity: "Nu a fost creată nicio tabelă de date",
        descriptionEntity: "Aici puteți crea tabele de date pentru a stoca și a citi date globale care pot fi accesate intre aplicații.",
        createIntegration: "Nu a fost creată nicio conexiune la baze de date",
        descriptionIntegration: "Aici puteți conecta platforma la sistemele existente, folosind conectori predefiniți de tip SQL Server, Oracle sau MySQL etc.<br><br>Odată ce conexiunea este disponibilă, aceasta poate fi folosită ca sursă a tabelelor de date pentru a accesa datele intre aplicații.",
        noTasks: "Nu aveți încă task-uri",
        noTasksDescription: "Task-urile disponibile pentru dvs. vor fi afișate aici.",
        noTeamTasks: "Echipa dvs. nu are încă niciun task",
        noTeamTasksDescription: "Task-urile disponibile echipei dvs. vor fi afișate aici.",
        createProcess: "Nu a fost creat încă niciun proces",
        createProcessView: "Nu a fost creat încă niciun proces",
        createProcessDescription: "Aici puteți crea vizual procese de business utilizând un editor simplificat care permite: configurarea task-urilor, regulilor, fluxuri, participanților, aprobărilor, notificărilor si toată logica de business.",
        createProcessDescriptionView: "Procesele disponibile pentru dvs. vor fi afișate aici.",
        createSC: "Nu a fost importat încă niciun descriptor de contract inteligent",
        createSCView: "Nu a fost importat încă niciun descriptor de contract inteligent",
        createSCDescription: "Aici puteți importa descriptori de contracte inteligente pentru a activa capabilitațile blockchain în aplicația dvs. Odată adăugat, poate fi folosit pentru a citi și stoca date in blockchain.",
        createSCDescriptionView: "Contractele inteligente disponibile pentru dvs. vor fi afișate aici.",
        createInterface: "Nu a fost creată nicio interfață utilizator",
        createInterfaceDescription: "Interfețele utilizator sunt o serie de pagini și elemente vizuale, cum ar fi butoanele și pictogramele, care permit utilizatorului de business să interacționeze cu aplicația.",
        createInterfaceDescriptionView: "Interfețele utilizator disponibile pentru dvs. vor fi afișate aici.",
        createDocument: "Nu a fost creat încă niciun șablon de document",
        createDocumentView: "Nu a fost creat încă niciun șablon de document",
        createDocumentDescription: "Aici puteți proiecta și genera șabloane de documente utilizând conținutul dinamic din datele aplicației.<br><br>Șabloanele sunt folosite pentru a genera documente la nivel de proces și de interfață utilizator.",
        createDocumentDescriptionView: "Template-urile de documente disponibile pentru dvs. vor fi afișate aici.",
        internalApis: "Nu este disponibil niciun API de sistem",
        internalApisDescription: "API-urile de sistem disponibile pentru dvs. vor fi afisate aici.",
        consumedApis: "Nicun API extern nu a fost adăugat",
        consumedApisView: "Nicun API extern nu a fost adăugat",
        consumedApisDescription: "Aici puteți integra sisteme externe cu aplicația, folosind servicii web.<br><br>Odată adăugat API-ul, acesta poate fi accesat din procese și din interfețele utilizator.",
        consumedApisDescriptionView: "API-urile externe disponibile pentru dvs. vor fi afișate aici.",
        exposedApis: "Nu au fost create credențiale pentru API-uri expuse",
        exposedApisView: "Nu au fost create credențiale pentru API-uri expuse",
        exposedApisDescription: "Aici puteți crea credențiale pe care le puteți utiliza pentru a autoriza accesul clientului la un API expus, odată ce acesta este creat în procesele aplicației.",
        exposedApisDescriptionView: "Credențialele API-urilor expuse disponibile pentru dvs. vor fi afișate aici.",
        createDM: "Nu a fost încă creat data model",
        createDMView: "Nu a fost încă creat data model",
        createDMDescription: "Modelul de date de proces definește modul în care datele vor fi stocate, organizate și clasificate odată ce un proces este început.<br><br>Creați clase și atributele acestora și utilizați modelul de date pentru a accesa și gestiona date din diferite zone ale aplicației, cum ar fi Interfețele utilizator, Procese, Analitice și așa mai departe.",
        createDMDescriptionView: "Clasele și atributele data modelului vor fi afișate aici.",
        createCatalog: "Nu a fost creat nicun catalog",
        createCatalogView: "Nu a fost creat nicun catalog",
        createCatalogDescription: "Aici puteți crea liste cu valori predefinite.<br><br>Odată ce un catalog este definit, utilizați-l în interfețele utilizator pentru a completa listele de selecție cu valorile din acesta.",
        createCatalogDescriptionView: "Cataloagele disponibile pentru dvs. vor fi afișate aici.",
        createPerspective: "Nu a fost creată nicio vizualizare de date",
        createPerspectiveView: "Nu a fost creată nicio vizualizare de date",
        createPerspectiveDescription: "Aici puteți crea vizualizări de date personalizate, adaptate nevoilor specifice fiecărui profil de utilizator.<br><br>Odată ce o vizualizare de date personalizată este definită, utilizatorii de business o pot accesa conform permisiunilor configurate.",
        createPerspectiveDescriptionView: "Vizualizările de date disponibile pentru dvs. vor fi afișate aici.",
        noPerspective: "Nu aveți nicio vizualizare de date disponibilă",
        noPerspectiveView: "Nu aveți nicio vizualizare de date disponibilă",
        noPerspectiveDescription: "Aici puteți accesa vizualizări de date personalizate pentru datele de proces.",
        noStatistics: "Nu sunt disponibile date de proces",
        noStatisticsView: "Nu sunt disponibile date de proces",
        noStatisticsDescription: "Procesele disponibile pentru dvs. vor fi afișate aici.",
        noStatisticsDescriptionView: "Procesele disponibile pentru dvs. vor fi afișate aici.",
        noProcessData: "Nu sunt disponibile date de proces",
        noProcessDataView: "Nu sunt disponibile date de proces",
        noProcessDataDescription: "Procesele disponibile pentru dvs. vor fi afișate aici.",
        noProcessDataDescriptionView: "Procesele disponibile pentru dvs. vor fi afișate aici.",
        acessDenied: "Acces restricționat",
        acessDeniedDescription: "Ne pare rău...<br> Pagina pe care încerci să o accesezi are acces restricționat.<br> Te rugăm să consulți administratorul de sistem.",
        blockchainEmptyWallet: "Creează un portofel Blockchain",
        blockchainEmptyWalletView: "Portofele Blockchain",
        blockchainEmptyWalletDescription: "Un portofel de tip Blockchain este folosit la semnarea unor contracte inteligente în activitățile care îl necesită.<br> Aici puteți găsi portofelele salvate și puteți importa portofele pentru utilizarea ulterioară.",
        toDashboard: "Mergi în panoul de bord",
        maintenanceTitle: "Suntem în mentenanță",
        maintenanceDescription: "Momentan platforma este în mentenanță. Reîncarcă pagina sau contactează administratorul.",
        pageNotFoundTitle: "Pagina nu a fost găsită",
        pageNotFoundDescription: "Pagina pe care încercați sa o accesați nu a fost găsită.<br> Verificați din nou linkul sau contactați un administrator.",
        authenticationTitle: "Nu s-a configurat încă o conectare Single Sign-on",
        authenticationDescription: "Configurați Single Sign-on pentru a permite utilizatorilor să se conecteze folosind un furnizor de identitate extern SAML sau OpenID Connect."
    },
    wallet: {
        wallet: "portofel",
        dashboard: {
            iconAlt: "Icon Niciun portofel încărcat încă",
            noWallets: "Niciun portofel încărcat încă",
            noWalletsInfo: "Portofelele create sau importate vor fi vizibile aici",
            notifyMessage: "Tranzacția este in progres",
            captionMessage: "Așteptați ca acțiunea să fie finalizată."
        },
        title: {
            create: "Creeare portofel",
            import: "Import portofel",
            sign: "Alege contul blockchain",
            edit: "Edit wallet",
        },
        subtitle: {
            settings: 'Setări',
            wallets: 'Portofele'
        },
        heading: {
            savedWallets: 'Saved wallets',
            otherWallets: 'Other wallets'
        },
        button: {
            import: "Importă",
            create: "Creează unul nou",
            save: "Salvează",
            initialize: "Inițializează",
            initializeAnother: "Inițializează un alt portofel HD",
            differentPrivateKey: "Folosește o altă cheie privată",
            differentKeystore: "Folosește un alt fișier keystore",
            done: "Finalizează",
            validate: "Validează"
        },
        cta: {
            create: "Creează",
            import: "Importă",
            sign: "Semnează",
            edit: "Done"
        },
        accountDefaultName: "Cont",
        saveForLater: "Salvează portofel pentru utilizare ulterioară",
        label: {
            name: "Nume",
            password: "Parolă",
            confirmPassword: "Confirmă parola",
            type: "Tip",
            passphrase: "Frază secretă de recuperare",
            confirmPassphrase: "Reintrodu frază de recuperare",
            optional: "Opțional",
            bip39passphrase: "Frază BIP39",
            address: "address"
        },
        error: {
            missingPassword: "Alege parolă portofel",
            passwordsNotMatching: "Parolele nu se potrivesc",
            passphraseNotMatching: "Frazele de recuperare nu se potrivesc",
            passwordRequirements: "Parola trebuie să conțină minim 8 caractere, dintre care 1 cu literă mare, 1 cu literă mica și 1 cifră",
            unknownError: "Eroare necunoscută. Ajută-ne să-ți îmbunătățim experiența trimițându-ne un mesaj cu problema întâmpinată.",
            invalidMnemonic: "Invalid mnemonic",
            invalidPrivateKey: "Invalid private key",
            keystorePassword: "Invalid password",
            invalidKeystore: "Invalid keystore"
        },
        passphraseInfo: "Fraza ta secretă de recuperare este singura cale pentru a copia portofelul sau al reimporta. \n "
            + "Fii sigur ca ai pastrat fraza secretă de recuperare intr-un loc sigur înainte de a continua. \n"
            + "Dacă îți pierzi fraza de recuperare vei pierde accesul la portofel pentru totdeauna. \n"
            + "Nu lăsa pe nimeni să îți cunoasca fraza secretă de recuperare. ",
        importOptions: {
            hd: "Portofel HD",
            privateKey: "Cheie privată",
            keystoreFile: "Fișier keystore",
            wallet: "Portofel"
        },
        createSuccess: "Portofelul a fost creat cu success!",
        signSuccess: "Transacție reușită!",
        callSuccess: "Apel reușit!",
        signFail: "Transacție eșuată!",
        callFail: "Apel eșuat!",
        generateAccount: "Creează cont nou",
        saveMethod: {
            local: "Save on this device only",
            cloud: "Save on cloud (Available to use on all your devices)"
        },
        storageType: {
            device: "Disk",
            cloud: "Cloud"
        },
        successDelete: "Portofelul a fost șters cu success!",
        deleteWalletTitle: "Ștergere portofel",
        deleteWalletText: "Sunteți sigur că vreți să ștergeți {walletName}?"
    },
    licenses: {
        title: "Licențe software",
        viewDetails: "Vizualizați detalii",
        libraryDetails: "Detaliie bibliotecii software",
        dialogMessage: "Puteți vedea mai multe detalii despre bibilotecă pe adresa furnizată de dezvoltatorul acesteia:",
        externalSite: "Continuați pe un site extern"
    },
    columnProps: {
        hint: "Accesibil când atributul mapat este de tip numeric sau string.",
        label: "Format",
        decimal: "Separator zecimale",
        thousands: "Separator mii"
    },
    btnListComponents: {
        edit: "Editare",
        delete: "Ștergere",
        copy: "Copiere",
        more: "Mai mult",
        download: "Descărcare"

    },
    versioning: {
        by: "de",
        at: "la",
        published: "Publicat",
        restore: "Restaurează",
        addNote: "Adăugați o notă",
        editNote: "Editați nota",
        deleteNote: "Ștergeți nota",
        createNote: "Creați",
        updateNote: "Actualizați",
        noteTooltip:"Notă",
        deleteNoteBtn: "Ștergeți",
        dialogTitleCreate: "Creează notă pentru {date}",
        dialogTitleEdit: "Editează nota pentru {date}",
        descriptionDeleteNote: "Sigur dorești să ștergi permanent nota pentru {date}?" ,
        recover: "Recuperați",
        edited: "modificat",
        restored: "restaurat",
        recovered: "recuperat",
        deleted: "șters",
        renamedTo: "redenumit în",
        imported: "importat",
        created: "creat",
        nothingToDisplay: "Nimic de afișat",
        noModuleActivity: "Nu există încă nicio activitate în acest modul",
        noSectionActivity: "Nu există încă nicio activitate în această sectiune",
        edits: "modificări",
        saveHModalTitle: "Istoric salvări",
        changeHModalTitle: "Istoric schimbări",
        containsPublishPoints: " | Conține {count} punct de publicare | Conține {count} puncte de publicare",
        showOlderSaves: "Arată salvări mai vechi" ,
        showOlderChanges: "Arată schimbări mai vechi",
        saveNote: "Nota a fost adăugată cu succes",
        updateNoteDialog: "Nota a fost actualizată cu succes",
        previewToastTitle: "Salvare din",
        previewToastText: "Previzualizezi o salvare mai veche. Pentru a efectua schimbări, restaurează această salvare.",
        close: "Închide",
        interfaceRecovered: "Interfața/fragmentul a fost recuperat(ă).",
        interfaceAlreadyRecovered: "Interfața/fragmentul a fost deja recuperat(ă).",
        interfaceNotFound: "Interfața/fragmentul nu a fost gasit(ă).",
        interfaceNotDeleteEvent: "Acțiunea de recuperare e posibilă doar pe evenimentul de ștergere.",
        documentRecovered: "Documentul a fost recuperat cu succes.",
        documentAlreadyRecovered: "Documentul a fost deja recuperat.",
        documentNotFound: "Documentul nu a fost găsit.",
        catalogRecovered: "Catalogul a fost recuperat.",
        catalogAlreadyRecovered: "Catalogul a fost deja recuperat.",
        catalogNotFound: "Catalogul nu a fost găsit.",
        apiRecovered: "API-ul extern a fost recuperat.",
        apiAlreadyRecovered: "API-ul extern a fost deja recuperat.",
        apiNotFound: "API-ul extern nu a fost găsit.",
        processRecovered: "Procesul a fost recuperat cu succes.",
        processAlreadyRecovered: "Procesul a fost deja recuperat.",
        processNotFound: "Procesul nu a fost găsit.",
        restoreSave: "Restaurați această salvare",
        restoreDialogTitle: "Restaurează o salvare precedentă",
        restoreDialogInfo: "Această acțiune va întoarce {interfaceName} la starea sa din {date}.",
        restoreDialogInfoDM: "Această acțiune va întoarce modelul de date la starea sa din {date}.",
        restoreDialogInfoCat: "Această acțiune va întoarce catalogul la starea sa din {date}.",
        confirmRestoreNotify: "Restaurarea a fost facută cu succes",
        emptyNameNotif: "Numele nu poate fi gol",
        renameInfo: "Click pe titlul paginii din partea stânga sus pentru a redenumi Interfața",
        noPublishWhilePreview: "Nu puteți publica în timpul previzualizării",
        filters: "Filtre",
        eventType: "Tip eveniment",
        user: "Utilizator"
    },
    startFromEmail: {
        emailConfig: "Configurare e-mail",
        emailContent: "Conținut e-mail ",
        config: "Configurare",
        protocol: "Tip server",
        host: "Adresă server",
        port: "Port",
        encryption: "Criptare",
        username: "Nume de utilizator",
        password: "Parolă",
        content: "Conținut",
        subject: "Subiect",
        from: "Expeditor",
        to: "Destinatar",
        cc: "CC",
        bcc: "BCC",
        body: "Corp",
        configured: "Configurat"
    },
    plugins: {
        title: "Plugin | Plugins",
        importPlugin: "Import plugin",
        importBtn: "Import plugin | Import",
        importTitle: "Încărcați fișierul",
        successNotif: "Pluginul a fost importat cu succes.",
        errorNotif: "Nu s-a putut importa pluginul!"
    }
};
